// This file is auto-generated by @hey-api/openapi-ts

/**
 * Deprecated: Unused property
 */
export enum MenuType {
    TILES = 'TILES',
    LIST = 'LIST'
}

export enum Icon {
    _360 = '360',
    _10K = '10k',
    _10MP = '10mp',
    _11MP = '11mp',
    _12MP = '12mp',
    _13MP = '13mp',
    _14MP = '14mp',
    _15MP = '15mp',
    _16MP = '16mp',
    _17MP = '17mp',
    _18MP = '18mp',
    _19MP = '19mp',
    _1K = '1k',
    _1K_PLUS = '1k-plus',
    _20MP = '20mp',
    _21MP = '21mp',
    _22MP = '22mp',
    _23MP = '23mp',
    _24MP = '24mp',
    _2K = '2k',
    _2K_PLUS = '2k-plus',
    _2MP = '2mp',
    _3D_ROTATION = '3d-rotation',
    _3K = '3k',
    _3K_PLUS = '3k-plus',
    _3MP = '3mp',
    _4K = '4k',
    _4K_PLUS = '4k-plus',
    _4MP = '4mp',
    _5G = '5g',
    _5K = '5k',
    _5K_PLUS = '5k-plus',
    _5MP = '5mp',
    _6_FT_APART = '6-ft-apart',
    _6K = '6k',
    _6K_PLUS = '6k-plus',
    _6MP = '6mp',
    _7K = '7k',
    _7K_PLUS = '7k-plus',
    _7MP = '7mp',
    _8K = '8k',
    _8K_PLUS = '8k-plus',
    _8MP = '8mp',
    _9K = '9k',
    _9K_PLUS = '9k-plus',
    _9MP = '9mp',
    AC_UNIT = 'ac-unit',
    ACCESS_ALARM = 'access-alarm',
    ACCESS_ALARMS = 'access-alarms',
    ACCESS_TIME = 'access-time',
    ACCESSIBILITY = 'accessibility',
    ACCESSIBILITY_NEW = 'accessibility-new',
    ACCESSIBLE = 'accessible',
    ACCESSIBLE_FORWARD = 'accessible-forward',
    ACCOUNT_BALANCE = 'account-balance',
    ACCOUNT_BALANCE_WALLET = 'account-balance-wallet',
    ACCOUNT_BOX = 'account-box',
    ACCOUNT_CIRCLE = 'account-circle',
    ACCOUNT_TREE = 'account-tree',
    AD_UNITS = 'ad-units',
    ADB = 'adb',
    ADD = 'add',
    ADD_A_PHOTO = 'add-a-photo',
    ADD_ALARM = 'add-alarm',
    ADD_ALERT = 'add-alert',
    ADD_BOX = 'add-box',
    ADD_BUSINESS = 'add-business',
    ADD_CALL = 'add-call',
    ADD_CHART = 'add-chart',
    ADD_CIRCLE = 'add-circle',
    ADD_CIRCLE_OUTLINE = 'add-circle-outline',
    ADD_COMMENT = 'add-comment',
    ADD_IC_CALL = 'add-ic-call',
    ADD_LINK = 'add-link',
    ADD_LOCATION = 'add-location',
    ADD_LOCATION_ALT = 'add-location-alt',
    ADD_MODERATOR = 'add-moderator',
    ADD_PHOTO_ALTERNATE = 'add-photo-alternate',
    ADD_ROAD = 'add-road',
    ADD_SHOPPING_CART = 'add-shopping-cart',
    ADD_TASK = 'add-task',
    ADD_TO_DRIVE = 'add-to-drive',
    ADD_TO_HOME_SCREEN = 'add-to-home-screen',
    ADD_TO_PHOTOS = 'add-to-photos',
    ADD_TO_QUEUE = 'add-to-queue',
    ADDCHART = 'addchart',
    ADJUST = 'adjust',
    ADMIN_PANEL_SETTINGS = 'admin-panel-settings',
    AGRICULTURE = 'agriculture',
    AIRLINE_SEAT_FLAT = 'airline-seat-flat',
    AIRLINE_SEAT_FLAT_ANGLED = 'airline-seat-flat-angled',
    AIRLINE_SEAT_INDIVIDUAL_SUITE = 'airline-seat-individual-suite',
    AIRLINE_SEAT_LEGROOM_EXTRA = 'airline-seat-legroom-extra',
    AIRLINE_SEAT_LEGROOM_NORMAL = 'airline-seat-legroom-normal',
    AIRLINE_SEAT_LEGROOM_REDUCED = 'airline-seat-legroom-reduced',
    AIRLINE_SEAT_RECLINE_EXTRA = 'airline-seat-recline-extra',
    AIRLINE_SEAT_RECLINE_NORMAL = 'airline-seat-recline-normal',
    AIRPLANEMODE_ACTIVE = 'airplanemode-active',
    AIRPLANEMODE_INACTIVE = 'airplanemode-inactive',
    AIRPLANEMODE_OFF = 'airplanemode-off',
    AIRPLANEMODE_ON = 'airplanemode-on',
    AIRPLAY = 'airplay',
    AIRPORT_SHUTTLE = 'airport-shuttle',
    ALARM = 'alarm',
    ALARM_ADD = 'alarm-add',
    ALARM_OFF = 'alarm-off',
    ALARM_ON = 'alarm-on',
    ALBUM = 'album',
    ALIGN_HORIZONTAL_CENTER = 'align-horizontal-center',
    ALIGN_HORIZONTAL_LEFT = 'align-horizontal-left',
    ALIGN_HORIZONTAL_RIGHT = 'align-horizontal-right',
    ALIGN_VERTICAL_BOTTOM = 'align-vertical-bottom',
    ALIGN_VERTICAL_CENTER = 'align-vertical-center',
    ALIGN_VERTICAL_TOP = 'align-vertical-top',
    ALL_INBOX = 'all-inbox',
    ALL_INCLUSIVE = 'all-inclusive',
    ALL_OUT = 'all-out',
    ALT_ROUTE = 'alt-route',
    ALTERNATE_EMAIL = 'alternate-email',
    AMP_STORIES = 'amp-stories',
    ANALYTICS = 'analytics',
    ANCHOR = 'anchor',
    ANDROID = 'android',
    ANIMATION = 'animation',
    ANNOUNCEMENT = 'announcement',
    APARTMENT = 'apartment',
    API = 'api',
    APP_BLOCKING = 'app-blocking',
    APP_REGISTRATION = 'app-registration',
    APP_SETTINGS_ALT = 'app-settings-alt',
    APPROVAL = 'approval',
    APPS = 'apps',
    ARCHITECTURE = 'architecture',
    ARCHIVE = 'archive',
    ARROW_BACK = 'arrow-back',
    ARROW_BACK_IOS = 'arrow-back-ios',
    ARROW_CIRCLE_DOWN = 'arrow-circle-down',
    ARROW_CIRCLE_UP = 'arrow-circle-up',
    ARROW_DOWNWARD = 'arrow-downward',
    ARROW_DROP_DOWN = 'arrow-drop-down',
    ARROW_DROP_DOWN_CIRCLE = 'arrow-drop-down-circle',
    ARROW_DROP_UP = 'arrow-drop-up',
    ARROW_FORWARD = 'arrow-forward',
    ARROW_FORWARD_IOS = 'arrow-forward-ios',
    ARROW_LEFT = 'arrow-left',
    ARROW_RIGHT = 'arrow-right',
    ARROW_RIGHT_ALT = 'arrow-right-alt',
    ARROW_UPWARD = 'arrow-upward',
    ART_TRACK = 'art-track',
    ARTICLE = 'article',
    ASPECT_RATIO = 'aspect-ratio',
    ASSESSMENT = 'assessment',
    ASSIGNMENT = 'assignment',
    ASSIGNMENT_IND = 'assignment-ind',
    ASSIGNMENT_LATE = 'assignment-late',
    ASSIGNMENT_RETURN = 'assignment-return',
    ASSIGNMENT_RETURNED = 'assignment-returned',
    ASSIGNMENT_TURNED_IN = 'assignment-turned-in',
    ASSISTANT = 'assistant',
    ASSISTANT_DIRECTION = 'assistant-direction',
    ASSISTANT_NAVIGATION = 'assistant-navigation',
    ASSISTANT_PHOTO = 'assistant-photo',
    ATM = 'atm',
    ATTACH_EMAIL = 'attach-email',
    ATTACH_FILE = 'attach-file',
    ATTACH_MONEY = 'attach-money',
    ATTACHMENT = 'attachment',
    ATTRACTIONS = 'attractions',
    AUDIOTRACK = 'audiotrack',
    AUTO_AWESOME = 'auto-awesome',
    AUTO_AWESOME_MOSAIC = 'auto-awesome-mosaic',
    AUTO_AWESOME_MOTION = 'auto-awesome-motion',
    AUTO_DELETE = 'auto-delete',
    AUTO_FIX_HIGH = 'auto-fix-high',
    AUTO_FIX_NORMAL = 'auto-fix-normal',
    AUTO_FIX_OFF = 'auto-fix-off',
    AUTO_STORIES = 'auto-stories',
    AUTORENEW = 'autorenew',
    AV_TIMER = 'av-timer',
    BABY_CHANGING_STATION = 'baby-changing-station',
    BACKPACK = 'backpack',
    BACKSPACE = 'backspace',
    BACKUP = 'backup',
    BACKUP_TABLE = 'backup-table',
    BADGE = 'badge',
    BAKERY_DINING = 'bakery-dining',
    BALLOT = 'ballot',
    BAR_CHART = 'bar-chart',
    BATCH_PREDICTION = 'batch-prediction',
    BATHTUB = 'bathtub',
    BATTERY_ALERT = 'battery-alert',
    BATTERY_CHARGING_FULL = 'battery-charging-full',
    BATTERY_FULL = 'battery-full',
    BATTERY_STD = 'battery-std',
    BATTERY_UNKNOWN = 'battery-unknown',
    BEACH_ACCESS = 'beach-access',
    BEDTIME = 'bedtime',
    BEENHERE = 'beenhere',
    BENTO = 'bento',
    BIKE_SCOOTER = 'bike-scooter',
    BIOTECH = 'biotech',
    BLOCK = 'block',
    BLOCK_FLIPPED = 'block-flipped',
    BLUETOOTH = 'bluetooth',
    BLUETOOTH_AUDIO = 'bluetooth-audio',
    BLUETOOTH_CONNECTED = 'bluetooth-connected',
    BLUETOOTH_DISABLED = 'bluetooth-disabled',
    BLUETOOTH_SEARCHING = 'bluetooth-searching',
    BLUR_CIRCULAR = 'blur-circular',
    BLUR_LINEAR = 'blur-linear',
    BLUR_OFF = 'blur-off',
    BLUR_ON = 'blur-on',
    BOLT = 'bolt',
    BOOK = 'book',
    BOOK_ONLINE = 'book-online',
    BOOKMARK = 'bookmark',
    BOOKMARK_BORDER = 'bookmark-border',
    BOOKMARK_OUTLINE = 'bookmark-outline',
    BOOKMARKS = 'bookmarks',
    BORDER_ALL = 'border-all',
    BORDER_BOTTOM = 'border-bottom',
    BORDER_CLEAR = 'border-clear',
    BORDER_COLOR = 'border-color',
    BORDER_HORIZONTAL = 'border-horizontal',
    BORDER_INNER = 'border-inner',
    BORDER_LEFT = 'border-left',
    BORDER_OUTER = 'border-outer',
    BORDER_RIGHT = 'border-right',
    BORDER_STYLE = 'border-style',
    BORDER_TOP = 'border-top',
    BORDER_VERTICAL = 'border-vertical',
    BRANDING_WATERMARK = 'branding-watermark',
    BREAKFAST_DINING = 'breakfast-dining',
    BRIGHTNESS_1 = 'brightness-1',
    BRIGHTNESS_2 = 'brightness-2',
    BRIGHTNESS_3 = 'brightness-3',
    BRIGHTNESS_4 = 'brightness-4',
    BRIGHTNESS_5 = 'brightness-5',
    BRIGHTNESS_6 = 'brightness-6',
    BRIGHTNESS_7 = 'brightness-7',
    BRIGHTNESS_AUTO = 'brightness-auto',
    BRIGHTNESS_HIGH = 'brightness-high',
    BRIGHTNESS_LOW = 'brightness-low',
    BRIGHTNESS_MEDIUM = 'brightness-medium',
    BROKEN_IMAGE = 'broken-image',
    BROWSER_NOT_SUPPORTED = 'browser-not-supported',
    BRUNCH_DINING = 'brunch-dining',
    BRUSH = 'brush',
    BUBBLE_CHART = 'bubble-chart',
    BUG_REPORT = 'bug-report',
    BUILD = 'build',
    BUILD_CIRCLE = 'build-circle',
    BURST_MODE = 'burst-mode',
    BUS_ALERT = 'bus-alert',
    BUSINESS = 'business',
    BUSINESS_CENTER = 'business-center',
    CACHED = 'cached',
    CAKE = 'cake',
    CALCULATE = 'calculate',
    CALENDAR_TODAY = 'calendar-today',
    CALENDAR_VIEW_DAY = 'calendar-view-day',
    CALL = 'call',
    CALL_END = 'call-end',
    CALL_MADE = 'call-made',
    CALL_MERGE = 'call-merge',
    CALL_MISSED = 'call-missed',
    CALL_MISSED_OUTGOING = 'call-missed-outgoing',
    CALL_RECEIVED = 'call-received',
    CALL_SPLIT = 'call-split',
    CALL_TO_ACTION = 'call-to-action',
    CAMERA = 'camera',
    CAMERA_ALT = 'camera-alt',
    CAMERA_ENHANCE = 'camera-enhance',
    CAMERA_FRONT = 'camera-front',
    CAMERA_REAR = 'camera-rear',
    CAMERA_ROLL = 'camera-roll',
    CAMPAIGN = 'campaign',
    CANCEL = 'cancel',
    CANCEL_PRESENTATION = 'cancel-presentation',
    CANCEL_SCHEDULE_SEND = 'cancel-schedule-send',
    CAR_RENTAL = 'car-rental',
    CAR_REPAIR = 'car-repair',
    CARD_GIFTCARD = 'card-giftcard',
    CARD_MEMBERSHIP = 'card-membership',
    CARD_TRAVEL = 'card-travel',
    CARPENTER = 'carpenter',
    CASES = 'cases',
    CASINO = 'casino',
    CAST = 'cast',
    CAST_CONNECTED = 'cast-connected',
    CAST_FOR_EDUCATION = 'cast-for-education',
    CATEGORY = 'category',
    CELEBRATION = 'celebration',
    CELL_WIFI = 'cell-wifi',
    CENTER_FOCUS_STRONG = 'center-focus-strong',
    CENTER_FOCUS_WEAK = 'center-focus-weak',
    CHANGE_HISTORY = 'change-history',
    CHARGING_STATION = 'charging-station',
    CHAT = 'chat',
    CHAT_BUBBLE = 'chat-bubble',
    CHAT_BUBBLE_OUTLINE = 'chat-bubble-outline',
    CHECK = 'check',
    CHECK_BOX = 'check-box',
    CHECK_BOX_OUTLINE_BLANK = 'check-box-outline-blank',
    CHECK_CIRCLE = 'check-circle',
    CHECK_CIRCLE_OUTLINE = 'check-circle-outline',
    CHECKROOM = 'checkroom',
    CHEVRON_LEFT = 'chevron-left',
    CHEVRON_RIGHT = 'chevron-right',
    CHILD_CARE = 'child-care',
    CHILD_FRIENDLY = 'child-friendly',
    CHROME_READER_MODE = 'chrome-reader-mode',
    CIRCLE = 'circle',
    CIRCLE_NOTIFICATIONS = 'circle-notifications',
    CLASS = 'class',
    CLEAN_HANDS = 'clean-hands',
    CLEANING_SERVICES = 'cleaning-services',
    CLEAR = 'clear',
    CLEAR_ALL = 'clear-all',
    CLOSE = 'close',
    CLOSE_FULLSCREEN = 'close-fullscreen',
    CLOSED_CAPTION = 'closed-caption',
    CLOSED_CAPTION_DISABLED = 'closed-caption-disabled',
    CLOSED_CAPTION_OFF = 'closed-caption-off',
    CLOUD = 'cloud',
    CLOUD_CIRCLE = 'cloud-circle',
    CLOUD_DONE = 'cloud-done',
    CLOUD_DOWNLOAD = 'cloud-download',
    CLOUD_OFF = 'cloud-off',
    CLOUD_QUEUE = 'cloud-queue',
    CLOUD_UPLOAD = 'cloud-upload',
    CODE = 'code',
    COLLECTIONS = 'collections',
    COLLECTIONS_BOOKMARK = 'collections-bookmark',
    COLOR_LENS = 'color-lens',
    COLORIZE = 'colorize',
    COMMENT = 'comment',
    COMMENT_BANK = 'comment-bank',
    COMMUTE = 'commute',
    COMPARE = 'compare',
    COMPARE_ARROWS = 'compare-arrows',
    COMPASS_CALIBRATION = 'compass-calibration',
    COMPRESS = 'compress',
    COMPUTER = 'computer',
    CONFIRMATION_NUM = 'confirmation-num',
    CONFIRMATION_NUMBER = 'confirmation-number',
    CONNECT_WITHOUT_CONTACT = 'connect-without-contact',
    CONNECTED_TV = 'connected-tv',
    CONSTRUCTION = 'construction',
    CONTACT_MAIL = 'contact-mail',
    CONTACT_PAGE = 'contact-page',
    CONTACT_PHONE = 'contact-phone',
    CONTACT_SUPPORT = 'contact-support',
    CONTACTLESS = 'contactless',
    CONTACTS = 'contacts',
    CONTENT_COPY = 'content-copy',
    CONTENT_CUT = 'content-cut',
    CONTENT_PASTE = 'content-paste',
    CONTROL_CAMERA = 'control-camera',
    CONTROL_POINT = 'control-point',
    CONTROL_POINT_DUPLICATE = 'control-point-duplicate',
    COPYRIGHT = 'copyright',
    CORONAVIRUS = 'coronavirus',
    CORPORATE_FARE = 'corporate-fare',
    COUNTERTOPS = 'countertops',
    CREATE = 'create',
    CREATE_NEW_FOLDER = 'create-new-folder',
    CREDIT_CARD = 'credit-card',
    CROP = 'crop',
    CROP_16_9 = 'crop-16-9',
    CROP_3_2 = 'crop-3-2',
    CROP_5_4 = 'crop-5-4',
    CROP_7_5 = 'crop-7-5',
    CROP_DIN = 'crop-din',
    CROP_FREE = 'crop-free',
    CROP_LANDSCAPE = 'crop-landscape',
    CROP_ORIGINAL = 'crop-original',
    CROP_PORTRAIT = 'crop-portrait',
    CROP_ROTATE = 'crop-rotate',
    CROP_SQUARE = 'crop-square',
    DANGEROUS = 'dangerous',
    DASHBOARD = 'dashboard',
    DASHBOARD_CUSTOMIZE = 'dashboard-customize',
    DATA_USAGE = 'data-usage',
    DATE_RANGE = 'date-range',
    DECK = 'deck',
    DEHAZE = 'dehaze',
    DELETE = 'delete',
    DELETE_FOREVER = 'delete-forever',
    DELETE_OUTLINE = 'delete-outline',
    DELETE_SWEEP = 'delete-sweep',
    DELIVERY_DINING = 'delivery-dining',
    DEPARTURE_BOARD = 'departure-board',
    DESCRIPTION = 'description',
    DESIGN_SERVICES = 'design-services',
    DESKTOP_ACCESS_DISABLED = 'desktop-access-disabled',
    DESKTOP_MAC = 'desktop-mac',
    DESKTOP_WINDOWS = 'desktop-windows',
    DETAILS = 'details',
    DEVELOPER_BOARD = 'developer-board',
    DEVELOPER_MODE = 'developer-mode',
    DEVICE_HUB = 'device-hub',
    DEVICE_THERMOSTAT = 'device-thermostat',
    DEVICE_UNKNOWN = 'device-unknown',
    DEVICES = 'devices',
    DEVICES_OTHER = 'devices-other',
    DIALER_SIP = 'dialer-sip',
    DIALPAD = 'dialpad',
    DINNER_DINING = 'dinner-dining',
    DIRECTIONS = 'directions',
    DIRECTIONS_BIKE = 'directions-bike',
    DIRECTIONS_BOAT = 'directions-boat',
    DIRECTIONS_BUS = 'directions-bus',
    DIRECTIONS_CAR = 'directions-car',
    DIRECTIONS_FERRY = 'directions-ferry',
    DIRECTIONS_OFF = 'directions-off',
    DIRECTIONS_RAILWAY = 'directions-railway',
    DIRECTIONS_RUN = 'directions-run',
    DIRECTIONS_SUBWAY = 'directions-subway',
    DIRECTIONS_TRAIN = 'directions-train',
    DIRECTIONS_TRANSIT = 'directions-transit',
    DIRECTIONS_WALK = 'directions-walk',
    DIRTY_LENS = 'dirty-lens',
    DISABLED_BY_DEFAULT = 'disabled-by-default',
    DISC_FULL = 'disc-full',
    DND_FORWARDSLASH = 'dnd-forwardslash',
    DNS = 'dns',
    DO_NOT_DISTURB = 'do-not-disturb',
    DO_NOT_DISTURB_ALT = 'do-not-disturb-alt',
    DO_NOT_DISTURB_OFF = 'do-not-disturb-off',
    DO_NOT_DISTURB_ON = 'do-not-disturb-on',
    DO_NOT_STEP = 'do-not-step',
    DO_NOT_TOUCH = 'do-not-touch',
    DOCK = 'dock',
    DOMAIN = 'domain',
    DOMAIN_DISABLED = 'domain-disabled',
    DOMAIN_VERIFICATION = 'domain-verification',
    DONE = 'done',
    DONE_ALL = 'done-all',
    DONE_OUTLINE = 'done-outline',
    DONUT_LARGE = 'donut-large',
    DONUT_SMALL = 'donut-small',
    DOUBLE_ARROW = 'double-arrow',
    DRAFTS = 'drafts',
    DRAG_HANDLE = 'drag-handle',
    DRAG_INDICATOR = 'drag-indicator',
    DRIVE_ETA = 'drive-eta',
    DRIVE_FILE_MOVE = 'drive-file-move',
    DRIVE_FILE_MOVE_OUTLINE = 'drive-file-move-outline',
    DRIVE_FILE_RENAME_OUTLINE = 'drive-file-rename-outline',
    DRIVE_FOLDER_UPLOAD = 'drive-folder-upload',
    DRY = 'dry',
    DRY_CLEANING = 'dry-cleaning',
    DUO = 'duo',
    DVR = 'dvr',
    DYNAMIC_FEED = 'dynamic-feed',
    DYNAMIC_FORM = 'dynamic-form',
    EAST = 'east',
    ECO = 'eco',
    EDIT = 'edit',
    EDIT_ATTRIBUTES = 'edit-attributes',
    EDIT_LOCATION = 'edit-location',
    EDIT_OFF = 'edit-off',
    EDIT_ROAD = 'edit-road',
    EJECT = 'eject',
    ELDERLY = 'elderly',
    ELECTRIC_BIKE = 'electric-bike',
    ELECTRIC_CAR = 'electric-car',
    ELECTRIC_MOPED = 'electric-moped',
    ELECTRIC_RICKSHAW = 'electric-rickshaw',
    ELECTRIC_SCOOTER = 'electric-scooter',
    ELECTRICAL_SERVICES = 'electrical-services',
    ELEVATOR = 'elevator',
    EMAIL = 'email',
    EMOJI_EMOTIONS = 'emoji-emotions',
    EMOJI_EVENTS = 'emoji-events',
    EMOJI_FLAGS = 'emoji-flags',
    EMOJI_FOOD_BEVERAGE = 'emoji-food-beverage',
    EMOJI_NATURE = 'emoji-nature',
    EMOJI_OBJECTS = 'emoji-objects',
    EMOJI_PEOPLE = 'emoji-people',
    EMOJI_SYMBOLS = 'emoji-symbols',
    EMOJI_TRANSPORTATION = 'emoji-transportation',
    ENGINEERING = 'engineering',
    ENHANCE_PHOTO_TRANSLATE = 'enhance-photo-translate',
    ENHANCED_ENCRYPTION = 'enhanced-encryption',
    EQUALIZER = 'equalizer',
    ERROR = 'error',
    ERROR_OUTLINE = 'error-outline',
    ESCALATOR = 'escalator',
    ESCALATOR_WARNING = 'escalator-warning',
    EURO = 'euro',
    EURO_SYMBOL = 'euro-symbol',
    EV_STATION = 'ev-station',
    EVENT = 'event',
    EVENT_AVAILABLE = 'event-available',
    EVENT_BUSY = 'event-busy',
    EVENT_NOTE = 'event-note',
    EVENT_SEAT = 'event-seat',
    EXIT_TO_APP = 'exit-to-app',
    EXPAND = 'expand',
    EXPAND_LESS = 'expand-less',
    EXPAND_MORE = 'expand-more',
    EXPLICIT = 'explicit',
    EXPLORE = 'explore',
    EXPLORE_OFF = 'explore-off',
    EXPOSURE = 'exposure',
    EXPOSURE_MINUS_1 = 'exposure-minus-1',
    EXPOSURE_MINUS_2 = 'exposure-minus-2',
    EXPOSURE_NEG_1 = 'exposure-neg-1',
    EXPOSURE_NEG_2 = 'exposure-neg-2',
    EXPOSURE_PLUS_1 = 'exposure-plus-1',
    EXPOSURE_PLUS_2 = 'exposure-plus-2',
    EXPOSURE_ZERO = 'exposure-zero',
    EXTENSION = 'extension',
    FACE = 'face',
    FACE_RETOUCHING_NATURAL = 'face-retouching-natural',
    FACEBOOK = 'facebook',
    FACT_CHECK = 'fact-check',
    FAMILY_RESTROOM = 'family-restroom',
    FAST_FORWARD = 'fast-forward',
    FAST_REWIND = 'fast-rewind',
    FASTFOOD = 'fastfood',
    FAVORITE = 'favorite',
    FAVORITE_BORDER = 'favorite-border',
    FAVORITE_OUTLINE = 'favorite-outline',
    FEATURED_PLAY_LIST = 'featured-play-list',
    FEATURED_VIDEO = 'featured-video',
    FEEDBACK = 'feedback',
    FENCE = 'fence',
    FESTIVAL = 'festival',
    FIBER_DVR = 'fiber-dvr',
    FIBER_MANUAL_RECORD = 'fiber-manual-record',
    FIBER_NEW = 'fiber-new',
    FIBER_PIN = 'fiber-pin',
    FIBER_SMART_RECORD = 'fiber-smart-record',
    FILE_COPY = 'file-copy',
    FILE_DOWNLOAD = 'file-download',
    FILE_DOWNLOAD_DONE = 'file-download-done',
    FILE_PRESENT = 'file-present',
    FILE_UPLOAD = 'file-upload',
    FILTER = 'filter',
    FILTER_1 = 'filter-1',
    FILTER_2 = 'filter-2',
    FILTER_3 = 'filter-3',
    FILTER_4 = 'filter-4',
    FILTER_5 = 'filter-5',
    FILTER_6 = 'filter-6',
    FILTER_7 = 'filter-7',
    FILTER_8 = 'filter-8',
    FILTER_9 = 'filter-9',
    FILTER_9_PLUS = 'filter-9-plus',
    FILTER_ALT = 'filter-alt',
    FILTER_B_AND_W = 'filter-b-and-w',
    FILTER_CENTER_FOCUS = 'filter-center-focus',
    FILTER_DRAMA = 'filter-drama',
    FILTER_FRAMES = 'filter-frames',
    FILTER_HDR = 'filter-hdr',
    FILTER_LIST = 'filter-list',
    FILTER_LIST_ALT = 'filter-list-alt',
    FILTER_NONE = 'filter-none',
    FILTER_TILT_SHIFT = 'filter-tilt-shift',
    FILTER_VINTAGE = 'filter-vintage',
    FIND_IN_PAGE = 'find-in-page',
    FIND_REPLACE = 'find-replace',
    FINGERPRINT = 'fingerprint',
    FIRE_EXTINGUISHER = 'fire-extinguisher',
    FIRE_HYDRANT = 'fire-hydrant',
    FIREPLACE = 'fireplace',
    FIRST_PAGE = 'first-page',
    FIT_SCREEN = 'fit-screen',
    FITNESS_CENTER = 'fitness-center',
    FLAG = 'flag',
    FLAKY = 'flaky',
    FLARE = 'flare',
    FLASH_AUTO = 'flash-auto',
    FLASH_OFF = 'flash-off',
    FLASH_ON = 'flash-on',
    FLIGHT = 'flight',
    FLIGHT_LAND = 'flight-land',
    FLIGHT_TAKEOFF = 'flight-takeoff',
    FLIP = 'flip',
    FLIP_CAMERA_ANDROID = 'flip-camera-android',
    FLIP_CAMERA_IOS = 'flip-camera-ios',
    FLIP_TO_BACK = 'flip-to-back',
    FLIP_TO_FRONT = 'flip-to-front',
    FOLDER = 'folder',
    FOLDER_OPEN = 'folder-open',
    FOLDER_SHARED = 'folder-shared',
    FOLDER_SPECIAL = 'folder-special',
    FOLLOW_THE_SIGNS = 'follow-the-signs',
    FONT_DOWNLOAD = 'font-download',
    FOOD_BANK = 'food-bank',
    FORMAT_ALIGN_CENTER = 'format-align-center',
    FORMAT_ALIGN_JUSTIFY = 'format-align-justify',
    FORMAT_ALIGN_LEFT = 'format-align-left',
    FORMAT_ALIGN_RIGHT = 'format-align-right',
    FORMAT_BOLD = 'format-bold',
    FORMAT_CLEAR = 'format-clear',
    FORMAT_COLOR_FILL = 'format-color-fill',
    FORMAT_COLOR_RESET = 'format-color-reset',
    FORMAT_COLOR_TEXT = 'format-color-text',
    FORMAT_INDENT_DECREASE = 'format-indent-decrease',
    FORMAT_INDENT_INCREASE = 'format-indent-increase',
    FORMAT_ITALIC = 'format-italic',
    FORMAT_LINE_SPACING = 'format-line-spacing',
    FORMAT_LIST_BULLETED = 'format-list-bulleted',
    FORMAT_LIST_NUMBERED = 'format-list-numbered',
    FORMAT_LIST_NUMBERED_RTL = 'format-list-numbered-rtl',
    FORMAT_PAINT = 'format-paint',
    FORMAT_QUOTE = 'format-quote',
    FORMAT_SHAPES = 'format-shapes',
    FORMAT_SIZE = 'format-size',
    FORMAT_STRIKETHROUGH = 'format-strikethrough',
    FORMAT_TEXTDIRECTION_L_TO_R = 'format-textdirection-l-to-r',
    FORMAT_TEXTDIRECTION_R_TO_L = 'format-textdirection-r-to-l',
    FORMAT_UNDERLINE = 'format-underline',
    FORMAT_UNDERLINED = 'format-underlined',
    FORUM = 'forum',
    FORWARD = 'forward',
    FORWARD_10 = 'forward-10',
    FORWARD_30 = 'forward-30',
    FORWARD_5 = 'forward-5',
    FORWARD_TO_INBOX = 'forward-to-inbox',
    FOUNDATION = 'foundation',
    FREE_BREAKFAST = 'free-breakfast',
    FULLSCREEN = 'fullscreen',
    FULLSCREEN_EXIT = 'fullscreen-exit',
    FUNCTIONS = 'functions',
    G_TRANSLATE = 'g-translate',
    GAMEPAD = 'gamepad',
    GAMES = 'games',
    GAVEL = 'gavel',
    GESTURE = 'gesture',
    GET_APP = 'get-app',
    GIF = 'gif',
    GOAT = 'goat',
    GOLF_COURSE = 'golf-course',
    GPS_FIXED = 'gps-fixed',
    GPS_NOT_FIXED = 'gps-not-fixed',
    GPS_OFF = 'gps-off',
    GRADE = 'grade',
    GRADIENT = 'gradient',
    GRADING = 'grading',
    GRAIN = 'grain',
    GRAPHIC_EQ = 'graphic-eq',
    GRASS = 'grass',
    GRID_OFF = 'grid-off',
    GRID_ON = 'grid-on',
    GRID_VIEW = 'grid-view',
    GROUP = 'group',
    GROUP_ADD = 'group-add',
    GROUP_WORK = 'group-work',
    GROUPS = 'groups',
    HAIL = 'hail',
    HANDYMAN = 'handyman',
    HARDWARE = 'hardware',
    HD = 'hd',
    HDR_ENHANCED_SELECT = 'hdr-enhanced-select',
    HDR_OFF = 'hdr-off',
    HDR_ON = 'hdr-on',
    HDR_STRONG = 'hdr-strong',
    HDR_WEAK = 'hdr-weak',
    HEADSET = 'headset',
    HEADSET_MIC = 'headset-mic',
    HEADSET_OFF = 'headset-off',
    HEALING = 'healing',
    HEARING = 'hearing',
    HEARING_DISABLED = 'hearing-disabled',
    HEIGHT = 'height',
    HELP = 'help',
    HELP_CENTER = 'help-center',
    HELP_OUTLINE = 'help-outline',
    HIGH_QUALITY = 'high-quality',
    HIGHLIGHT = 'highlight',
    HIGHLIGHT_ALT = 'highlight-alt',
    HIGHLIGHT_OFF = 'highlight-off',
    HIGHLIGHT_REMOVE = 'highlight-remove',
    HISTORY = 'history',
    HISTORY_EDU = 'history-edu',
    HISTORY_TOGGLE_OFF = 'history-toggle-off',
    HOME = 'home',
    HOME_FILLED = 'home-filled',
    HOME_REPAIR_SERVICE = 'home-repair-service',
    HOME_WORK = 'home-work',
    HORIZONTAL_DISTRIBUTE = 'horizontal-distribute',
    HORIZONTAL_RULE = 'horizontal-rule',
    HORIZONTAL_SPLIT = 'horizontal-split',
    HOT_TUB = 'hot-tub',
    HOTEL = 'hotel',
    HOURGLASS_BOTTOM = 'hourglass-bottom',
    HOURGLASS_DISABLED = 'hourglass-disabled',
    HOURGLASS_EMPTY = 'hourglass-empty',
    HOURGLASS_FULL = 'hourglass-full',
    HOURGLASS_TOP = 'hourglass-top',
    HOUSE = 'house',
    HOUSE_SIDING = 'house-siding',
    HOW_TO_REG = 'how-to-reg',
    HOW_TO_VOTE = 'how-to-vote',
    HTTP = 'http',
    HTTPS = 'https',
    HVAC = 'hvac',
    ICECREAM = 'icecream',
    IMAGE = 'image',
    IMAGE_ASPECT_RATIO = 'image-aspect-ratio',
    IMAGE_NOT_SUPPORTED = 'image-not-supported',
    IMAGE_SEARCH = 'image-search',
    IMAGESEARCH_ROLLER = 'imagesearch-roller',
    IMPORT_CONTACTS = 'import-contacts',
    IMPORT_EXPORT = 'import-export',
    IMPORTANT_DEVICES = 'important-devices',
    INBOX = 'inbox',
    INDETERMINATE_CHECK_BOX = 'indeterminate-check-box',
    INFO = 'info',
    INFO_OUTLINE = 'info-outline',
    INPUT = 'input',
    INSERT_CHART = 'insert-chart',
    INSERT_CHART_OUTLINED = 'insert-chart-outlined',
    INSERT_COMMENT = 'insert-comment',
    INSERT_DRIVE_FILE = 'insert-drive-file',
    INSERT_EMOTICON = 'insert-emoticon',
    INSERT_INVITATION = 'insert-invitation',
    INSERT_LINK = 'insert-link',
    INSERT_PHOTO = 'insert-photo',
    INSIGHTS = 'insights',
    INTEGRATION_INSTRUCTIONS = 'integration-instructions',
    INVENTORY = 'inventory',
    INVERT_COLORS = 'invert-colors',
    INVERT_COLORS_OFF = 'invert-colors-off',
    INVERT_COLORS_ON = 'invert-colors-on',
    IOS_SHARE = 'ios-share',
    ISO = 'iso',
    KEYBOARD = 'keyboard',
    KEYBOARD_ARROW_DOWN = 'keyboard-arrow-down',
    KEYBOARD_ARROW_LEFT = 'keyboard-arrow-left',
    KEYBOARD_ARROW_RIGHT = 'keyboard-arrow-right',
    KEYBOARD_ARROW_UP = 'keyboard-arrow-up',
    KEYBOARD_BACKSPACE = 'keyboard-backspace',
    KEYBOARD_CAPSLOCK = 'keyboard-capslock',
    KEYBOARD_CONTROL = 'keyboard-control',
    KEYBOARD_HIDE = 'keyboard-hide',
    KEYBOARD_RETURN = 'keyboard-return',
    KEYBOARD_TAB = 'keyboard-tab',
    KEYBOARD_VOICE = 'keyboard-voice',
    KING_BED = 'king-bed',
    KITCHEN = 'kitchen',
    LABEL = 'label',
    LABEL_IMPORTANT = 'label-important',
    LABEL_IMPORTANT_OUTLINE = 'label-important-outline',
    LABEL_OFF = 'label-off',
    LABEL_OUTLINE = 'label-outline',
    LANDSCAPE = 'landscape',
    LANGUAGE = 'language',
    LAPTOP = 'laptop',
    LAPTOP_CHROMEBOOK = 'laptop-chromebook',
    LAPTOP_MAC = 'laptop-mac',
    LAPTOP_WINDOWS = 'laptop-windows',
    LAST_PAGE = 'last-page',
    LAUNCH = 'launch',
    LAYERS = 'layers',
    LAYERS_CLEAR = 'layers-clear',
    LEADERBOARD = 'leaderboard',
    LEAK_ADD = 'leak-add',
    LEAK_REMOVE = 'leak-remove',
    LEAVE_BAGS_AT_HOME = 'leave-bags-at-home',
    LEGEND_TOGGLE = 'legend-toggle',
    LENS = 'lens',
    LIBRARY_ADD = 'library-add',
    LIBRARY_ADD_CHECK = 'library-add-check',
    LIBRARY_BOOKS = 'library-books',
    LIBRARY_MUSIC = 'library-music',
    LIGHTBULB = 'lightbulb',
    LIGHTBULB_OUTLINE = 'lightbulb-outline',
    LINE_STYLE = 'line-style',
    LINE_WEIGHT = 'line-weight',
    LINEAR_SCALE = 'linear-scale',
    LINK = 'link',
    LINK_OFF = 'link-off',
    LINKED_CAMERA = 'linked-camera',
    LIQUOR = 'liquor',
    LIST = 'list',
    LIST_ALT = 'list-alt',
    LIVE_HELP = 'live-help',
    LIVE_TV = 'live-tv',
    LOCAL_ACTIVITY = 'local-activity',
    LOCAL_AIRPORT = 'local-airport',
    LOCAL_ATM = 'local-atm',
    LOCAL_ATTRACTION = 'local-attraction',
    LOCAL_BAR = 'local-bar',
    LOCAL_CAFE = 'local-cafe',
    LOCAL_CAR_WASH = 'local-car-wash',
    LOCAL_CONVENIENCE_STORE = 'local-convenience-store',
    LOCAL_DINING = 'local-dining',
    LOCAL_DRINK = 'local-drink',
    LOCAL_FIRE_DEPARTMENT = 'local-fire-department',
    LOCAL_FLORIST = 'local-florist',
    LOCAL_GAS_STATION = 'local-gas-station',
    LOCAL_GROCERY_STORE = 'local-grocery-store',
    LOCAL_HOSPITAL = 'local-hospital',
    LOCAL_HOTEL = 'local-hotel',
    LOCAL_LAUNDRY_SERVICE = 'local-laundry-service',
    LOCAL_LIBRARY = 'local-library',
    LOCAL_MALL = 'local-mall',
    LOCAL_MOVIES = 'local-movies',
    LOCAL_OFFER = 'local-offer',
    LOCAL_PARKING = 'local-parking',
    LOCAL_PHARMACY = 'local-pharmacy',
    LOCAL_PHONE = 'local-phone',
    LOCAL_PIZZA = 'local-pizza',
    LOCAL_PLAY = 'local-play',
    LOCAL_POLICE = 'local-police',
    LOCAL_POST_OFFICE = 'local-post-office',
    LOCAL_PRINT_SHOP = 'local-print-shop',
    LOCAL_PRINTSHOP = 'local-printshop',
    LOCAL_RESTAURANT = 'local-restaurant',
    LOCAL_SEE = 'local-see',
    LOCAL_SHIPPING = 'local-shipping',
    LOCAL_TAXI = 'local-taxi',
    LOCATION_CITY = 'location-city',
    LOCATION_DISABLED = 'location-disabled',
    LOCATION_HISTORY = 'location-history',
    LOCATION_OFF = 'location-off',
    LOCATION_ON = 'location-on',
    LOCATION_PIN = 'location-pin',
    LOCATION_SEARCHING = 'location-searching',
    LOCK = 'lock',
    LOCK_CLOCK = 'lock-clock',
    LOCK_OPEN = 'lock-open',
    LOCK_OUTLINE = 'lock-outline',
    LOGIN = 'login',
    LOGOUT = 'logout',
    LOOKS = 'looks',
    LOOKS_3 = 'looks-3',
    LOOKS_4 = 'looks-4',
    LOOKS_5 = 'looks-5',
    LOOKS_6 = 'looks-6',
    LOOKS_ONE = 'looks-one',
    LOOKS_TWO = 'looks-two',
    LOOP = 'loop',
    LOUPE = 'loupe',
    LOW_PRIORITY = 'low-priority',
    LOYALTY = 'loyalty',
    LUGGAGE = 'luggage',
    LUNCH_DINING = 'lunch-dining',
    MAIL = 'mail',
    MAIL_OUTLINE = 'mail-outline',
    MAP = 'map',
    MAPS_UGC = 'maps-ugc',
    MARGIN = 'margin',
    MARK_AS_UNREAD = 'mark-as-unread',
    MARK_CHAT_READ = 'mark-chat-read',
    MARK_CHAT_UNREAD = 'mark-chat-unread',
    MARK_EMAIL_READ = 'mark-email-read',
    MARK_EMAIL_UNREAD = 'mark-email-unread',
    MARKUNREAD = 'markunread',
    MARKUNREAD_MAILBOX = 'markunread-mailbox',
    MASKS = 'masks',
    MAXIMIZE = 'maximize',
    MEDIATION = 'mediation',
    MEDICAL_SERVICES = 'medical-services',
    MEETING_ROOM = 'meeting-room',
    MEMORY = 'memory',
    MENU = 'menu',
    MENU_BOOK = 'menu-book',
    MENU_OPEN = 'menu-open',
    MERGE_TYPE = 'merge-type',
    MESSAGE = 'message',
    MESSENGER = 'messenger',
    MESSENGER_OUTLINE = 'messenger-outline',
    MIC = 'mic',
    MIC_EXTERNAL_OFF = 'mic-external-off',
    MIC_EXTERNAL_ON = 'mic-external-on',
    MIC_NONE = 'mic-none',
    MIC_OFF = 'mic-off',
    MICROWAVE = 'microwave',
    MILITARY_TECH = 'military-tech',
    MINIMIZE = 'minimize',
    MISCELLANEOUS_SERVICES = 'miscellaneous-services',
    MISSED_VIDEO_CALL = 'missed-video-call',
    MMS = 'mms',
    MOBILE_FRIENDLY = 'mobile-friendly',
    MOBILE_OFF = 'mobile-off',
    MOBILE_SCREEN_SHARE = 'mobile-screen-share',
    MODE_COMMENT = 'mode-comment',
    MODE_EDIT = 'mode-edit',
    MODEL_TRAINING = 'model-training',
    MONETIZATION_ON = 'monetization-on',
    MONEY = 'money',
    MONEY_OFF = 'money-off',
    MONITOR = 'monitor',
    MONOCHROME_PHOTOS = 'monochrome-photos',
    MOOD = 'mood',
    MOOD_BAD = 'mood-bad',
    MOPED = 'moped',
    MORE = 'more',
    MORE_HORIZ = 'more-horiz',
    MORE_TIME = 'more-time',
    MORE_VERT = 'more-vert',
    MOTION_PHOTOS_OFF = 'motion-photos-off',
    MOTION_PHOTOS_ON = 'motion-photos-on',
    MOTION_PHOTOS_PAUSE = 'motion-photos-pause',
    MOTION_PHOTOS_PAUSED = 'motion-photos-paused',
    MOTORCYCLE = 'motorcycle',
    MOUSE = 'mouse',
    MOVE_TO_INBOX = 'move-to-inbox',
    MOVIE = 'movie',
    MOVIE_CREATION = 'movie-creation',
    MOVIE_FILTER = 'movie-filter',
    MP = 'mp',
    MULTILINE_CHART = 'multiline-chart',
    MULTIPLE_STOP = 'multiple-stop',
    MULTITRACK_AUDIO = 'multitrack-audio',
    MUSEUM = 'museum',
    MUSIC_NOTE = 'music-note',
    MUSIC_OFF = 'music-off',
    MUSIC_VIDEO = 'music-video',
    MY_LIBRARY_ADD = 'my-library-add',
    MY_LIBRARY_BOOKS = 'my-library-books',
    MY_LIBRARY_MUSIC = 'my-library-music',
    MY_LOCATION = 'my-location',
    NAT = 'nat',
    NATURE = 'nature',
    NATURE_PEOPLE = 'nature-people',
    NAVIGATE_BEFORE = 'navigate-before',
    NAVIGATE_NEXT = 'navigate-next',
    NAVIGATION = 'navigation',
    NEAR_ME = 'near-me',
    NEAR_ME_DISABLED = 'near-me-disabled',
    NETWORK_CELL = 'network-cell',
    NETWORK_CHECK = 'network-check',
    NETWORK_LOCKED = 'network-locked',
    NETWORK_WIFI = 'network-wifi',
    NEW_RELEASES = 'new-releases',
    NEXT_PLAN = 'next-plan',
    NEXT_WEEK = 'next-week',
    NFC = 'nfc',
    NIGHT_SHELTER = 'night-shelter',
    NIGHTLIFE = 'nightlife',
    NIGHTLIGHT_ROUND = 'nightlight-round',
    NIGHTS_STAY = 'nights-stay',
    NO_BACKPACK = 'no-backpack',
    NO_CELL = 'no-cell',
    NO_DRINKS = 'no-drinks',
    NO_ENCRYPTION = 'no-encryption',
    NO_FLASH = 'no-flash',
    NO_FOOD = 'no-food',
    NO_LUGGAGE = 'no-luggage',
    NO_MEALS = 'no-meals',
    NO_MEALS_OULINE = 'no-meals-ouline',
    NO_MEETING_ROOM = 'no-meeting-room',
    NO_PHOTOGRAPHY = 'no-photography',
    NO_SIM = 'no-sim',
    NO_STROLLER = 'no-stroller',
    NO_TRANSFER = 'no-transfer',
    NORTH = 'north',
    NORTH_EAST = 'north-east',
    NORTH_WEST = 'north-west',
    NOT_ACCESSIBLE = 'not-accessible',
    NOT_INTERESTED = 'not-interested',
    NOT_LISTED_LOCATION = 'not-listed-location',
    NOT_STARTED = 'not-started',
    NOTE = 'note',
    NOTE_ADD = 'note-add',
    NOTES = 'notes',
    NOTIFICATION_IMPORTANT = 'notification-important',
    NOTIFICATIONS = 'notifications',
    NOTIFICATIONS_ACTIVE = 'notifications-active',
    NOTIFICATIONS_NONE = 'notifications-none',
    NOTIFICATIONS_OFF = 'notifications-off',
    NOTIFICATIONS_ON = 'notifications-on',
    NOTIFICATIONS_PAUSED = 'notifications-paused',
    NOW_WALLPAPER = 'now-wallpaper',
    NOW_WIDGETS = 'now-widgets',
    OFFLINE_BOLT = 'offline-bolt',
    OFFLINE_PIN = 'offline-pin',
    OFFLINE_SHARE = 'offline-share',
    ONDEMAND_VIDEO = 'ondemand-video',
    ONLINE_PREDICTION = 'online-prediction',
    OPACITY = 'opacity',
    OPEN_IN_BROWSER = 'open-in-browser',
    OPEN_IN_FULL = 'open-in-full',
    OPEN_IN_NEW = 'open-in-new',
    OPEN_WITH = 'open-with',
    OUTBOND = 'outbond',
    OUTBOX = 'outbox',
    OUTDOOR_GRILL = 'outdoor-grill',
    OUTGOING_MAIL = 'outgoing-mail',
    OUTLET = 'outlet',
    OUTLINED_FLAG = 'outlined-flag',
    PADDING = 'padding',
    PAGES = 'pages',
    PAGEVIEW = 'pageview',
    PALETTE = 'palette',
    PAN_TOOL = 'pan-tool',
    PANORAMA = 'panorama',
    PANORAMA_FISH_EYE = 'panorama-fish-eye',
    PANORAMA_FISHEYE = 'panorama-fisheye',
    PANORAMA_HORIZONTAL = 'panorama-horizontal',
    PANORAMA_HORIZONTAL_SELECT = 'panorama-horizontal-select',
    PANORAMA_PHOTOSPHERE = 'panorama-photosphere',
    PANORAMA_PHOTOSPHERE_SELECT = 'panorama-photosphere-select',
    PANORAMA_VERTICAL = 'panorama-vertical',
    PANORAMA_VERTICAL_SELECT = 'panorama-vertical-select',
    PANORAMA_WIDE_ANGLE = 'panorama-wide-angle',
    PANORAMA_WIDE_ANGLE_SELECT = 'panorama-wide-angle-select',
    PARK = 'park',
    PARTY_MODE = 'party-mode',
    PAUSE = 'pause',
    PAUSE_CIRCLE_FILLED = 'pause-circle-filled',
    PAUSE_CIRCLE_OUTLINE = 'pause-circle-outline',
    PAUSE_PRESENTATION = 'pause-presentation',
    PAYMENT = 'payment',
    PAYMENTS = 'payments',
    PEDAL_BIKE = 'pedal-bike',
    PENDING = 'pending',
    PENDING_ACTIONS = 'pending-actions',
    PEOPLE = 'people',
    PEOPLE_ALT = 'people-alt',
    PEOPLE_OUTLINE = 'people-outline',
    PERM_CAMERA_MIC = 'perm-camera-mic',
    PERM_CONTACT_CAL = 'perm-contact-cal',
    PERM_CONTACT_CALENDAR = 'perm-contact-calendar',
    PERM_DATA_SETTING = 'perm-data-setting',
    PERM_DEVICE_INFO = 'perm-device-info',
    PERM_DEVICE_INFORMATION = 'perm-device-information',
    PERM_IDENTITY = 'perm-identity',
    PERM_MEDIA = 'perm-media',
    PERM_PHONE_MSG = 'perm-phone-msg',
    PERM_SCAN_WIFI = 'perm-scan-wifi',
    PERSON = 'person',
    PERSON_ADD = 'person-add',
    PERSON_ADD_ALT = 'person-add-alt',
    PERSON_ADD_ALT_1 = 'person-add-alt-1',
    PERSON_ADD_DISABLED = 'person-add-disabled',
    PERSON_OUTLINE = 'person-outline',
    PERSON_PIN = 'person-pin',
    PERSON_PIN_CIRCLE = 'person-pin-circle',
    PERSON_REMOVE = 'person-remove',
    PERSON_REMOVE_ALT_1 = 'person-remove-alt-1',
    PERSON_SEARCH = 'person-search',
    PERSONAL_VIDEO = 'personal-video',
    PEST_CONTROL = 'pest-control',
    PEST_CONTROL_RODENT = 'pest-control-rodent',
    PETS = 'pets',
    PHONE = 'phone',
    PHONE_ANDROID = 'phone-android',
    PHONE_BLUETOOTH_SPEAKER = 'phone-bluetooth-speaker',
    PHONE_CALLBACK = 'phone-callback',
    PHONE_DISABLED = 'phone-disabled',
    PHONE_ENABLED = 'phone-enabled',
    PHONE_FORWARDED = 'phone-forwarded',
    PHONE_IN_TALK = 'phone-in-talk',
    PHONE_IPHONE = 'phone-iphone',
    PHONE_LOCKED = 'phone-locked',
    PHONE_MISSED = 'phone-missed',
    PHONE_PAUSED = 'phone-paused',
    PHONELINK = 'phonelink',
    PHONELINK_ERASE = 'phonelink-erase',
    PHONELINK_LOCK = 'phonelink-lock',
    PHONELINK_OFF = 'phonelink-off',
    PHONELINK_RING = 'phonelink-ring',
    PHONELINK_SETUP = 'phonelink-setup',
    PHOTO = 'photo',
    PHOTO_ALBUM = 'photo-album',
    PHOTO_CAMERA = 'photo-camera',
    PHOTO_CAMERA_BACK = 'photo-camera-back',
    PHOTO_CAMERA_FRONT = 'photo-camera-front',
    PHOTO_FILTER = 'photo-filter',
    PHOTO_LIBRARY = 'photo-library',
    PHOTO_SIZE_SELECT_ACTUAL = 'photo-size-select-actual',
    PHOTO_SIZE_SELECT_LARGE = 'photo-size-select-large',
    PHOTO_SIZE_SELECT_SMALL = 'photo-size-select-small',
    PICTURE_AS_PDF = 'picture-as-pdf',
    PICTURE_IN_PICTURE = 'picture-in-picture',
    PICTURE_IN_PICTURE_ALT = 'picture-in-picture-alt',
    PIE_CHART = 'pie-chart',
    PIE_CHART_OUTLINED = 'pie-chart-outlined',
    PIN_DROP = 'pin-drop',
    PIVOT_TABLE_CHART = 'pivot-table-chart',
    PLACE = 'place',
    PLAGIARISM = 'plagiarism',
    PLAY_ARROW = 'play-arrow',
    PLAY_CIRCLE_FILL = 'play-circle-fill',
    PLAY_CIRCLE_FILLED = 'play-circle-filled',
    PLAY_CIRCLE_OUTLINE = 'play-circle-outline',
    PLAY_DISABLED = 'play-disabled',
    PLAY_FOR_WORK = 'play-for-work',
    PLAYLIST_ADD = 'playlist-add',
    PLAYLIST_ADD_CHECK = 'playlist-add-check',
    PLAYLIST_PLAY = 'playlist-play',
    PLUMBING = 'plumbing',
    PLUS_ONE = 'plus-one',
    POINT_OF_SALE = 'point-of-sale',
    POLICY = 'policy',
    POLL = 'poll',
    POLYMER = 'polymer',
    POOL = 'pool',
    PORTABLE_WIFI_OFF = 'portable-wifi-off',
    PORTRAIT = 'portrait',
    POST_ADD = 'post-add',
    POWER = 'power',
    POWER_INPUT = 'power-input',
    POWER_OFF = 'power-off',
    POWER_SETTINGS_NEW = 'power-settings-new',
    PREGNANT_WOMAN = 'pregnant-woman',
    PRESENT_TO_ALL = 'present-to-all',
    PREVIEW = 'preview',
    PRINT = 'print',
    PRINT_DISABLED = 'print-disabled',
    PRIORITY_HIGH = 'priority-high',
    PRIVACY_TIP = 'privacy-tip',
    PSYCHOLOGY = 'psychology',
    PUBLIC = 'public',
    PUBLIC_OFF = 'public-off',
    PUBLISH = 'publish',
    PUBLISHED_WITH_CHANGES = 'published-with-changes',
    PUSH_PIN = 'push-pin',
    QR_CODE = 'qr-code',
    QR_CODE_2 = 'qr-code-2',
    QR_CODE_SCANNER = 'qr-code-scanner',
    QUERY_BUILDER = 'query-builder',
    QUESTION_ANSWER = 'question-answer',
    QUEUE = 'queue',
    QUEUE_MUSIC = 'queue-music',
    QUEUE_PLAY_NEXT = 'queue-play-next',
    QUICK_CONTACTS_DIALER = 'quick-contacts-dialer',
    QUICK_CONTACTS_MAIL = 'quick-contacts-mail',
    QUICKREPLY = 'quickreply',
    RADIO = 'radio',
    RADIO_BUTTON_CHECKED = 'radio-button-checked',
    RADIO_BUTTON_OFF = 'radio-button-off',
    RADIO_BUTTON_ON = 'radio-button-on',
    RADIO_BUTTON_UNCHECKED = 'radio-button-unchecked',
    RAILWAY_ALERT = 'railway-alert',
    RAMEN_DINING = 'ramen-dining',
    RATE_REVIEW = 'rate-review',
    READ_MORE = 'read-more',
    RECEIPT = 'receipt',
    RECEIPT_LONG = 'receipt-long',
    RECENT_ACTORS = 'recent-actors',
    RECOMMEND = 'recommend',
    RECORD_VOICE_OVER = 'record-voice-over',
    REDEEM = 'redeem',
    REDO = 'redo',
    REDUCE_CAPACITY = 'reduce-capacity',
    REFRESH = 'refresh',
    REMOVE = 'remove',
    REMOVE_CIRCLE = 'remove-circle',
    REMOVE_CIRCLE_OUTLINE = 'remove-circle-outline',
    REMOVE_DONE = 'remove-done',
    REMOVE_FROM_QUEUE = 'remove-from-queue',
    REMOVE_MODERATOR = 'remove-moderator',
    REMOVE_RED_EYE = 'remove-red-eye',
    REMOVE_SHOPPING_CART = 'remove-shopping-cart',
    REORDER = 'reorder',
    REPEAT = 'repeat',
    REPEAT_ON = 'repeat-on',
    REPEAT_ONE = 'repeat-one',
    REPEAT_ONE_ON = 'repeat-one-on',
    REPLAY = 'replay',
    REPLAY_10 = 'replay-10',
    REPLAY_30 = 'replay-30',
    REPLAY_5 = 'replay-5',
    REPLAY_CIRCLE_FILLED = 'replay-circle-filled',
    REPLY = 'reply',
    REPLY_ALL = 'reply-all',
    REPORT = 'report',
    REPORT_OFF = 'report-off',
    REPORT_PROBLEM = 'report-problem',
    REQUEST_PAGE = 'request-page',
    REQUEST_QUOTE = 'request-quote',
    RESET_TV = 'reset-tv',
    RESTAURANT = 'restaurant',
    RESTAURANT_MENU = 'restaurant-menu',
    RESTORE = 'restore',
    RESTORE_FROM_TRASH = 'restore-from-trash',
    RESTORE_PAGE = 'restore-page',
    RICE_BOWL = 'rice-bowl',
    RING_VOLUME = 'ring-volume',
    ROOFING = 'roofing',
    ROOM = 'room',
    ROOM_PREFERENCES = 'room-preferences',
    ROOM_SERVICE = 'room-service',
    ROTATE_90_DEGREES_CCW = 'rotate-90-degrees-ccw',
    ROTATE_LEFT = 'rotate-left',
    ROTATE_RIGHT = 'rotate-right',
    ROUNDED_CORNER = 'rounded-corner',
    ROUTER = 'router',
    ROWING = 'rowing',
    RSS_FEED = 'rss-feed',
    RTT = 'rtt',
    RULE = 'rule',
    RULE_FOLDER = 'rule-folder',
    RUN_CIRCLE = 'run-circle',
    RV_HOOKUP = 'rv-hookup',
    SANITIZER = 'sanitizer',
    SATELLITE = 'satellite',
    SAVE = 'save',
    SAVE_ALT = 'save-alt',
    SAVED_SEARCH = 'saved-search',
    SCANNER = 'scanner',
    SCATTER_PLOT = 'scatter-plot',
    SCHEDULE = 'schedule',
    SCHEDULE_SEND = 'schedule-send',
    SCHOOL = 'school',
    SCIENCE = 'science',
    SCORE = 'score',
    SCREEN_LOCK_LANDSCAPE = 'screen-lock-landscape',
    SCREEN_LOCK_PORTRAIT = 'screen-lock-portrait',
    SCREEN_LOCK_ROTATION = 'screen-lock-rotation',
    SCREEN_ROTATION = 'screen-rotation',
    SCREEN_SEARCH_DESKTOP = 'screen-search-desktop',
    SCREEN_SHARE = 'screen-share',
    SD = 'sd',
    SD_CARD = 'sd-card',
    SD_STORAGE = 'sd-storage',
    SEARCH = 'search',
    SEARCH_OFF = 'search-off',
    SECURITY = 'security',
    SEGMENT = 'segment',
    SELECT_ALL = 'select-all',
    SELF_IMPROVEMENT = 'self-improvement',
    SEND = 'send',
    SEND_AND_ARCHIVE = 'send-and-archive',
    SEND_TO_MOBILE = 'send-to-mobile',
    SENSOR_DOOR = 'sensor-door',
    SENSOR_WINDOW = 'sensor-window',
    SENTIMENT_DISSATISFIED = 'sentiment-dissatisfied',
    SENTIMENT_NEUTRAL = 'sentiment-neutral',
    SENTIMENT_SATISFIED = 'sentiment-satisfied',
    SENTIMENT_SATISFIED_ALT = 'sentiment-satisfied-alt',
    SENTIMENT_VERY_DISSATISFIED = 'sentiment-very-dissatisfied',
    SENTIMENT_VERY_SATISFIED = 'sentiment-very-satisfied',
    SET_MEAL = 'set-meal',
    SETTINGS = 'settings',
    SETTINGS_APPLICATIONS = 'settings-applications',
    SETTINGS_BACKUP_RESTORE = 'settings-backup-restore',
    SETTINGS_BLUETOOTH = 'settings-bluetooth',
    SETTINGS_BRIGHTNESS = 'settings-brightness',
    SETTINGS_CELL = 'settings-cell',
    SETTINGS_DISPLAY = 'settings-display',
    SETTINGS_ETHERNET = 'settings-ethernet',
    SETTINGS_INPUT_ANTENNA = 'settings-input-antenna',
    SETTINGS_INPUT_COMPONENT = 'settings-input-component',
    SETTINGS_INPUT_COMPOSITE = 'settings-input-composite',
    SETTINGS_INPUT_HDMI = 'settings-input-hdmi',
    SETTINGS_INPUT_SVIDEO = 'settings-input-svideo',
    SETTINGS_OVERSCAN = 'settings-overscan',
    SETTINGS_PHONE = 'settings-phone',
    SETTINGS_POWER = 'settings-power',
    SETTINGS_REMOTE = 'settings-remote',
    SETTINGS_SYSTEM_DAYDREAM = 'settings-system-daydream',
    SETTINGS_VOICE = 'settings-voice',
    SHARE = 'share',
    SHIELD = 'shield',
    SHOP = 'shop',
    SHOP_TWO = 'shop-two',
    SHOPPING_BAG = 'shopping-bag',
    SHOPPING_BASKET = 'shopping-basket',
    SHOPPING_CART = 'shopping-cart',
    SHORT_TEXT = 'short-text',
    SHOW_CHART = 'show-chart',
    SHUFFLE = 'shuffle',
    SHUFFLE_ON = 'shuffle-on',
    SHUTTER_SPEED = 'shutter-speed',
    SICK = 'sick',
    SIGNAL_CELLULAR_0_BAR = 'signal-cellular-0-bar',
    SIGNAL_CELLULAR_4_BAR = 'signal-cellular-4-bar',
    SIGNAL_CELLULAR_ALT = 'signal-cellular-alt',
    SIGNAL_CELLULAR_CONNECTED_NO_INTERNET_4_BAR = 'signal-cellular-connected-no-internet-4-bar',
    SIGNAL_CELLULAR_NO_SIM = 'signal-cellular-no-sim',
    SIGNAL_CELLULAR_NULL = 'signal-cellular-null',
    SIGNAL_CELLULAR_OFF = 'signal-cellular-off',
    SIGNAL_WIFI_0_BAR = 'signal-wifi-0-bar',
    SIGNAL_WIFI_4_BAR = 'signal-wifi-4-bar',
    SIGNAL_WIFI_4_BAR_LOCK = 'signal-wifi-4-bar-lock',
    SIGNAL_WIFI_OFF = 'signal-wifi-off',
    SIM_CARD = 'sim-card',
    SIM_CARD_ALERT = 'sim-card-alert',
    SINGLE_BED = 'single-bed',
    SKIP_NEXT = 'skip-next',
    SKIP_PREVIOUS = 'skip-previous',
    SLIDESHOW = 'slideshow',
    SLOW_MOTION_VIDEO = 'slow-motion-video',
    SMART_BUTTON = 'smart-button',
    SMARTPHONE = 'smartphone',
    SMOKE_FREE = 'smoke-free',
    SMOKING_ROOMS = 'smoking-rooms',
    SMS = 'sms',
    SMS_FAILED = 'sms-failed',
    SNIPPET_FOLDER = 'snippet-folder',
    SNOOZE = 'snooze',
    SOAP = 'soap',
    SORT = 'sort',
    SORT_BY_ALPHA = 'sort-by-alpha',
    SOURCE = 'source',
    SOUTH = 'south',
    SOUTH_EAST = 'south-east',
    SOUTH_WEST = 'south-west',
    SPA = 'spa',
    SPACE_BAR = 'space-bar',
    SPEAKER = 'speaker',
    SPEAKER_GROUP = 'speaker-group',
    SPEAKER_NOTES = 'speaker-notes',
    SPEAKER_NOTES_OFF = 'speaker-notes-off',
    SPEAKER_PHONE = 'speaker-phone',
    SPEED = 'speed',
    SPELLCHECK = 'spellcheck',
    SPORTS = 'sports',
    SPORTS_BAR = 'sports-bar',
    SPORTS_BASEBALL = 'sports-baseball',
    SPORTS_BASKETBALL = 'sports-basketball',
    SPORTS_CRICKET = 'sports-cricket',
    SPORTS_ESPORTS = 'sports-esports',
    SPORTS_FOOTBALL = 'sports-football',
    SPORTS_GOLF = 'sports-golf',
    SPORTS_HANDBALL = 'sports-handball',
    SPORTS_HOCKEY = 'sports-hockey',
    SPORTS_KABADDI = 'sports-kabaddi',
    SPORTS_MMA = 'sports-mma',
    SPORTS_MOTORSPORTS = 'sports-motorsports',
    SPORTS_RUGBY = 'sports-rugby',
    SPORTS_SOCCER = 'sports-soccer',
    SPORTS_TENNIS = 'sports-tennis',
    SPORTS_VOLLEYBALL = 'sports-volleyball',
    SQUARE_FOOT = 'square-foot',
    STACKED_BAR_CHART = 'stacked-bar-chart',
    STACKED_LINE_CHART = 'stacked-line-chart',
    STAIRS = 'stairs',
    STAR = 'star',
    STAR_BORDER = 'star-border',
    STAR_HALF = 'star-half',
    STAR_OUTLINE = 'star-outline',
    STAR_RATE = 'star-rate',
    STARS = 'stars',
    STAY_CURRENT_LANDSCAPE = 'stay-current-landscape',
    STAY_CURRENT_PORTRAIT = 'stay-current-portrait',
    STAY_PRIMARY_LANDSCAPE = 'stay-primary-landscape',
    STAY_PRIMARY_PORTRAIT = 'stay-primary-portrait',
    STICKY_NOTE_2 = 'sticky-note-2',
    STOP = 'stop',
    STOP_CIRCLE = 'stop-circle',
    STOP_SCREEN_SHARE = 'stop-screen-share',
    STORAGE = 'storage',
    STORE = 'store',
    STORE_MALL_DIRECTORY = 'store-mall-directory',
    STOREFRONT = 'storefront',
    STRAIGHTEN = 'straighten',
    STREAM = 'stream',
    STREETVIEW = 'streetview',
    STRIKETHROUGH_S = 'strikethrough-s',
    STROLLER = 'stroller',
    STYLE = 'style',
    SUBDIRECTORY_ARROW_LEFT = 'subdirectory-arrow-left',
    SUBDIRECTORY_ARROW_RIGHT = 'subdirectory-arrow-right',
    SUBJECT = 'subject',
    SUBSCRIPT = 'subscript',
    SUBSCRIPTIONS = 'subscriptions',
    SUBTITLES = 'subtitles',
    SUBTITLES_OFF = 'subtitles-off',
    SUBWAY = 'subway',
    SUPERSCRIPT = 'superscript',
    SUPERVISED_USER_CIRCLE = 'supervised-user-circle',
    SUPERVISOR_ACCOUNT = 'supervisor-account',
    SUPPORT = 'support',
    SUPPORT_AGENT = 'support-agent',
    SURROUND_SOUND = 'surround-sound',
    SWAP_CALLS = 'swap-calls',
    SWAP_HORIZ = 'swap-horiz',
    SWAP_HORIZONTAL_CIRCLE = 'swap-horizontal-circle',
    SWAP_VERT = 'swap-vert',
    SWAP_VERT_CIRCLE = 'swap-vert-circle',
    SWAP_VERTICAL_CIRCLE = 'swap-vertical-circle',
    SWIPE = 'swipe',
    SWITCH_ACCOUNT = 'switch-account',
    SWITCH_CAMERA = 'switch-camera',
    SWITCH_LEFT = 'switch-left',
    SWITCH_RIGHT = 'switch-right',
    SWITCH_VIDEO = 'switch-video',
    SYNC = 'sync',
    SYNC_ALT = 'sync-alt',
    SYNC_DISABLED = 'sync-disabled',
    SYNC_PROBLEM = 'sync-problem',
    SYSTEM_UPDATE = 'system-update',
    SYSTEM_UPDATE_ALT = 'system-update-alt',
    SYSTEM_UPDATE_TV = 'system-update-tv',
    TAB = 'tab',
    TAB_UNSELECTED = 'tab-unselected',
    TABLE_CHART = 'table-chart',
    TABLE_ROWS = 'table-rows',
    TABLE_VIEW = 'table-view',
    TABLET = 'tablet',
    TABLET_ANDROID = 'tablet-android',
    TABLET_MAC = 'tablet-mac',
    TAG = 'tag',
    TAG_FACES = 'tag-faces',
    TAKEOUT_DINING = 'takeout-dining',
    TAP_AND_PLAY = 'tap-and-play',
    TAPAS = 'tapas',
    TAXI_ALERT = 'taxi-alert',
    TERRAIN = 'terrain',
    TEXT_FIELDS = 'text-fields',
    TEXT_FORMAT = 'text-format',
    TEXT_ROTATE_UP = 'text-rotate-up',
    TEXT_ROTATE_VERTICAL = 'text-rotate-vertical',
    TEXT_ROTATION_ANGLEDOWN = 'text-rotation-angledown',
    TEXT_ROTATION_ANGLEUP = 'text-rotation-angleup',
    TEXT_ROTATION_DOWN = 'text-rotation-down',
    TEXT_ROTATION_NONE = 'text-rotation-none',
    TEXT_SNIPPET = 'text-snippet',
    TEXTSMS = 'textsms',
    TEXTURE = 'texture',
    THEATER_COMEDY = 'theater-comedy',
    THEATERS = 'theaters',
    THUMB_DOWN = 'thumb-down',
    THUMB_DOWN_ALT = 'thumb-down-alt',
    THUMB_DOWN_OFF_ALT = 'thumb-down-off-alt',
    THUMB_UP = 'thumb-up',
    THUMB_UP_ALT = 'thumb-up-alt',
    THUMB_UP_OFF_ALT = 'thumb-up-off-alt',
    THUMBS_UP_DOWN = 'thumbs-up-down',
    TIME_TO_LEAVE = 'time-to-leave',
    TIMELAPSE = 'timelapse',
    TIMELINE = 'timeline',
    TIMER = 'timer',
    TIMER_10 = 'timer-10',
    TIMER_3 = 'timer-3',
    TIMER_OFF = 'timer-off',
    TITLE = 'title',
    TOC = 'toc',
    TODAY = 'today',
    TOGGLE_OFF = 'toggle-off',
    TOGGLE_ON = 'toggle-on',
    TOLL = 'toll',
    TONALITY = 'tonality',
    TOPIC = 'topic',
    TOUCH_APP = 'touch-app',
    TOUR = 'tour',
    TOYS = 'toys',
    TRACK_CHANGES = 'track-changes',
    TRAFFIC = 'traffic',
    TRAIN = 'train',
    TRAM = 'tram',
    TRANSFER_WITHIN_A_STATION = 'transfer-within-a-station',
    TRANSFORM = 'transform',
    TRANSIT_ENTEREXIT = 'transit-enterexit',
    TRANSLATE = 'translate',
    TRENDING_DOWN = 'trending-down',
    TRENDING_FLAT = 'trending-flat',
    TRENDING_NEUTRAL = 'trending-neutral',
    TRENDING_UP = 'trending-up',
    TRIP_ORIGIN = 'trip-origin',
    TTY = 'tty',
    TUNE = 'tune',
    TURNED_IN = 'turned-in',
    TURNED_IN_NOT = 'turned-in-not',
    TV = 'tv',
    TV_OFF = 'tv-off',
    TWO_WHEELER = 'two-wheeler',
    UMBRELLA = 'umbrella',
    UNARCHIVE = 'unarchive',
    UNDO = 'undo',
    UNFOLD_LESS = 'unfold-less',
    UNFOLD_MORE = 'unfold-more',
    UNPUBLISHED = 'unpublished',
    UNSUBSCRIBE = 'unsubscribe',
    UPDATE = 'update',
    UPDATE_DISABLED = 'update-disabled',
    UPGRADE = 'upgrade',
    UPLOAD_FILE = 'upload-file',
    USB = 'usb',
    VERIFIED = 'verified',
    VERIFIED_USER = 'verified-user',
    VERTICAL_ALIGN_BOTTOM = 'vertical-align-bottom',
    VERTICAL_ALIGN_CENTER = 'vertical-align-center',
    VERTICAL_ALIGN_TOP = 'vertical-align-top',
    VERTICAL_DISTRIBUTE = 'vertical-distribute',
    VERTICAL_SPLIT = 'vertical-split',
    VIBRATION = 'vibration',
    VIDEO_CALL = 'video-call',
    VIDEO_COLLECTION = 'video-collection',
    VIDEO_LABEL = 'video-label',
    VIDEO_LIBRARY = 'video-library',
    VIDEO_SETTINGS = 'video-settings',
    VIDEOCAM = 'videocam',
    VIDEOCAM_OFF = 'videocam-off',
    VIDEOGAME_ASSET = 'videogame-asset',
    VIEW_AGENDA = 'view-agenda',
    VIEW_ARRAY = 'view-array',
    VIEW_CAROUSEL = 'view-carousel',
    VIEW_COLUMN = 'view-column',
    VIEW_COMFORTABLE = 'view-comfortable',
    VIEW_COMFY = 'view-comfy',
    VIEW_COMPACT = 'view-compact',
    VIEW_DAY = 'view-day',
    VIEW_HEADLINE = 'view-headline',
    VIEW_IN_AR = 'view-in-ar',
    VIEW_LIST = 'view-list',
    VIEW_MODULE = 'view-module',
    VIEW_QUILT = 'view-quilt',
    VIEW_SIDEBAR = 'view-sidebar',
    VIEW_STREAM = 'view-stream',
    VIEW_WEEK = 'view-week',
    VIGNETTE = 'vignette',
    VISIBILITY = 'visibility',
    VISIBILITY_OFF = 'visibility-off',
    VOICE_CHAT = 'voice-chat',
    VOICE_OVER_OFF = 'voice-over-off',
    VOICEMAIL = 'voicemail',
    VOLUME_DOWN = 'volume-down',
    VOLUME_MUTE = 'volume-mute',
    VOLUME_OFF = 'volume-off',
    VOLUME_UP = 'volume-up',
    VOLUNTEER_ACTIVISM = 'volunteer-activism',
    VPN_KEY = 'vpn-key',
    VPN_LOCK = 'vpn-lock',
    WALLET_GIFTCARD = 'wallet-giftcard',
    WALLET_MEMBERSHIP = 'wallet-membership',
    WALLET_TRAVEL = 'wallet-travel',
    WALLPAPER = 'wallpaper',
    WARNING = 'warning',
    WASH = 'wash',
    WATCH = 'watch',
    WATCH_LATER = 'watch-later',
    WATER_DAMAGE = 'water-damage',
    WATERFALL_CHART = 'waterfall-chart',
    WAVES = 'waves',
    WB_AUTO = 'wb-auto',
    WB_CLOUDY = 'wb-cloudy',
    WB_INCANDESCENT = 'wb-incandescent',
    WB_IRIDESCENT = 'wb-iridescent',
    WB_SHADE = 'wb-shade',
    WB_SUNNY = 'wb-sunny',
    WB_TWIGHLIGHT = 'wb-twighlight',
    WC = 'wc',
    WEB = 'web',
    WEB_ASSET = 'web-asset',
    WEEKEND = 'weekend',
    WEST = 'west',
    WHATSHOT = 'whatshot',
    WHEELCHAIR_PICKUP = 'wheelchair-pickup',
    WHERE_TO_VOTE = 'where-to-vote',
    WIDGETS = 'widgets',
    WIFI = 'wifi',
    WIFI_CALLING = 'wifi-calling',
    WIFI_LOCK = 'wifi-lock',
    WIFI_OFF = 'wifi-off',
    WIFI_PROTECTED_SETUP = 'wifi-protected-setup',
    WIFI_TETHERING = 'wifi-tethering',
    WINE_BAR = 'wine-bar',
    WORK = 'work',
    WORK_OFF = 'work-off',
    WORK_OUTLINE = 'work-outline',
    WORKSPACES_FILLED = 'workspaces-filled',
    WORKSPACES_OUTLINE = 'workspaces-outline',
    WRAP_TEXT = 'wrap-text',
    WRONG_LOCATION = 'wrong-location',
    WYSIWYG = 'wysiwyg',
    YOUTUBE_SEARCHED_FOR = 'youtube-searched-for',
    ZOOM_IN = 'zoom-in',
    ZOOM_OUT = 'zoom-out',
    ZOOM_OUT_MAP = 'zoom-out-map'
}

export enum MenuItemType {
    NEWS = 'NEWS',
    CONTENT = 'CONTENT',
    LINK = 'LINK',
    CUSTOMIZED_PAGE = 'CUSTOMIZED_PAGE',
    SCHEDULE = 'SCHEDULE',
    MY_SCHEDULE = 'MY_SCHEDULE',
    FLOORPLAN = 'FLOORPLAN',
    SEARCH = 'SEARCH',
    NOTES = 'NOTES',
    POLL = 'POLL',
    NOW = 'NOW',
    SPONSORS = 'SPONSORS',
    SETTINGS = 'SETTINGS',
    PEOPLE = 'PEOPLE'
}

export type MenuItem = {
    id: string;
    title: string;
    order: number;
    icon: Icon | null;
    type: MenuItemType;
    data: string | null;
    visibility: string;
};

export type Menu = {
    id: string;
    title: string;
    order: number;
    type: MenuType;
    isSidebar: boolean;
    createdAt: string;
    updatedAt: string;
    /**
     * Array of menu items
     */
    items: Array<MenuItem>;
};

export enum FileType {
    ICON = 'ICON',
    IMG = 'IMG',
    DOC = 'DOC',
    QUILL_IMAGE = 'QUILL_IMAGE'
}

export type File = {
    id: string;
    file_name: string;
    type: FileType;
    width: number | null;
    height: number | null;
    createdAt: string;
    updatedAt: string;
};

export type Congress = {
    id: string;
    congId: number;
    name: string;
    from: number;
    to: number;
    hidden: boolean;
    status: boolean;
    coverId: string;
    color: string | null;
    textColor: string | null;
    source: string | null;
    settings: string | null;
    isAbstractQaEnabled: boolean;
    isAbstractRatingEnabled: boolean;
    isSectionQaEnabled: boolean;
    isSectionRatingEnabled: boolean;
    sectionLeftTemplate: string;
    sectionRightTemplate: string;
    abstractLeftTemplate: string;
    abstractRightTemplate: string;
    displayPosterDay: boolean;
    displaySectionGroup: boolean;
    createdAt: string;
    updatedAt: string;
    cover: (File) | null;
    timezone: string;
};

export type SocietyData = {
    menu: Array<Menu>;
    congress: Array<Congress>;
};

export type CreateMenuDto = {
    congressId?: string;
    title: string;
    order: number;
    type: 'TILES' | 'LIST';
    isSidebar?: boolean;
};

export enum type {
    TILES = 'TILES',
    LIST = 'LIST'
}

export type UpdateMenuItemsOrderDto = {
    newIndex: number;
    oldIndex: number;
};

export type UpdateMenuDto = {
    congressId?: string;
    title?: string;
    order?: number;
    type?: 'TILES' | 'LIST';
    isSidebar?: boolean;
};

export type CreateMenuItemDto = {
    title: string;
    icon: '360' | '10k' | '10mp' | '11mp' | '12mp' | '13mp' | '14mp' | '15mp' | '16mp' | '17mp' | '18mp' | '19mp' | '1k' | '1k-plus' | '20mp' | '21mp' | '22mp' | '23mp' | '24mp' | '2k' | '2k-plus' | '2mp' | '3d-rotation' | '3k' | '3k-plus' | '3mp' | '4k' | '4k-plus' | '4mp' | '5g' | '5k' | '5k-plus' | '5mp' | '6-ft-apart' | '6k' | '6k-plus' | '6mp' | '7k' | '7k-plus' | '7mp' | '8k' | '8k-plus' | '8mp' | '9k' | '9k-plus' | '9mp' | 'ac-unit' | 'access-alarm' | 'access-alarms' | 'access-time' | 'accessibility' | 'accessibility-new' | 'accessible' | 'accessible-forward' | 'account-balance' | 'account-balance-wallet' | 'account-box' | 'account-circle' | 'account-tree' | 'ad-units' | 'adb' | 'add' | 'add-a-photo' | 'add-alarm' | 'add-alert' | 'add-box' | 'add-business' | 'add-call' | 'add-chart' | 'add-circle' | 'add-circle-outline' | 'add-comment' | 'add-ic-call' | 'add-link' | 'add-location' | 'add-location-alt' | 'add-moderator' | 'add-photo-alternate' | 'add-road' | 'add-shopping-cart' | 'add-task' | 'add-to-drive' | 'add-to-home-screen' | 'add-to-photos' | 'add-to-queue' | 'addchart' | 'adjust' | 'admin-panel-settings' | 'agriculture' | 'airline-seat-flat' | 'airline-seat-flat-angled' | 'airline-seat-individual-suite' | 'airline-seat-legroom-extra' | 'airline-seat-legroom-normal' | 'airline-seat-legroom-reduced' | 'airline-seat-recline-extra' | 'airline-seat-recline-normal' | 'airplanemode-active' | 'airplanemode-inactive' | 'airplanemode-off' | 'airplanemode-on' | 'airplay' | 'airport-shuttle' | 'alarm' | 'alarm-add' | 'alarm-off' | 'alarm-on' | 'album' | 'align-horizontal-center' | 'align-horizontal-left' | 'align-horizontal-right' | 'align-vertical-bottom' | 'align-vertical-center' | 'align-vertical-top' | 'all-inbox' | 'all-inclusive' | 'all-out' | 'alt-route' | 'alternate-email' | 'amp-stories' | 'analytics' | 'anchor' | 'android' | 'animation' | 'announcement' | 'apartment' | 'api' | 'app-blocking' | 'app-registration' | 'app-settings-alt' | 'approval' | 'apps' | 'architecture' | 'archive' | 'arrow-back' | 'arrow-back-ios' | 'arrow-circle-down' | 'arrow-circle-up' | 'arrow-downward' | 'arrow-drop-down' | 'arrow-drop-down-circle' | 'arrow-drop-up' | 'arrow-forward' | 'arrow-forward-ios' | 'arrow-left' | 'arrow-right' | 'arrow-right-alt' | 'arrow-upward' | 'art-track' | 'article' | 'aspect-ratio' | 'assessment' | 'assignment' | 'assignment-ind' | 'assignment-late' | 'assignment-return' | 'assignment-returned' | 'assignment-turned-in' | 'assistant' | 'assistant-direction' | 'assistant-navigation' | 'assistant-photo' | 'atm' | 'attach-email' | 'attach-file' | 'attach-money' | 'attachment' | 'attractions' | 'audiotrack' | 'auto-awesome' | 'auto-awesome-mosaic' | 'auto-awesome-motion' | 'auto-delete' | 'auto-fix-high' | 'auto-fix-normal' | 'auto-fix-off' | 'auto-stories' | 'autorenew' | 'av-timer' | 'baby-changing-station' | 'backpack' | 'backspace' | 'backup' | 'backup-table' | 'badge' | 'bakery-dining' | 'ballot' | 'bar-chart' | 'batch-prediction' | 'bathtub' | 'battery-alert' | 'battery-charging-full' | 'battery-full' | 'battery-std' | 'battery-unknown' | 'beach-access' | 'bedtime' | 'beenhere' | 'bento' | 'bike-scooter' | 'biotech' | 'block' | 'block-flipped' | 'bluetooth' | 'bluetooth-audio' | 'bluetooth-connected' | 'bluetooth-disabled' | 'bluetooth-searching' | 'blur-circular' | 'blur-linear' | 'blur-off' | 'blur-on' | 'bolt' | 'book' | 'book-online' | 'bookmark' | 'bookmark-border' | 'bookmark-outline' | 'bookmarks' | 'border-all' | 'border-bottom' | 'border-clear' | 'border-color' | 'border-horizontal' | 'border-inner' | 'border-left' | 'border-outer' | 'border-right' | 'border-style' | 'border-top' | 'border-vertical' | 'branding-watermark' | 'breakfast-dining' | 'brightness-1' | 'brightness-2' | 'brightness-3' | 'brightness-4' | 'brightness-5' | 'brightness-6' | 'brightness-7' | 'brightness-auto' | 'brightness-high' | 'brightness-low' | 'brightness-medium' | 'broken-image' | 'browser-not-supported' | 'brunch-dining' | 'brush' | 'bubble-chart' | 'bug-report' | 'build' | 'build-circle' | 'burst-mode' | 'bus-alert' | 'business' | 'business-center' | 'cached' | 'cake' | 'calculate' | 'calendar-today' | 'calendar-view-day' | 'call' | 'call-end' | 'call-made' | 'call-merge' | 'call-missed' | 'call-missed-outgoing' | 'call-received' | 'call-split' | 'call-to-action' | 'camera' | 'camera-alt' | 'camera-enhance' | 'camera-front' | 'camera-rear' | 'camera-roll' | 'campaign' | 'cancel' | 'cancel-presentation' | 'cancel-schedule-send' | 'car-rental' | 'car-repair' | 'card-giftcard' | 'card-membership' | 'card-travel' | 'carpenter' | 'cases' | 'casino' | 'cast' | 'cast-connected' | 'cast-for-education' | 'category' | 'celebration' | 'cell-wifi' | 'center-focus-strong' | 'center-focus-weak' | 'change-history' | 'charging-station' | 'chat' | 'chat-bubble' | 'chat-bubble-outline' | 'check' | 'check-box' | 'check-box-outline-blank' | 'check-circle' | 'check-circle-outline' | 'checkroom' | 'chevron-left' | 'chevron-right' | 'child-care' | 'child-friendly' | 'chrome-reader-mode' | 'circle' | 'circle-notifications' | 'class' | 'clean-hands' | 'cleaning-services' | 'clear' | 'clear-all' | 'close' | 'close-fullscreen' | 'closed-caption' | 'closed-caption-disabled' | 'closed-caption-off' | 'cloud' | 'cloud-circle' | 'cloud-done' | 'cloud-download' | 'cloud-off' | 'cloud-queue' | 'cloud-upload' | 'code' | 'collections' | 'collections-bookmark' | 'color-lens' | 'colorize' | 'comment' | 'comment-bank' | 'commute' | 'compare' | 'compare-arrows' | 'compass-calibration' | 'compress' | 'computer' | 'confirmation-num' | 'confirmation-number' | 'connect-without-contact' | 'connected-tv' | 'construction' | 'contact-mail' | 'contact-page' | 'contact-phone' | 'contact-support' | 'contactless' | 'contacts' | 'content-copy' | 'content-cut' | 'content-paste' | 'control-camera' | 'control-point' | 'control-point-duplicate' | 'copyright' | 'coronavirus' | 'corporate-fare' | 'countertops' | 'create' | 'create-new-folder' | 'credit-card' | 'crop' | 'crop-16-9' | 'crop-3-2' | 'crop-5-4' | 'crop-7-5' | 'crop-din' | 'crop-free' | 'crop-landscape' | 'crop-original' | 'crop-portrait' | 'crop-rotate' | 'crop-square' | 'dangerous' | 'dashboard' | 'dashboard-customize' | 'data-usage' | 'date-range' | 'deck' | 'dehaze' | 'delete' | 'delete-forever' | 'delete-outline' | 'delete-sweep' | 'delivery-dining' | 'departure-board' | 'description' | 'design-services' | 'desktop-access-disabled' | 'desktop-mac' | 'desktop-windows' | 'details' | 'developer-board' | 'developer-mode' | 'device-hub' | 'device-thermostat' | 'device-unknown' | 'devices' | 'devices-other' | 'dialer-sip' | 'dialpad' | 'dinner-dining' | 'directions' | 'directions-bike' | 'directions-boat' | 'directions-bus' | 'directions-car' | 'directions-ferry' | 'directions-off' | 'directions-railway' | 'directions-run' | 'directions-subway' | 'directions-train' | 'directions-transit' | 'directions-walk' | 'dirty-lens' | 'disabled-by-default' | 'disc-full' | 'dnd-forwardslash' | 'dns' | 'do-not-disturb' | 'do-not-disturb-alt' | 'do-not-disturb-off' | 'do-not-disturb-on' | 'do-not-step' | 'do-not-touch' | 'dock' | 'domain' | 'domain-disabled' | 'domain-verification' | 'done' | 'done-all' | 'done-outline' | 'donut-large' | 'donut-small' | 'double-arrow' | 'drafts' | 'drag-handle' | 'drag-indicator' | 'drive-eta' | 'drive-file-move' | 'drive-file-move-outline' | 'drive-file-rename-outline' | 'drive-folder-upload' | 'dry' | 'dry-cleaning' | 'duo' | 'dvr' | 'dynamic-feed' | 'dynamic-form' | 'east' | 'eco' | 'edit' | 'edit-attributes' | 'edit-location' | 'edit-off' | 'edit-road' | 'eject' | 'elderly' | 'electric-bike' | 'electric-car' | 'electric-moped' | 'electric-rickshaw' | 'electric-scooter' | 'electrical-services' | 'elevator' | 'email' | 'emoji-emotions' | 'emoji-events' | 'emoji-flags' | 'emoji-food-beverage' | 'emoji-nature' | 'emoji-objects' | 'emoji-people' | 'emoji-symbols' | 'emoji-transportation' | 'engineering' | 'enhance-photo-translate' | 'enhanced-encryption' | 'equalizer' | 'error' | 'error-outline' | 'escalator' | 'escalator-warning' | 'euro' | 'euro-symbol' | 'ev-station' | 'event' | 'event-available' | 'event-busy' | 'event-note' | 'event-seat' | 'exit-to-app' | 'expand' | 'expand-less' | 'expand-more' | 'explicit' | 'explore' | 'explore-off' | 'exposure' | 'exposure-minus-1' | 'exposure-minus-2' | 'exposure-neg-1' | 'exposure-neg-2' | 'exposure-plus-1' | 'exposure-plus-2' | 'exposure-zero' | 'extension' | 'face' | 'face-retouching-natural' | 'facebook' | 'fact-check' | 'family-restroom' | 'fast-forward' | 'fast-rewind' | 'fastfood' | 'favorite' | 'favorite-border' | 'favorite-outline' | 'featured-play-list' | 'featured-video' | 'feedback' | 'fence' | 'festival' | 'fiber-dvr' | 'fiber-manual-record' | 'fiber-new' | 'fiber-pin' | 'fiber-smart-record' | 'file-copy' | 'file-download' | 'file-download-done' | 'file-present' | 'file-upload' | 'filter' | 'filter-1' | 'filter-2' | 'filter-3' | 'filter-4' | 'filter-5' | 'filter-6' | 'filter-7' | 'filter-8' | 'filter-9' | 'filter-9-plus' | 'filter-alt' | 'filter-b-and-w' | 'filter-center-focus' | 'filter-drama' | 'filter-frames' | 'filter-hdr' | 'filter-list' | 'filter-list-alt' | 'filter-none' | 'filter-tilt-shift' | 'filter-vintage' | 'find-in-page' | 'find-replace' | 'fingerprint' | 'fire-extinguisher' | 'fire-hydrant' | 'fireplace' | 'first-page' | 'fit-screen' | 'fitness-center' | 'flag' | 'flaky' | 'flare' | 'flash-auto' | 'flash-off' | 'flash-on' | 'flight' | 'flight-land' | 'flight-takeoff' | 'flip' | 'flip-camera-android' | 'flip-camera-ios' | 'flip-to-back' | 'flip-to-front' | 'folder' | 'folder-open' | 'folder-shared' | 'folder-special' | 'follow-the-signs' | 'font-download' | 'food-bank' | 'format-align-center' | 'format-align-justify' | 'format-align-left' | 'format-align-right' | 'format-bold' | 'format-clear' | 'format-color-fill' | 'format-color-reset' | 'format-color-text' | 'format-indent-decrease' | 'format-indent-increase' | 'format-italic' | 'format-line-spacing' | 'format-list-bulleted' | 'format-list-numbered' | 'format-list-numbered-rtl' | 'format-paint' | 'format-quote' | 'format-shapes' | 'format-size' | 'format-strikethrough' | 'format-textdirection-l-to-r' | 'format-textdirection-r-to-l' | 'format-underline' | 'format-underlined' | 'forum' | 'forward' | 'forward-10' | 'forward-30' | 'forward-5' | 'forward-to-inbox' | 'foundation' | 'free-breakfast' | 'fullscreen' | 'fullscreen-exit' | 'functions' | 'g-translate' | 'gamepad' | 'games' | 'gavel' | 'gesture' | 'get-app' | 'gif' | 'goat' | 'golf-course' | 'gps-fixed' | 'gps-not-fixed' | 'gps-off' | 'grade' | 'gradient' | 'grading' | 'grain' | 'graphic-eq' | 'grass' | 'grid-off' | 'grid-on' | 'grid-view' | 'group' | 'group-add' | 'group-work' | 'groups' | 'hail' | 'handyman' | 'hardware' | 'hd' | 'hdr-enhanced-select' | 'hdr-off' | 'hdr-on' | 'hdr-strong' | 'hdr-weak' | 'headset' | 'headset-mic' | 'headset-off' | 'healing' | 'hearing' | 'hearing-disabled' | 'height' | 'help' | 'help-center' | 'help-outline' | 'high-quality' | 'highlight' | 'highlight-alt' | 'highlight-off' | 'highlight-remove' | 'history' | 'history-edu' | 'history-toggle-off' | 'home' | 'home-filled' | 'home-repair-service' | 'home-work' | 'horizontal-distribute' | 'horizontal-rule' | 'horizontal-split' | 'hot-tub' | 'hotel' | 'hourglass-bottom' | 'hourglass-disabled' | 'hourglass-empty' | 'hourglass-full' | 'hourglass-top' | 'house' | 'house-siding' | 'how-to-reg' | 'how-to-vote' | 'http' | 'https' | 'hvac' | 'icecream' | 'image' | 'image-aspect-ratio' | 'image-not-supported' | 'image-search' | 'imagesearch-roller' | 'import-contacts' | 'import-export' | 'important-devices' | 'inbox' | 'indeterminate-check-box' | 'info' | 'info-outline' | 'input' | 'insert-chart' | 'insert-chart-outlined' | 'insert-comment' | 'insert-drive-file' | 'insert-emoticon' | 'insert-invitation' | 'insert-link' | 'insert-photo' | 'insights' | 'integration-instructions' | 'inventory' | 'invert-colors' | 'invert-colors-off' | 'invert-colors-on' | 'ios-share' | 'iso' | 'keyboard' | 'keyboard-arrow-down' | 'keyboard-arrow-left' | 'keyboard-arrow-right' | 'keyboard-arrow-up' | 'keyboard-backspace' | 'keyboard-capslock' | 'keyboard-control' | 'keyboard-hide' | 'keyboard-return' | 'keyboard-tab' | 'keyboard-voice' | 'king-bed' | 'kitchen' | 'label' | 'label-important' | 'label-important-outline' | 'label-off' | 'label-outline' | 'landscape' | 'language' | 'laptop' | 'laptop-chromebook' | 'laptop-mac' | 'laptop-windows' | 'last-page' | 'launch' | 'layers' | 'layers-clear' | 'leaderboard' | 'leak-add' | 'leak-remove' | 'leave-bags-at-home' | 'legend-toggle' | 'lens' | 'library-add' | 'library-add-check' | 'library-books' | 'library-music' | 'lightbulb' | 'lightbulb-outline' | 'line-style' | 'line-weight' | 'linear-scale' | 'link' | 'link-off' | 'linked-camera' | 'liquor' | 'list' | 'list-alt' | 'live-help' | 'live-tv' | 'local-activity' | 'local-airport' | 'local-atm' | 'local-attraction' | 'local-bar' | 'local-cafe' | 'local-car-wash' | 'local-convenience-store' | 'local-dining' | 'local-drink' | 'local-fire-department' | 'local-florist' | 'local-gas-station' | 'local-grocery-store' | 'local-hospital' | 'local-hotel' | 'local-laundry-service' | 'local-library' | 'local-mall' | 'local-movies' | 'local-offer' | 'local-parking' | 'local-pharmacy' | 'local-phone' | 'local-pizza' | 'local-play' | 'local-police' | 'local-post-office' | 'local-print-shop' | 'local-printshop' | 'local-restaurant' | 'local-see' | 'local-shipping' | 'local-taxi' | 'location-city' | 'location-disabled' | 'location-history' | 'location-off' | 'location-on' | 'location-pin' | 'location-searching' | 'lock' | 'lock-clock' | 'lock-open' | 'lock-outline' | 'login' | 'logout' | 'looks' | 'looks-3' | 'looks-4' | 'looks-5' | 'looks-6' | 'looks-one' | 'looks-two' | 'loop' | 'loupe' | 'low-priority' | 'loyalty' | 'luggage' | 'lunch-dining' | 'mail' | 'mail-outline' | 'map' | 'maps-ugc' | 'margin' | 'mark-as-unread' | 'mark-chat-read' | 'mark-chat-unread' | 'mark-email-read' | 'mark-email-unread' | 'markunread' | 'markunread-mailbox' | 'masks' | 'maximize' | 'mediation' | 'medical-services' | 'meeting-room' | 'memory' | 'menu' | 'menu-book' | 'menu-open' | 'merge-type' | 'message' | 'messenger' | 'messenger-outline' | 'mic' | 'mic-external-off' | 'mic-external-on' | 'mic-none' | 'mic-off' | 'microwave' | 'military-tech' | 'minimize' | 'miscellaneous-services' | 'missed-video-call' | 'mms' | 'mobile-friendly' | 'mobile-off' | 'mobile-screen-share' | 'mode-comment' | 'mode-edit' | 'model-training' | 'monetization-on' | 'money' | 'money-off' | 'monitor' | 'monochrome-photos' | 'mood' | 'mood-bad' | 'moped' | 'more' | 'more-horiz' | 'more-time' | 'more-vert' | 'motion-photos-off' | 'motion-photos-on' | 'motion-photos-pause' | 'motion-photos-paused' | 'motorcycle' | 'mouse' | 'move-to-inbox' | 'movie' | 'movie-creation' | 'movie-filter' | 'mp' | 'multiline-chart' | 'multiple-stop' | 'multitrack-audio' | 'museum' | 'music-note' | 'music-off' | 'music-video' | 'my-library-add' | 'my-library-books' | 'my-library-music' | 'my-location' | 'nat' | 'nature' | 'nature-people' | 'navigate-before' | 'navigate-next' | 'navigation' | 'near-me' | 'near-me-disabled' | 'network-cell' | 'network-check' | 'network-locked' | 'network-wifi' | 'new-releases' | 'next-plan' | 'next-week' | 'nfc' | 'night-shelter' | 'nightlife' | 'nightlight-round' | 'nights-stay' | 'no-backpack' | 'no-cell' | 'no-drinks' | 'no-encryption' | 'no-flash' | 'no-food' | 'no-luggage' | 'no-meals' | 'no-meals-ouline' | 'no-meeting-room' | 'no-photography' | 'no-sim' | 'no-stroller' | 'no-transfer' | 'north' | 'north-east' | 'north-west' | 'not-accessible' | 'not-interested' | 'not-listed-location' | 'not-started' | 'note' | 'note-add' | 'notes' | 'notification-important' | 'notifications' | 'notifications-active' | 'notifications-none' | 'notifications-off' | 'notifications-on' | 'notifications-paused' | 'now-wallpaper' | 'now-widgets' | 'offline-bolt' | 'offline-pin' | 'offline-share' | 'ondemand-video' | 'online-prediction' | 'opacity' | 'open-in-browser' | 'open-in-full' | 'open-in-new' | 'open-with' | 'outbond' | 'outbox' | 'outdoor-grill' | 'outgoing-mail' | 'outlet' | 'outlined-flag' | 'padding' | 'pages' | 'pageview' | 'palette' | 'pan-tool' | 'panorama' | 'panorama-fish-eye' | 'panorama-fisheye' | 'panorama-horizontal' | 'panorama-horizontal-select' | 'panorama-photosphere' | 'panorama-photosphere-select' | 'panorama-vertical' | 'panorama-vertical-select' | 'panorama-wide-angle' | 'panorama-wide-angle-select' | 'park' | 'party-mode' | 'pause' | 'pause-circle-filled' | 'pause-circle-outline' | 'pause-presentation' | 'payment' | 'payments' | 'pedal-bike' | 'pending' | 'pending-actions' | 'people' | 'people-alt' | 'people-outline' | 'perm-camera-mic' | 'perm-contact-cal' | 'perm-contact-calendar' | 'perm-data-setting' | 'perm-device-info' | 'perm-device-information' | 'perm-identity' | 'perm-media' | 'perm-phone-msg' | 'perm-scan-wifi' | 'person' | 'person-add' | 'person-add-alt' | 'person-add-alt-1' | 'person-add-disabled' | 'person-outline' | 'person-pin' | 'person-pin-circle' | 'person-remove' | 'person-remove-alt-1' | 'person-search' | 'personal-video' | 'pest-control' | 'pest-control-rodent' | 'pets' | 'phone' | 'phone-android' | 'phone-bluetooth-speaker' | 'phone-callback' | 'phone-disabled' | 'phone-enabled' | 'phone-forwarded' | 'phone-in-talk' | 'phone-iphone' | 'phone-locked' | 'phone-missed' | 'phone-paused' | 'phonelink' | 'phonelink-erase' | 'phonelink-lock' | 'phonelink-off' | 'phonelink-ring' | 'phonelink-setup' | 'photo' | 'photo-album' | 'photo-camera' | 'photo-camera-back' | 'photo-camera-front' | 'photo-filter' | 'photo-library' | 'photo-size-select-actual' | 'photo-size-select-large' | 'photo-size-select-small' | 'picture-as-pdf' | 'picture-in-picture' | 'picture-in-picture-alt' | 'pie-chart' | 'pie-chart-outlined' | 'pin-drop' | 'pivot-table-chart' | 'place' | 'plagiarism' | 'play-arrow' | 'play-circle-fill' | 'play-circle-filled' | 'play-circle-outline' | 'play-disabled' | 'play-for-work' | 'playlist-add' | 'playlist-add-check' | 'playlist-play' | 'plumbing' | 'plus-one' | 'point-of-sale' | 'policy' | 'poll' | 'polymer' | 'pool' | 'portable-wifi-off' | 'portrait' | 'post-add' | 'power' | 'power-input' | 'power-off' | 'power-settings-new' | 'pregnant-woman' | 'present-to-all' | 'preview' | 'print' | 'print-disabled' | 'priority-high' | 'privacy-tip' | 'psychology' | 'public' | 'public-off' | 'publish' | 'published-with-changes' | 'push-pin' | 'qr-code' | 'qr-code-2' | 'qr-code-scanner' | 'query-builder' | 'question-answer' | 'queue' | 'queue-music' | 'queue-play-next' | 'quick-contacts-dialer' | 'quick-contacts-mail' | 'quickreply' | 'radio' | 'radio-button-checked' | 'radio-button-off' | 'radio-button-on' | 'radio-button-unchecked' | 'railway-alert' | 'ramen-dining' | 'rate-review' | 'read-more' | 'receipt' | 'receipt-long' | 'recent-actors' | 'recommend' | 'record-voice-over' | 'redeem' | 'redo' | 'reduce-capacity' | 'refresh' | 'remove' | 'remove-circle' | 'remove-circle-outline' | 'remove-done' | 'remove-from-queue' | 'remove-moderator' | 'remove-red-eye' | 'remove-shopping-cart' | 'reorder' | 'repeat' | 'repeat-on' | 'repeat-one' | 'repeat-one-on' | 'replay' | 'replay-10' | 'replay-30' | 'replay-5' | 'replay-circle-filled' | 'reply' | 'reply-all' | 'report' | 'report-off' | 'report-problem' | 'request-page' | 'request-quote' | 'reset-tv' | 'restaurant' | 'restaurant-menu' | 'restore' | 'restore-from-trash' | 'restore-page' | 'rice-bowl' | 'ring-volume' | 'roofing' | 'room' | 'room-preferences' | 'room-service' | 'rotate-90-degrees-ccw' | 'rotate-left' | 'rotate-right' | 'rounded-corner' | 'router' | 'rowing' | 'rss-feed' | 'rtt' | 'rule' | 'rule-folder' | 'run-circle' | 'rv-hookup' | 'sanitizer' | 'satellite' | 'save' | 'save-alt' | 'saved-search' | 'scanner' | 'scatter-plot' | 'schedule' | 'schedule-send' | 'school' | 'science' | 'score' | 'screen-lock-landscape' | 'screen-lock-portrait' | 'screen-lock-rotation' | 'screen-rotation' | 'screen-search-desktop' | 'screen-share' | 'sd' | 'sd-card' | 'sd-storage' | 'search' | 'search-off' | 'security' | 'segment' | 'select-all' | 'self-improvement' | 'send' | 'send-and-archive' | 'send-to-mobile' | 'sensor-door' | 'sensor-window' | 'sentiment-dissatisfied' | 'sentiment-neutral' | 'sentiment-satisfied' | 'sentiment-satisfied-alt' | 'sentiment-very-dissatisfied' | 'sentiment-very-satisfied' | 'set-meal' | 'settings' | 'settings-applications' | 'settings-backup-restore' | 'settings-bluetooth' | 'settings-brightness' | 'settings-cell' | 'settings-display' | 'settings-ethernet' | 'settings-input-antenna' | 'settings-input-component' | 'settings-input-composite' | 'settings-input-hdmi' | 'settings-input-svideo' | 'settings-overscan' | 'settings-phone' | 'settings-power' | 'settings-remote' | 'settings-system-daydream' | 'settings-voice' | 'share' | 'shield' | 'shop' | 'shop-two' | 'shopping-bag' | 'shopping-basket' | 'shopping-cart' | 'short-text' | 'show-chart' | 'shuffle' | 'shuffle-on' | 'shutter-speed' | 'sick' | 'signal-cellular-0-bar' | 'signal-cellular-4-bar' | 'signal-cellular-alt' | 'signal-cellular-connected-no-internet-4-bar' | 'signal-cellular-no-sim' | 'signal-cellular-null' | 'signal-cellular-off' | 'signal-wifi-0-bar' | 'signal-wifi-4-bar' | 'signal-wifi-4-bar-lock' | 'signal-wifi-off' | 'sim-card' | 'sim-card-alert' | 'single-bed' | 'skip-next' | 'skip-previous' | 'slideshow' | 'slow-motion-video' | 'smart-button' | 'smartphone' | 'smoke-free' | 'smoking-rooms' | 'sms' | 'sms-failed' | 'snippet-folder' | 'snooze' | 'soap' | 'sort' | 'sort-by-alpha' | 'source' | 'south' | 'south-east' | 'south-west' | 'spa' | 'space-bar' | 'speaker' | 'speaker-group' | 'speaker-notes' | 'speaker-notes-off' | 'speaker-phone' | 'speed' | 'spellcheck' | 'sports' | 'sports-bar' | 'sports-baseball' | 'sports-basketball' | 'sports-cricket' | 'sports-esports' | 'sports-football' | 'sports-golf' | 'sports-handball' | 'sports-hockey' | 'sports-kabaddi' | 'sports-mma' | 'sports-motorsports' | 'sports-rugby' | 'sports-soccer' | 'sports-tennis' | 'sports-volleyball' | 'square-foot' | 'stacked-bar-chart' | 'stacked-line-chart' | 'stairs' | 'star' | 'star-border' | 'star-half' | 'star-outline' | 'star-rate' | 'stars' | 'stay-current-landscape' | 'stay-current-portrait' | 'stay-primary-landscape' | 'stay-primary-portrait' | 'sticky-note-2' | 'stop' | 'stop-circle' | 'stop-screen-share' | 'storage' | 'store' | 'store-mall-directory' | 'storefront' | 'straighten' | 'stream' | 'streetview' | 'strikethrough-s' | 'stroller' | 'style' | 'subdirectory-arrow-left' | 'subdirectory-arrow-right' | 'subject' | 'subscript' | 'subscriptions' | 'subtitles' | 'subtitles-off' | 'subway' | 'superscript' | 'supervised-user-circle' | 'supervisor-account' | 'support' | 'support-agent' | 'surround-sound' | 'swap-calls' | 'swap-horiz' | 'swap-horizontal-circle' | 'swap-vert' | 'swap-vert-circle' | 'swap-vertical-circle' | 'swipe' | 'switch-account' | 'switch-camera' | 'switch-left' | 'switch-right' | 'switch-video' | 'sync' | 'sync-alt' | 'sync-disabled' | 'sync-problem' | 'system-update' | 'system-update-alt' | 'system-update-tv' | 'tab' | 'tab-unselected' | 'table-chart' | 'table-rows' | 'table-view' | 'tablet' | 'tablet-android' | 'tablet-mac' | 'tag' | 'tag-faces' | 'takeout-dining' | 'tap-and-play' | 'tapas' | 'taxi-alert' | 'terrain' | 'text-fields' | 'text-format' | 'text-rotate-up' | 'text-rotate-vertical' | 'text-rotation-angledown' | 'text-rotation-angleup' | 'text-rotation-down' | 'text-rotation-none' | 'text-snippet' | 'textsms' | 'texture' | 'theater-comedy' | 'theaters' | 'thumb-down' | 'thumb-down-alt' | 'thumb-down-off-alt' | 'thumb-up' | 'thumb-up-alt' | 'thumb-up-off-alt' | 'thumbs-up-down' | 'time-to-leave' | 'timelapse' | 'timeline' | 'timer' | 'timer-10' | 'timer-3' | 'timer-off' | 'title' | 'toc' | 'today' | 'toggle-off' | 'toggle-on' | 'toll' | 'tonality' | 'topic' | 'touch-app' | 'tour' | 'toys' | 'track-changes' | 'traffic' | 'train' | 'tram' | 'transfer-within-a-station' | 'transform' | 'transit-enterexit' | 'translate' | 'trending-down' | 'trending-flat' | 'trending-neutral' | 'trending-up' | 'trip-origin' | 'tty' | 'tune' | 'turned-in' | 'turned-in-not' | 'tv' | 'tv-off' | 'two-wheeler' | 'umbrella' | 'unarchive' | 'undo' | 'unfold-less' | 'unfold-more' | 'unpublished' | 'unsubscribe' | 'update' | 'update-disabled' | 'upgrade' | 'upload-file' | 'usb' | 'verified' | 'verified-user' | 'vertical-align-bottom' | 'vertical-align-center' | 'vertical-align-top' | 'vertical-distribute' | 'vertical-split' | 'vibration' | 'video-call' | 'video-collection' | 'video-label' | 'video-library' | 'video-settings' | 'videocam' | 'videocam-off' | 'videogame-asset' | 'view-agenda' | 'view-array' | 'view-carousel' | 'view-column' | 'view-comfortable' | 'view-comfy' | 'view-compact' | 'view-day' | 'view-headline' | 'view-in-ar' | 'view-list' | 'view-module' | 'view-quilt' | 'view-sidebar' | 'view-stream' | 'view-week' | 'vignette' | 'visibility' | 'visibility-off' | 'voice-chat' | 'voice-over-off' | 'voicemail' | 'volume-down' | 'volume-mute' | 'volume-off' | 'volume-up' | 'volunteer-activism' | 'vpn-key' | 'vpn-lock' | 'wallet-giftcard' | 'wallet-membership' | 'wallet-travel' | 'wallpaper' | 'warning' | 'wash' | 'watch' | 'watch-later' | 'water-damage' | 'waterfall-chart' | 'waves' | 'wb-auto' | 'wb-cloudy' | 'wb-incandescent' | 'wb-iridescent' | 'wb-shade' | 'wb-sunny' | 'wb-twighlight' | 'wc' | 'web' | 'web-asset' | 'weekend' | 'west' | 'whatshot' | 'wheelchair-pickup' | 'where-to-vote' | 'widgets' | 'wifi' | 'wifi-calling' | 'wifi-lock' | 'wifi-off' | 'wifi-protected-setup' | 'wifi-tethering' | 'wine-bar' | 'work' | 'work-off' | 'work-outline' | 'workspaces-filled' | 'workspaces-outline' | 'wrap-text' | 'wrong-location' | 'wysiwyg' | 'youtube-searched-for' | 'zoom-in' | 'zoom-out' | 'zoom-out-map' | null;
    type: 'NEWS' | 'CONTENT' | 'LINK' | 'CUSTOMIZED_PAGE' | 'SCHEDULE' | 'MY_SCHEDULE' | 'FLOORPLAN' | 'SEARCH' | 'NOTES' | 'POLL' | 'NOW' | 'SPONSORS' | 'SETTINGS' | 'PEOPLE';
    data: string | null;
    visibility?: string;
};

export enum icon {
    _360 = '360',
    _10K = '10k',
    _10MP = '10mp',
    _11MP = '11mp',
    _12MP = '12mp',
    _13MP = '13mp',
    _14MP = '14mp',
    _15MP = '15mp',
    _16MP = '16mp',
    _17MP = '17mp',
    _18MP = '18mp',
    _19MP = '19mp',
    _1K = '1k',
    _1K_PLUS = '1k-plus',
    _20MP = '20mp',
    _21MP = '21mp',
    _22MP = '22mp',
    _23MP = '23mp',
    _24MP = '24mp',
    _2K = '2k',
    _2K_PLUS = '2k-plus',
    _2MP = '2mp',
    _3D_ROTATION = '3d-rotation',
    _3K = '3k',
    _3K_PLUS = '3k-plus',
    _3MP = '3mp',
    _4K = '4k',
    _4K_PLUS = '4k-plus',
    _4MP = '4mp',
    _5G = '5g',
    _5K = '5k',
    _5K_PLUS = '5k-plus',
    _5MP = '5mp',
    _6_FT_APART = '6-ft-apart',
    _6K = '6k',
    _6K_PLUS = '6k-plus',
    _6MP = '6mp',
    _7K = '7k',
    _7K_PLUS = '7k-plus',
    _7MP = '7mp',
    _8K = '8k',
    _8K_PLUS = '8k-plus',
    _8MP = '8mp',
    _9K = '9k',
    _9K_PLUS = '9k-plus',
    _9MP = '9mp',
    AC_UNIT = 'ac-unit',
    ACCESS_ALARM = 'access-alarm',
    ACCESS_ALARMS = 'access-alarms',
    ACCESS_TIME = 'access-time',
    ACCESSIBILITY = 'accessibility',
    ACCESSIBILITY_NEW = 'accessibility-new',
    ACCESSIBLE = 'accessible',
    ACCESSIBLE_FORWARD = 'accessible-forward',
    ACCOUNT_BALANCE = 'account-balance',
    ACCOUNT_BALANCE_WALLET = 'account-balance-wallet',
    ACCOUNT_BOX = 'account-box',
    ACCOUNT_CIRCLE = 'account-circle',
    ACCOUNT_TREE = 'account-tree',
    AD_UNITS = 'ad-units',
    ADB = 'adb',
    ADD = 'add',
    ADD_A_PHOTO = 'add-a-photo',
    ADD_ALARM = 'add-alarm',
    ADD_ALERT = 'add-alert',
    ADD_BOX = 'add-box',
    ADD_BUSINESS = 'add-business',
    ADD_CALL = 'add-call',
    ADD_CHART = 'add-chart',
    ADD_CIRCLE = 'add-circle',
    ADD_CIRCLE_OUTLINE = 'add-circle-outline',
    ADD_COMMENT = 'add-comment',
    ADD_IC_CALL = 'add-ic-call',
    ADD_LINK = 'add-link',
    ADD_LOCATION = 'add-location',
    ADD_LOCATION_ALT = 'add-location-alt',
    ADD_MODERATOR = 'add-moderator',
    ADD_PHOTO_ALTERNATE = 'add-photo-alternate',
    ADD_ROAD = 'add-road',
    ADD_SHOPPING_CART = 'add-shopping-cart',
    ADD_TASK = 'add-task',
    ADD_TO_DRIVE = 'add-to-drive',
    ADD_TO_HOME_SCREEN = 'add-to-home-screen',
    ADD_TO_PHOTOS = 'add-to-photos',
    ADD_TO_QUEUE = 'add-to-queue',
    ADDCHART = 'addchart',
    ADJUST = 'adjust',
    ADMIN_PANEL_SETTINGS = 'admin-panel-settings',
    AGRICULTURE = 'agriculture',
    AIRLINE_SEAT_FLAT = 'airline-seat-flat',
    AIRLINE_SEAT_FLAT_ANGLED = 'airline-seat-flat-angled',
    AIRLINE_SEAT_INDIVIDUAL_SUITE = 'airline-seat-individual-suite',
    AIRLINE_SEAT_LEGROOM_EXTRA = 'airline-seat-legroom-extra',
    AIRLINE_SEAT_LEGROOM_NORMAL = 'airline-seat-legroom-normal',
    AIRLINE_SEAT_LEGROOM_REDUCED = 'airline-seat-legroom-reduced',
    AIRLINE_SEAT_RECLINE_EXTRA = 'airline-seat-recline-extra',
    AIRLINE_SEAT_RECLINE_NORMAL = 'airline-seat-recline-normal',
    AIRPLANEMODE_ACTIVE = 'airplanemode-active',
    AIRPLANEMODE_INACTIVE = 'airplanemode-inactive',
    AIRPLANEMODE_OFF = 'airplanemode-off',
    AIRPLANEMODE_ON = 'airplanemode-on',
    AIRPLAY = 'airplay',
    AIRPORT_SHUTTLE = 'airport-shuttle',
    ALARM = 'alarm',
    ALARM_ADD = 'alarm-add',
    ALARM_OFF = 'alarm-off',
    ALARM_ON = 'alarm-on',
    ALBUM = 'album',
    ALIGN_HORIZONTAL_CENTER = 'align-horizontal-center',
    ALIGN_HORIZONTAL_LEFT = 'align-horizontal-left',
    ALIGN_HORIZONTAL_RIGHT = 'align-horizontal-right',
    ALIGN_VERTICAL_BOTTOM = 'align-vertical-bottom',
    ALIGN_VERTICAL_CENTER = 'align-vertical-center',
    ALIGN_VERTICAL_TOP = 'align-vertical-top',
    ALL_INBOX = 'all-inbox',
    ALL_INCLUSIVE = 'all-inclusive',
    ALL_OUT = 'all-out',
    ALT_ROUTE = 'alt-route',
    ALTERNATE_EMAIL = 'alternate-email',
    AMP_STORIES = 'amp-stories',
    ANALYTICS = 'analytics',
    ANCHOR = 'anchor',
    ANDROID = 'android',
    ANIMATION = 'animation',
    ANNOUNCEMENT = 'announcement',
    APARTMENT = 'apartment',
    API = 'api',
    APP_BLOCKING = 'app-blocking',
    APP_REGISTRATION = 'app-registration',
    APP_SETTINGS_ALT = 'app-settings-alt',
    APPROVAL = 'approval',
    APPS = 'apps',
    ARCHITECTURE = 'architecture',
    ARCHIVE = 'archive',
    ARROW_BACK = 'arrow-back',
    ARROW_BACK_IOS = 'arrow-back-ios',
    ARROW_CIRCLE_DOWN = 'arrow-circle-down',
    ARROW_CIRCLE_UP = 'arrow-circle-up',
    ARROW_DOWNWARD = 'arrow-downward',
    ARROW_DROP_DOWN = 'arrow-drop-down',
    ARROW_DROP_DOWN_CIRCLE = 'arrow-drop-down-circle',
    ARROW_DROP_UP = 'arrow-drop-up',
    ARROW_FORWARD = 'arrow-forward',
    ARROW_FORWARD_IOS = 'arrow-forward-ios',
    ARROW_LEFT = 'arrow-left',
    ARROW_RIGHT = 'arrow-right',
    ARROW_RIGHT_ALT = 'arrow-right-alt',
    ARROW_UPWARD = 'arrow-upward',
    ART_TRACK = 'art-track',
    ARTICLE = 'article',
    ASPECT_RATIO = 'aspect-ratio',
    ASSESSMENT = 'assessment',
    ASSIGNMENT = 'assignment',
    ASSIGNMENT_IND = 'assignment-ind',
    ASSIGNMENT_LATE = 'assignment-late',
    ASSIGNMENT_RETURN = 'assignment-return',
    ASSIGNMENT_RETURNED = 'assignment-returned',
    ASSIGNMENT_TURNED_IN = 'assignment-turned-in',
    ASSISTANT = 'assistant',
    ASSISTANT_DIRECTION = 'assistant-direction',
    ASSISTANT_NAVIGATION = 'assistant-navigation',
    ASSISTANT_PHOTO = 'assistant-photo',
    ATM = 'atm',
    ATTACH_EMAIL = 'attach-email',
    ATTACH_FILE = 'attach-file',
    ATTACH_MONEY = 'attach-money',
    ATTACHMENT = 'attachment',
    ATTRACTIONS = 'attractions',
    AUDIOTRACK = 'audiotrack',
    AUTO_AWESOME = 'auto-awesome',
    AUTO_AWESOME_MOSAIC = 'auto-awesome-mosaic',
    AUTO_AWESOME_MOTION = 'auto-awesome-motion',
    AUTO_DELETE = 'auto-delete',
    AUTO_FIX_HIGH = 'auto-fix-high',
    AUTO_FIX_NORMAL = 'auto-fix-normal',
    AUTO_FIX_OFF = 'auto-fix-off',
    AUTO_STORIES = 'auto-stories',
    AUTORENEW = 'autorenew',
    AV_TIMER = 'av-timer',
    BABY_CHANGING_STATION = 'baby-changing-station',
    BACKPACK = 'backpack',
    BACKSPACE = 'backspace',
    BACKUP = 'backup',
    BACKUP_TABLE = 'backup-table',
    BADGE = 'badge',
    BAKERY_DINING = 'bakery-dining',
    BALLOT = 'ballot',
    BAR_CHART = 'bar-chart',
    BATCH_PREDICTION = 'batch-prediction',
    BATHTUB = 'bathtub',
    BATTERY_ALERT = 'battery-alert',
    BATTERY_CHARGING_FULL = 'battery-charging-full',
    BATTERY_FULL = 'battery-full',
    BATTERY_STD = 'battery-std',
    BATTERY_UNKNOWN = 'battery-unknown',
    BEACH_ACCESS = 'beach-access',
    BEDTIME = 'bedtime',
    BEENHERE = 'beenhere',
    BENTO = 'bento',
    BIKE_SCOOTER = 'bike-scooter',
    BIOTECH = 'biotech',
    BLOCK = 'block',
    BLOCK_FLIPPED = 'block-flipped',
    BLUETOOTH = 'bluetooth',
    BLUETOOTH_AUDIO = 'bluetooth-audio',
    BLUETOOTH_CONNECTED = 'bluetooth-connected',
    BLUETOOTH_DISABLED = 'bluetooth-disabled',
    BLUETOOTH_SEARCHING = 'bluetooth-searching',
    BLUR_CIRCULAR = 'blur-circular',
    BLUR_LINEAR = 'blur-linear',
    BLUR_OFF = 'blur-off',
    BLUR_ON = 'blur-on',
    BOLT = 'bolt',
    BOOK = 'book',
    BOOK_ONLINE = 'book-online',
    BOOKMARK = 'bookmark',
    BOOKMARK_BORDER = 'bookmark-border',
    BOOKMARK_OUTLINE = 'bookmark-outline',
    BOOKMARKS = 'bookmarks',
    BORDER_ALL = 'border-all',
    BORDER_BOTTOM = 'border-bottom',
    BORDER_CLEAR = 'border-clear',
    BORDER_COLOR = 'border-color',
    BORDER_HORIZONTAL = 'border-horizontal',
    BORDER_INNER = 'border-inner',
    BORDER_LEFT = 'border-left',
    BORDER_OUTER = 'border-outer',
    BORDER_RIGHT = 'border-right',
    BORDER_STYLE = 'border-style',
    BORDER_TOP = 'border-top',
    BORDER_VERTICAL = 'border-vertical',
    BRANDING_WATERMARK = 'branding-watermark',
    BREAKFAST_DINING = 'breakfast-dining',
    BRIGHTNESS_1 = 'brightness-1',
    BRIGHTNESS_2 = 'brightness-2',
    BRIGHTNESS_3 = 'brightness-3',
    BRIGHTNESS_4 = 'brightness-4',
    BRIGHTNESS_5 = 'brightness-5',
    BRIGHTNESS_6 = 'brightness-6',
    BRIGHTNESS_7 = 'brightness-7',
    BRIGHTNESS_AUTO = 'brightness-auto',
    BRIGHTNESS_HIGH = 'brightness-high',
    BRIGHTNESS_LOW = 'brightness-low',
    BRIGHTNESS_MEDIUM = 'brightness-medium',
    BROKEN_IMAGE = 'broken-image',
    BROWSER_NOT_SUPPORTED = 'browser-not-supported',
    BRUNCH_DINING = 'brunch-dining',
    BRUSH = 'brush',
    BUBBLE_CHART = 'bubble-chart',
    BUG_REPORT = 'bug-report',
    BUILD = 'build',
    BUILD_CIRCLE = 'build-circle',
    BURST_MODE = 'burst-mode',
    BUS_ALERT = 'bus-alert',
    BUSINESS = 'business',
    BUSINESS_CENTER = 'business-center',
    CACHED = 'cached',
    CAKE = 'cake',
    CALCULATE = 'calculate',
    CALENDAR_TODAY = 'calendar-today',
    CALENDAR_VIEW_DAY = 'calendar-view-day',
    CALL = 'call',
    CALL_END = 'call-end',
    CALL_MADE = 'call-made',
    CALL_MERGE = 'call-merge',
    CALL_MISSED = 'call-missed',
    CALL_MISSED_OUTGOING = 'call-missed-outgoing',
    CALL_RECEIVED = 'call-received',
    CALL_SPLIT = 'call-split',
    CALL_TO_ACTION = 'call-to-action',
    CAMERA = 'camera',
    CAMERA_ALT = 'camera-alt',
    CAMERA_ENHANCE = 'camera-enhance',
    CAMERA_FRONT = 'camera-front',
    CAMERA_REAR = 'camera-rear',
    CAMERA_ROLL = 'camera-roll',
    CAMPAIGN = 'campaign',
    CANCEL = 'cancel',
    CANCEL_PRESENTATION = 'cancel-presentation',
    CANCEL_SCHEDULE_SEND = 'cancel-schedule-send',
    CAR_RENTAL = 'car-rental',
    CAR_REPAIR = 'car-repair',
    CARD_GIFTCARD = 'card-giftcard',
    CARD_MEMBERSHIP = 'card-membership',
    CARD_TRAVEL = 'card-travel',
    CARPENTER = 'carpenter',
    CASES = 'cases',
    CASINO = 'casino',
    CAST = 'cast',
    CAST_CONNECTED = 'cast-connected',
    CAST_FOR_EDUCATION = 'cast-for-education',
    CATEGORY = 'category',
    CELEBRATION = 'celebration',
    CELL_WIFI = 'cell-wifi',
    CENTER_FOCUS_STRONG = 'center-focus-strong',
    CENTER_FOCUS_WEAK = 'center-focus-weak',
    CHANGE_HISTORY = 'change-history',
    CHARGING_STATION = 'charging-station',
    CHAT = 'chat',
    CHAT_BUBBLE = 'chat-bubble',
    CHAT_BUBBLE_OUTLINE = 'chat-bubble-outline',
    CHECK = 'check',
    CHECK_BOX = 'check-box',
    CHECK_BOX_OUTLINE_BLANK = 'check-box-outline-blank',
    CHECK_CIRCLE = 'check-circle',
    CHECK_CIRCLE_OUTLINE = 'check-circle-outline',
    CHECKROOM = 'checkroom',
    CHEVRON_LEFT = 'chevron-left',
    CHEVRON_RIGHT = 'chevron-right',
    CHILD_CARE = 'child-care',
    CHILD_FRIENDLY = 'child-friendly',
    CHROME_READER_MODE = 'chrome-reader-mode',
    CIRCLE = 'circle',
    CIRCLE_NOTIFICATIONS = 'circle-notifications',
    CLASS = 'class',
    CLEAN_HANDS = 'clean-hands',
    CLEANING_SERVICES = 'cleaning-services',
    CLEAR = 'clear',
    CLEAR_ALL = 'clear-all',
    CLOSE = 'close',
    CLOSE_FULLSCREEN = 'close-fullscreen',
    CLOSED_CAPTION = 'closed-caption',
    CLOSED_CAPTION_DISABLED = 'closed-caption-disabled',
    CLOSED_CAPTION_OFF = 'closed-caption-off',
    CLOUD = 'cloud',
    CLOUD_CIRCLE = 'cloud-circle',
    CLOUD_DONE = 'cloud-done',
    CLOUD_DOWNLOAD = 'cloud-download',
    CLOUD_OFF = 'cloud-off',
    CLOUD_QUEUE = 'cloud-queue',
    CLOUD_UPLOAD = 'cloud-upload',
    CODE = 'code',
    COLLECTIONS = 'collections',
    COLLECTIONS_BOOKMARK = 'collections-bookmark',
    COLOR_LENS = 'color-lens',
    COLORIZE = 'colorize',
    COMMENT = 'comment',
    COMMENT_BANK = 'comment-bank',
    COMMUTE = 'commute',
    COMPARE = 'compare',
    COMPARE_ARROWS = 'compare-arrows',
    COMPASS_CALIBRATION = 'compass-calibration',
    COMPRESS = 'compress',
    COMPUTER = 'computer',
    CONFIRMATION_NUM = 'confirmation-num',
    CONFIRMATION_NUMBER = 'confirmation-number',
    CONNECT_WITHOUT_CONTACT = 'connect-without-contact',
    CONNECTED_TV = 'connected-tv',
    CONSTRUCTION = 'construction',
    CONTACT_MAIL = 'contact-mail',
    CONTACT_PAGE = 'contact-page',
    CONTACT_PHONE = 'contact-phone',
    CONTACT_SUPPORT = 'contact-support',
    CONTACTLESS = 'contactless',
    CONTACTS = 'contacts',
    CONTENT_COPY = 'content-copy',
    CONTENT_CUT = 'content-cut',
    CONTENT_PASTE = 'content-paste',
    CONTROL_CAMERA = 'control-camera',
    CONTROL_POINT = 'control-point',
    CONTROL_POINT_DUPLICATE = 'control-point-duplicate',
    COPYRIGHT = 'copyright',
    CORONAVIRUS = 'coronavirus',
    CORPORATE_FARE = 'corporate-fare',
    COUNTERTOPS = 'countertops',
    CREATE = 'create',
    CREATE_NEW_FOLDER = 'create-new-folder',
    CREDIT_CARD = 'credit-card',
    CROP = 'crop',
    CROP_16_9 = 'crop-16-9',
    CROP_3_2 = 'crop-3-2',
    CROP_5_4 = 'crop-5-4',
    CROP_7_5 = 'crop-7-5',
    CROP_DIN = 'crop-din',
    CROP_FREE = 'crop-free',
    CROP_LANDSCAPE = 'crop-landscape',
    CROP_ORIGINAL = 'crop-original',
    CROP_PORTRAIT = 'crop-portrait',
    CROP_ROTATE = 'crop-rotate',
    CROP_SQUARE = 'crop-square',
    DANGEROUS = 'dangerous',
    DASHBOARD = 'dashboard',
    DASHBOARD_CUSTOMIZE = 'dashboard-customize',
    DATA_USAGE = 'data-usage',
    DATE_RANGE = 'date-range',
    DECK = 'deck',
    DEHAZE = 'dehaze',
    DELETE = 'delete',
    DELETE_FOREVER = 'delete-forever',
    DELETE_OUTLINE = 'delete-outline',
    DELETE_SWEEP = 'delete-sweep',
    DELIVERY_DINING = 'delivery-dining',
    DEPARTURE_BOARD = 'departure-board',
    DESCRIPTION = 'description',
    DESIGN_SERVICES = 'design-services',
    DESKTOP_ACCESS_DISABLED = 'desktop-access-disabled',
    DESKTOP_MAC = 'desktop-mac',
    DESKTOP_WINDOWS = 'desktop-windows',
    DETAILS = 'details',
    DEVELOPER_BOARD = 'developer-board',
    DEVELOPER_MODE = 'developer-mode',
    DEVICE_HUB = 'device-hub',
    DEVICE_THERMOSTAT = 'device-thermostat',
    DEVICE_UNKNOWN = 'device-unknown',
    DEVICES = 'devices',
    DEVICES_OTHER = 'devices-other',
    DIALER_SIP = 'dialer-sip',
    DIALPAD = 'dialpad',
    DINNER_DINING = 'dinner-dining',
    DIRECTIONS = 'directions',
    DIRECTIONS_BIKE = 'directions-bike',
    DIRECTIONS_BOAT = 'directions-boat',
    DIRECTIONS_BUS = 'directions-bus',
    DIRECTIONS_CAR = 'directions-car',
    DIRECTIONS_FERRY = 'directions-ferry',
    DIRECTIONS_OFF = 'directions-off',
    DIRECTIONS_RAILWAY = 'directions-railway',
    DIRECTIONS_RUN = 'directions-run',
    DIRECTIONS_SUBWAY = 'directions-subway',
    DIRECTIONS_TRAIN = 'directions-train',
    DIRECTIONS_TRANSIT = 'directions-transit',
    DIRECTIONS_WALK = 'directions-walk',
    DIRTY_LENS = 'dirty-lens',
    DISABLED_BY_DEFAULT = 'disabled-by-default',
    DISC_FULL = 'disc-full',
    DND_FORWARDSLASH = 'dnd-forwardslash',
    DNS = 'dns',
    DO_NOT_DISTURB = 'do-not-disturb',
    DO_NOT_DISTURB_ALT = 'do-not-disturb-alt',
    DO_NOT_DISTURB_OFF = 'do-not-disturb-off',
    DO_NOT_DISTURB_ON = 'do-not-disturb-on',
    DO_NOT_STEP = 'do-not-step',
    DO_NOT_TOUCH = 'do-not-touch',
    DOCK = 'dock',
    DOMAIN = 'domain',
    DOMAIN_DISABLED = 'domain-disabled',
    DOMAIN_VERIFICATION = 'domain-verification',
    DONE = 'done',
    DONE_ALL = 'done-all',
    DONE_OUTLINE = 'done-outline',
    DONUT_LARGE = 'donut-large',
    DONUT_SMALL = 'donut-small',
    DOUBLE_ARROW = 'double-arrow',
    DRAFTS = 'drafts',
    DRAG_HANDLE = 'drag-handle',
    DRAG_INDICATOR = 'drag-indicator',
    DRIVE_ETA = 'drive-eta',
    DRIVE_FILE_MOVE = 'drive-file-move',
    DRIVE_FILE_MOVE_OUTLINE = 'drive-file-move-outline',
    DRIVE_FILE_RENAME_OUTLINE = 'drive-file-rename-outline',
    DRIVE_FOLDER_UPLOAD = 'drive-folder-upload',
    DRY = 'dry',
    DRY_CLEANING = 'dry-cleaning',
    DUO = 'duo',
    DVR = 'dvr',
    DYNAMIC_FEED = 'dynamic-feed',
    DYNAMIC_FORM = 'dynamic-form',
    EAST = 'east',
    ECO = 'eco',
    EDIT = 'edit',
    EDIT_ATTRIBUTES = 'edit-attributes',
    EDIT_LOCATION = 'edit-location',
    EDIT_OFF = 'edit-off',
    EDIT_ROAD = 'edit-road',
    EJECT = 'eject',
    ELDERLY = 'elderly',
    ELECTRIC_BIKE = 'electric-bike',
    ELECTRIC_CAR = 'electric-car',
    ELECTRIC_MOPED = 'electric-moped',
    ELECTRIC_RICKSHAW = 'electric-rickshaw',
    ELECTRIC_SCOOTER = 'electric-scooter',
    ELECTRICAL_SERVICES = 'electrical-services',
    ELEVATOR = 'elevator',
    EMAIL = 'email',
    EMOJI_EMOTIONS = 'emoji-emotions',
    EMOJI_EVENTS = 'emoji-events',
    EMOJI_FLAGS = 'emoji-flags',
    EMOJI_FOOD_BEVERAGE = 'emoji-food-beverage',
    EMOJI_NATURE = 'emoji-nature',
    EMOJI_OBJECTS = 'emoji-objects',
    EMOJI_PEOPLE = 'emoji-people',
    EMOJI_SYMBOLS = 'emoji-symbols',
    EMOJI_TRANSPORTATION = 'emoji-transportation',
    ENGINEERING = 'engineering',
    ENHANCE_PHOTO_TRANSLATE = 'enhance-photo-translate',
    ENHANCED_ENCRYPTION = 'enhanced-encryption',
    EQUALIZER = 'equalizer',
    ERROR = 'error',
    ERROR_OUTLINE = 'error-outline',
    ESCALATOR = 'escalator',
    ESCALATOR_WARNING = 'escalator-warning',
    EURO = 'euro',
    EURO_SYMBOL = 'euro-symbol',
    EV_STATION = 'ev-station',
    EVENT = 'event',
    EVENT_AVAILABLE = 'event-available',
    EVENT_BUSY = 'event-busy',
    EVENT_NOTE = 'event-note',
    EVENT_SEAT = 'event-seat',
    EXIT_TO_APP = 'exit-to-app',
    EXPAND = 'expand',
    EXPAND_LESS = 'expand-less',
    EXPAND_MORE = 'expand-more',
    EXPLICIT = 'explicit',
    EXPLORE = 'explore',
    EXPLORE_OFF = 'explore-off',
    EXPOSURE = 'exposure',
    EXPOSURE_MINUS_1 = 'exposure-minus-1',
    EXPOSURE_MINUS_2 = 'exposure-minus-2',
    EXPOSURE_NEG_1 = 'exposure-neg-1',
    EXPOSURE_NEG_2 = 'exposure-neg-2',
    EXPOSURE_PLUS_1 = 'exposure-plus-1',
    EXPOSURE_PLUS_2 = 'exposure-plus-2',
    EXPOSURE_ZERO = 'exposure-zero',
    EXTENSION = 'extension',
    FACE = 'face',
    FACE_RETOUCHING_NATURAL = 'face-retouching-natural',
    FACEBOOK = 'facebook',
    FACT_CHECK = 'fact-check',
    FAMILY_RESTROOM = 'family-restroom',
    FAST_FORWARD = 'fast-forward',
    FAST_REWIND = 'fast-rewind',
    FASTFOOD = 'fastfood',
    FAVORITE = 'favorite',
    FAVORITE_BORDER = 'favorite-border',
    FAVORITE_OUTLINE = 'favorite-outline',
    FEATURED_PLAY_LIST = 'featured-play-list',
    FEATURED_VIDEO = 'featured-video',
    FEEDBACK = 'feedback',
    FENCE = 'fence',
    FESTIVAL = 'festival',
    FIBER_DVR = 'fiber-dvr',
    FIBER_MANUAL_RECORD = 'fiber-manual-record',
    FIBER_NEW = 'fiber-new',
    FIBER_PIN = 'fiber-pin',
    FIBER_SMART_RECORD = 'fiber-smart-record',
    FILE_COPY = 'file-copy',
    FILE_DOWNLOAD = 'file-download',
    FILE_DOWNLOAD_DONE = 'file-download-done',
    FILE_PRESENT = 'file-present',
    FILE_UPLOAD = 'file-upload',
    FILTER = 'filter',
    FILTER_1 = 'filter-1',
    FILTER_2 = 'filter-2',
    FILTER_3 = 'filter-3',
    FILTER_4 = 'filter-4',
    FILTER_5 = 'filter-5',
    FILTER_6 = 'filter-6',
    FILTER_7 = 'filter-7',
    FILTER_8 = 'filter-8',
    FILTER_9 = 'filter-9',
    FILTER_9_PLUS = 'filter-9-plus',
    FILTER_ALT = 'filter-alt',
    FILTER_B_AND_W = 'filter-b-and-w',
    FILTER_CENTER_FOCUS = 'filter-center-focus',
    FILTER_DRAMA = 'filter-drama',
    FILTER_FRAMES = 'filter-frames',
    FILTER_HDR = 'filter-hdr',
    FILTER_LIST = 'filter-list',
    FILTER_LIST_ALT = 'filter-list-alt',
    FILTER_NONE = 'filter-none',
    FILTER_TILT_SHIFT = 'filter-tilt-shift',
    FILTER_VINTAGE = 'filter-vintage',
    FIND_IN_PAGE = 'find-in-page',
    FIND_REPLACE = 'find-replace',
    FINGERPRINT = 'fingerprint',
    FIRE_EXTINGUISHER = 'fire-extinguisher',
    FIRE_HYDRANT = 'fire-hydrant',
    FIREPLACE = 'fireplace',
    FIRST_PAGE = 'first-page',
    FIT_SCREEN = 'fit-screen',
    FITNESS_CENTER = 'fitness-center',
    FLAG = 'flag',
    FLAKY = 'flaky',
    FLARE = 'flare',
    FLASH_AUTO = 'flash-auto',
    FLASH_OFF = 'flash-off',
    FLASH_ON = 'flash-on',
    FLIGHT = 'flight',
    FLIGHT_LAND = 'flight-land',
    FLIGHT_TAKEOFF = 'flight-takeoff',
    FLIP = 'flip',
    FLIP_CAMERA_ANDROID = 'flip-camera-android',
    FLIP_CAMERA_IOS = 'flip-camera-ios',
    FLIP_TO_BACK = 'flip-to-back',
    FLIP_TO_FRONT = 'flip-to-front',
    FOLDER = 'folder',
    FOLDER_OPEN = 'folder-open',
    FOLDER_SHARED = 'folder-shared',
    FOLDER_SPECIAL = 'folder-special',
    FOLLOW_THE_SIGNS = 'follow-the-signs',
    FONT_DOWNLOAD = 'font-download',
    FOOD_BANK = 'food-bank',
    FORMAT_ALIGN_CENTER = 'format-align-center',
    FORMAT_ALIGN_JUSTIFY = 'format-align-justify',
    FORMAT_ALIGN_LEFT = 'format-align-left',
    FORMAT_ALIGN_RIGHT = 'format-align-right',
    FORMAT_BOLD = 'format-bold',
    FORMAT_CLEAR = 'format-clear',
    FORMAT_COLOR_FILL = 'format-color-fill',
    FORMAT_COLOR_RESET = 'format-color-reset',
    FORMAT_COLOR_TEXT = 'format-color-text',
    FORMAT_INDENT_DECREASE = 'format-indent-decrease',
    FORMAT_INDENT_INCREASE = 'format-indent-increase',
    FORMAT_ITALIC = 'format-italic',
    FORMAT_LINE_SPACING = 'format-line-spacing',
    FORMAT_LIST_BULLETED = 'format-list-bulleted',
    FORMAT_LIST_NUMBERED = 'format-list-numbered',
    FORMAT_LIST_NUMBERED_RTL = 'format-list-numbered-rtl',
    FORMAT_PAINT = 'format-paint',
    FORMAT_QUOTE = 'format-quote',
    FORMAT_SHAPES = 'format-shapes',
    FORMAT_SIZE = 'format-size',
    FORMAT_STRIKETHROUGH = 'format-strikethrough',
    FORMAT_TEXTDIRECTION_L_TO_R = 'format-textdirection-l-to-r',
    FORMAT_TEXTDIRECTION_R_TO_L = 'format-textdirection-r-to-l',
    FORMAT_UNDERLINE = 'format-underline',
    FORMAT_UNDERLINED = 'format-underlined',
    FORUM = 'forum',
    FORWARD = 'forward',
    FORWARD_10 = 'forward-10',
    FORWARD_30 = 'forward-30',
    FORWARD_5 = 'forward-5',
    FORWARD_TO_INBOX = 'forward-to-inbox',
    FOUNDATION = 'foundation',
    FREE_BREAKFAST = 'free-breakfast',
    FULLSCREEN = 'fullscreen',
    FULLSCREEN_EXIT = 'fullscreen-exit',
    FUNCTIONS = 'functions',
    G_TRANSLATE = 'g-translate',
    GAMEPAD = 'gamepad',
    GAMES = 'games',
    GAVEL = 'gavel',
    GESTURE = 'gesture',
    GET_APP = 'get-app',
    GIF = 'gif',
    GOAT = 'goat',
    GOLF_COURSE = 'golf-course',
    GPS_FIXED = 'gps-fixed',
    GPS_NOT_FIXED = 'gps-not-fixed',
    GPS_OFF = 'gps-off',
    GRADE = 'grade',
    GRADIENT = 'gradient',
    GRADING = 'grading',
    GRAIN = 'grain',
    GRAPHIC_EQ = 'graphic-eq',
    GRASS = 'grass',
    GRID_OFF = 'grid-off',
    GRID_ON = 'grid-on',
    GRID_VIEW = 'grid-view',
    GROUP = 'group',
    GROUP_ADD = 'group-add',
    GROUP_WORK = 'group-work',
    GROUPS = 'groups',
    HAIL = 'hail',
    HANDYMAN = 'handyman',
    HARDWARE = 'hardware',
    HD = 'hd',
    HDR_ENHANCED_SELECT = 'hdr-enhanced-select',
    HDR_OFF = 'hdr-off',
    HDR_ON = 'hdr-on',
    HDR_STRONG = 'hdr-strong',
    HDR_WEAK = 'hdr-weak',
    HEADSET = 'headset',
    HEADSET_MIC = 'headset-mic',
    HEADSET_OFF = 'headset-off',
    HEALING = 'healing',
    HEARING = 'hearing',
    HEARING_DISABLED = 'hearing-disabled',
    HEIGHT = 'height',
    HELP = 'help',
    HELP_CENTER = 'help-center',
    HELP_OUTLINE = 'help-outline',
    HIGH_QUALITY = 'high-quality',
    HIGHLIGHT = 'highlight',
    HIGHLIGHT_ALT = 'highlight-alt',
    HIGHLIGHT_OFF = 'highlight-off',
    HIGHLIGHT_REMOVE = 'highlight-remove',
    HISTORY = 'history',
    HISTORY_EDU = 'history-edu',
    HISTORY_TOGGLE_OFF = 'history-toggle-off',
    HOME = 'home',
    HOME_FILLED = 'home-filled',
    HOME_REPAIR_SERVICE = 'home-repair-service',
    HOME_WORK = 'home-work',
    HORIZONTAL_DISTRIBUTE = 'horizontal-distribute',
    HORIZONTAL_RULE = 'horizontal-rule',
    HORIZONTAL_SPLIT = 'horizontal-split',
    HOT_TUB = 'hot-tub',
    HOTEL = 'hotel',
    HOURGLASS_BOTTOM = 'hourglass-bottom',
    HOURGLASS_DISABLED = 'hourglass-disabled',
    HOURGLASS_EMPTY = 'hourglass-empty',
    HOURGLASS_FULL = 'hourglass-full',
    HOURGLASS_TOP = 'hourglass-top',
    HOUSE = 'house',
    HOUSE_SIDING = 'house-siding',
    HOW_TO_REG = 'how-to-reg',
    HOW_TO_VOTE = 'how-to-vote',
    HTTP = 'http',
    HTTPS = 'https',
    HVAC = 'hvac',
    ICECREAM = 'icecream',
    IMAGE = 'image',
    IMAGE_ASPECT_RATIO = 'image-aspect-ratio',
    IMAGE_NOT_SUPPORTED = 'image-not-supported',
    IMAGE_SEARCH = 'image-search',
    IMAGESEARCH_ROLLER = 'imagesearch-roller',
    IMPORT_CONTACTS = 'import-contacts',
    IMPORT_EXPORT = 'import-export',
    IMPORTANT_DEVICES = 'important-devices',
    INBOX = 'inbox',
    INDETERMINATE_CHECK_BOX = 'indeterminate-check-box',
    INFO = 'info',
    INFO_OUTLINE = 'info-outline',
    INPUT = 'input',
    INSERT_CHART = 'insert-chart',
    INSERT_CHART_OUTLINED = 'insert-chart-outlined',
    INSERT_COMMENT = 'insert-comment',
    INSERT_DRIVE_FILE = 'insert-drive-file',
    INSERT_EMOTICON = 'insert-emoticon',
    INSERT_INVITATION = 'insert-invitation',
    INSERT_LINK = 'insert-link',
    INSERT_PHOTO = 'insert-photo',
    INSIGHTS = 'insights',
    INTEGRATION_INSTRUCTIONS = 'integration-instructions',
    INVENTORY = 'inventory',
    INVERT_COLORS = 'invert-colors',
    INVERT_COLORS_OFF = 'invert-colors-off',
    INVERT_COLORS_ON = 'invert-colors-on',
    IOS_SHARE = 'ios-share',
    ISO = 'iso',
    KEYBOARD = 'keyboard',
    KEYBOARD_ARROW_DOWN = 'keyboard-arrow-down',
    KEYBOARD_ARROW_LEFT = 'keyboard-arrow-left',
    KEYBOARD_ARROW_RIGHT = 'keyboard-arrow-right',
    KEYBOARD_ARROW_UP = 'keyboard-arrow-up',
    KEYBOARD_BACKSPACE = 'keyboard-backspace',
    KEYBOARD_CAPSLOCK = 'keyboard-capslock',
    KEYBOARD_CONTROL = 'keyboard-control',
    KEYBOARD_HIDE = 'keyboard-hide',
    KEYBOARD_RETURN = 'keyboard-return',
    KEYBOARD_TAB = 'keyboard-tab',
    KEYBOARD_VOICE = 'keyboard-voice',
    KING_BED = 'king-bed',
    KITCHEN = 'kitchen',
    LABEL = 'label',
    LABEL_IMPORTANT = 'label-important',
    LABEL_IMPORTANT_OUTLINE = 'label-important-outline',
    LABEL_OFF = 'label-off',
    LABEL_OUTLINE = 'label-outline',
    LANDSCAPE = 'landscape',
    LANGUAGE = 'language',
    LAPTOP = 'laptop',
    LAPTOP_CHROMEBOOK = 'laptop-chromebook',
    LAPTOP_MAC = 'laptop-mac',
    LAPTOP_WINDOWS = 'laptop-windows',
    LAST_PAGE = 'last-page',
    LAUNCH = 'launch',
    LAYERS = 'layers',
    LAYERS_CLEAR = 'layers-clear',
    LEADERBOARD = 'leaderboard',
    LEAK_ADD = 'leak-add',
    LEAK_REMOVE = 'leak-remove',
    LEAVE_BAGS_AT_HOME = 'leave-bags-at-home',
    LEGEND_TOGGLE = 'legend-toggle',
    LENS = 'lens',
    LIBRARY_ADD = 'library-add',
    LIBRARY_ADD_CHECK = 'library-add-check',
    LIBRARY_BOOKS = 'library-books',
    LIBRARY_MUSIC = 'library-music',
    LIGHTBULB = 'lightbulb',
    LIGHTBULB_OUTLINE = 'lightbulb-outline',
    LINE_STYLE = 'line-style',
    LINE_WEIGHT = 'line-weight',
    LINEAR_SCALE = 'linear-scale',
    LINK = 'link',
    LINK_OFF = 'link-off',
    LINKED_CAMERA = 'linked-camera',
    LIQUOR = 'liquor',
    LIST = 'list',
    LIST_ALT = 'list-alt',
    LIVE_HELP = 'live-help',
    LIVE_TV = 'live-tv',
    LOCAL_ACTIVITY = 'local-activity',
    LOCAL_AIRPORT = 'local-airport',
    LOCAL_ATM = 'local-atm',
    LOCAL_ATTRACTION = 'local-attraction',
    LOCAL_BAR = 'local-bar',
    LOCAL_CAFE = 'local-cafe',
    LOCAL_CAR_WASH = 'local-car-wash',
    LOCAL_CONVENIENCE_STORE = 'local-convenience-store',
    LOCAL_DINING = 'local-dining',
    LOCAL_DRINK = 'local-drink',
    LOCAL_FIRE_DEPARTMENT = 'local-fire-department',
    LOCAL_FLORIST = 'local-florist',
    LOCAL_GAS_STATION = 'local-gas-station',
    LOCAL_GROCERY_STORE = 'local-grocery-store',
    LOCAL_HOSPITAL = 'local-hospital',
    LOCAL_HOTEL = 'local-hotel',
    LOCAL_LAUNDRY_SERVICE = 'local-laundry-service',
    LOCAL_LIBRARY = 'local-library',
    LOCAL_MALL = 'local-mall',
    LOCAL_MOVIES = 'local-movies',
    LOCAL_OFFER = 'local-offer',
    LOCAL_PARKING = 'local-parking',
    LOCAL_PHARMACY = 'local-pharmacy',
    LOCAL_PHONE = 'local-phone',
    LOCAL_PIZZA = 'local-pizza',
    LOCAL_PLAY = 'local-play',
    LOCAL_POLICE = 'local-police',
    LOCAL_POST_OFFICE = 'local-post-office',
    LOCAL_PRINT_SHOP = 'local-print-shop',
    LOCAL_PRINTSHOP = 'local-printshop',
    LOCAL_RESTAURANT = 'local-restaurant',
    LOCAL_SEE = 'local-see',
    LOCAL_SHIPPING = 'local-shipping',
    LOCAL_TAXI = 'local-taxi',
    LOCATION_CITY = 'location-city',
    LOCATION_DISABLED = 'location-disabled',
    LOCATION_HISTORY = 'location-history',
    LOCATION_OFF = 'location-off',
    LOCATION_ON = 'location-on',
    LOCATION_PIN = 'location-pin',
    LOCATION_SEARCHING = 'location-searching',
    LOCK = 'lock',
    LOCK_CLOCK = 'lock-clock',
    LOCK_OPEN = 'lock-open',
    LOCK_OUTLINE = 'lock-outline',
    LOGIN = 'login',
    LOGOUT = 'logout',
    LOOKS = 'looks',
    LOOKS_3 = 'looks-3',
    LOOKS_4 = 'looks-4',
    LOOKS_5 = 'looks-5',
    LOOKS_6 = 'looks-6',
    LOOKS_ONE = 'looks-one',
    LOOKS_TWO = 'looks-two',
    LOOP = 'loop',
    LOUPE = 'loupe',
    LOW_PRIORITY = 'low-priority',
    LOYALTY = 'loyalty',
    LUGGAGE = 'luggage',
    LUNCH_DINING = 'lunch-dining',
    MAIL = 'mail',
    MAIL_OUTLINE = 'mail-outline',
    MAP = 'map',
    MAPS_UGC = 'maps-ugc',
    MARGIN = 'margin',
    MARK_AS_UNREAD = 'mark-as-unread',
    MARK_CHAT_READ = 'mark-chat-read',
    MARK_CHAT_UNREAD = 'mark-chat-unread',
    MARK_EMAIL_READ = 'mark-email-read',
    MARK_EMAIL_UNREAD = 'mark-email-unread',
    MARKUNREAD = 'markunread',
    MARKUNREAD_MAILBOX = 'markunread-mailbox',
    MASKS = 'masks',
    MAXIMIZE = 'maximize',
    MEDIATION = 'mediation',
    MEDICAL_SERVICES = 'medical-services',
    MEETING_ROOM = 'meeting-room',
    MEMORY = 'memory',
    MENU = 'menu',
    MENU_BOOK = 'menu-book',
    MENU_OPEN = 'menu-open',
    MERGE_TYPE = 'merge-type',
    MESSAGE = 'message',
    MESSENGER = 'messenger',
    MESSENGER_OUTLINE = 'messenger-outline',
    MIC = 'mic',
    MIC_EXTERNAL_OFF = 'mic-external-off',
    MIC_EXTERNAL_ON = 'mic-external-on',
    MIC_NONE = 'mic-none',
    MIC_OFF = 'mic-off',
    MICROWAVE = 'microwave',
    MILITARY_TECH = 'military-tech',
    MINIMIZE = 'minimize',
    MISCELLANEOUS_SERVICES = 'miscellaneous-services',
    MISSED_VIDEO_CALL = 'missed-video-call',
    MMS = 'mms',
    MOBILE_FRIENDLY = 'mobile-friendly',
    MOBILE_OFF = 'mobile-off',
    MOBILE_SCREEN_SHARE = 'mobile-screen-share',
    MODE_COMMENT = 'mode-comment',
    MODE_EDIT = 'mode-edit',
    MODEL_TRAINING = 'model-training',
    MONETIZATION_ON = 'monetization-on',
    MONEY = 'money',
    MONEY_OFF = 'money-off',
    MONITOR = 'monitor',
    MONOCHROME_PHOTOS = 'monochrome-photos',
    MOOD = 'mood',
    MOOD_BAD = 'mood-bad',
    MOPED = 'moped',
    MORE = 'more',
    MORE_HORIZ = 'more-horiz',
    MORE_TIME = 'more-time',
    MORE_VERT = 'more-vert',
    MOTION_PHOTOS_OFF = 'motion-photos-off',
    MOTION_PHOTOS_ON = 'motion-photos-on',
    MOTION_PHOTOS_PAUSE = 'motion-photos-pause',
    MOTION_PHOTOS_PAUSED = 'motion-photos-paused',
    MOTORCYCLE = 'motorcycle',
    MOUSE = 'mouse',
    MOVE_TO_INBOX = 'move-to-inbox',
    MOVIE = 'movie',
    MOVIE_CREATION = 'movie-creation',
    MOVIE_FILTER = 'movie-filter',
    MP = 'mp',
    MULTILINE_CHART = 'multiline-chart',
    MULTIPLE_STOP = 'multiple-stop',
    MULTITRACK_AUDIO = 'multitrack-audio',
    MUSEUM = 'museum',
    MUSIC_NOTE = 'music-note',
    MUSIC_OFF = 'music-off',
    MUSIC_VIDEO = 'music-video',
    MY_LIBRARY_ADD = 'my-library-add',
    MY_LIBRARY_BOOKS = 'my-library-books',
    MY_LIBRARY_MUSIC = 'my-library-music',
    MY_LOCATION = 'my-location',
    NAT = 'nat',
    NATURE = 'nature',
    NATURE_PEOPLE = 'nature-people',
    NAVIGATE_BEFORE = 'navigate-before',
    NAVIGATE_NEXT = 'navigate-next',
    NAVIGATION = 'navigation',
    NEAR_ME = 'near-me',
    NEAR_ME_DISABLED = 'near-me-disabled',
    NETWORK_CELL = 'network-cell',
    NETWORK_CHECK = 'network-check',
    NETWORK_LOCKED = 'network-locked',
    NETWORK_WIFI = 'network-wifi',
    NEW_RELEASES = 'new-releases',
    NEXT_PLAN = 'next-plan',
    NEXT_WEEK = 'next-week',
    NFC = 'nfc',
    NIGHT_SHELTER = 'night-shelter',
    NIGHTLIFE = 'nightlife',
    NIGHTLIGHT_ROUND = 'nightlight-round',
    NIGHTS_STAY = 'nights-stay',
    NO_BACKPACK = 'no-backpack',
    NO_CELL = 'no-cell',
    NO_DRINKS = 'no-drinks',
    NO_ENCRYPTION = 'no-encryption',
    NO_FLASH = 'no-flash',
    NO_FOOD = 'no-food',
    NO_LUGGAGE = 'no-luggage',
    NO_MEALS = 'no-meals',
    NO_MEALS_OULINE = 'no-meals-ouline',
    NO_MEETING_ROOM = 'no-meeting-room',
    NO_PHOTOGRAPHY = 'no-photography',
    NO_SIM = 'no-sim',
    NO_STROLLER = 'no-stroller',
    NO_TRANSFER = 'no-transfer',
    NORTH = 'north',
    NORTH_EAST = 'north-east',
    NORTH_WEST = 'north-west',
    NOT_ACCESSIBLE = 'not-accessible',
    NOT_INTERESTED = 'not-interested',
    NOT_LISTED_LOCATION = 'not-listed-location',
    NOT_STARTED = 'not-started',
    NOTE = 'note',
    NOTE_ADD = 'note-add',
    NOTES = 'notes',
    NOTIFICATION_IMPORTANT = 'notification-important',
    NOTIFICATIONS = 'notifications',
    NOTIFICATIONS_ACTIVE = 'notifications-active',
    NOTIFICATIONS_NONE = 'notifications-none',
    NOTIFICATIONS_OFF = 'notifications-off',
    NOTIFICATIONS_ON = 'notifications-on',
    NOTIFICATIONS_PAUSED = 'notifications-paused',
    NOW_WALLPAPER = 'now-wallpaper',
    NOW_WIDGETS = 'now-widgets',
    OFFLINE_BOLT = 'offline-bolt',
    OFFLINE_PIN = 'offline-pin',
    OFFLINE_SHARE = 'offline-share',
    ONDEMAND_VIDEO = 'ondemand-video',
    ONLINE_PREDICTION = 'online-prediction',
    OPACITY = 'opacity',
    OPEN_IN_BROWSER = 'open-in-browser',
    OPEN_IN_FULL = 'open-in-full',
    OPEN_IN_NEW = 'open-in-new',
    OPEN_WITH = 'open-with',
    OUTBOND = 'outbond',
    OUTBOX = 'outbox',
    OUTDOOR_GRILL = 'outdoor-grill',
    OUTGOING_MAIL = 'outgoing-mail',
    OUTLET = 'outlet',
    OUTLINED_FLAG = 'outlined-flag',
    PADDING = 'padding',
    PAGES = 'pages',
    PAGEVIEW = 'pageview',
    PALETTE = 'palette',
    PAN_TOOL = 'pan-tool',
    PANORAMA = 'panorama',
    PANORAMA_FISH_EYE = 'panorama-fish-eye',
    PANORAMA_FISHEYE = 'panorama-fisheye',
    PANORAMA_HORIZONTAL = 'panorama-horizontal',
    PANORAMA_HORIZONTAL_SELECT = 'panorama-horizontal-select',
    PANORAMA_PHOTOSPHERE = 'panorama-photosphere',
    PANORAMA_PHOTOSPHERE_SELECT = 'panorama-photosphere-select',
    PANORAMA_VERTICAL = 'panorama-vertical',
    PANORAMA_VERTICAL_SELECT = 'panorama-vertical-select',
    PANORAMA_WIDE_ANGLE = 'panorama-wide-angle',
    PANORAMA_WIDE_ANGLE_SELECT = 'panorama-wide-angle-select',
    PARK = 'park',
    PARTY_MODE = 'party-mode',
    PAUSE = 'pause',
    PAUSE_CIRCLE_FILLED = 'pause-circle-filled',
    PAUSE_CIRCLE_OUTLINE = 'pause-circle-outline',
    PAUSE_PRESENTATION = 'pause-presentation',
    PAYMENT = 'payment',
    PAYMENTS = 'payments',
    PEDAL_BIKE = 'pedal-bike',
    PENDING = 'pending',
    PENDING_ACTIONS = 'pending-actions',
    PEOPLE = 'people',
    PEOPLE_ALT = 'people-alt',
    PEOPLE_OUTLINE = 'people-outline',
    PERM_CAMERA_MIC = 'perm-camera-mic',
    PERM_CONTACT_CAL = 'perm-contact-cal',
    PERM_CONTACT_CALENDAR = 'perm-contact-calendar',
    PERM_DATA_SETTING = 'perm-data-setting',
    PERM_DEVICE_INFO = 'perm-device-info',
    PERM_DEVICE_INFORMATION = 'perm-device-information',
    PERM_IDENTITY = 'perm-identity',
    PERM_MEDIA = 'perm-media',
    PERM_PHONE_MSG = 'perm-phone-msg',
    PERM_SCAN_WIFI = 'perm-scan-wifi',
    PERSON = 'person',
    PERSON_ADD = 'person-add',
    PERSON_ADD_ALT = 'person-add-alt',
    PERSON_ADD_ALT_1 = 'person-add-alt-1',
    PERSON_ADD_DISABLED = 'person-add-disabled',
    PERSON_OUTLINE = 'person-outline',
    PERSON_PIN = 'person-pin',
    PERSON_PIN_CIRCLE = 'person-pin-circle',
    PERSON_REMOVE = 'person-remove',
    PERSON_REMOVE_ALT_1 = 'person-remove-alt-1',
    PERSON_SEARCH = 'person-search',
    PERSONAL_VIDEO = 'personal-video',
    PEST_CONTROL = 'pest-control',
    PEST_CONTROL_RODENT = 'pest-control-rodent',
    PETS = 'pets',
    PHONE = 'phone',
    PHONE_ANDROID = 'phone-android',
    PHONE_BLUETOOTH_SPEAKER = 'phone-bluetooth-speaker',
    PHONE_CALLBACK = 'phone-callback',
    PHONE_DISABLED = 'phone-disabled',
    PHONE_ENABLED = 'phone-enabled',
    PHONE_FORWARDED = 'phone-forwarded',
    PHONE_IN_TALK = 'phone-in-talk',
    PHONE_IPHONE = 'phone-iphone',
    PHONE_LOCKED = 'phone-locked',
    PHONE_MISSED = 'phone-missed',
    PHONE_PAUSED = 'phone-paused',
    PHONELINK = 'phonelink',
    PHONELINK_ERASE = 'phonelink-erase',
    PHONELINK_LOCK = 'phonelink-lock',
    PHONELINK_OFF = 'phonelink-off',
    PHONELINK_RING = 'phonelink-ring',
    PHONELINK_SETUP = 'phonelink-setup',
    PHOTO = 'photo',
    PHOTO_ALBUM = 'photo-album',
    PHOTO_CAMERA = 'photo-camera',
    PHOTO_CAMERA_BACK = 'photo-camera-back',
    PHOTO_CAMERA_FRONT = 'photo-camera-front',
    PHOTO_FILTER = 'photo-filter',
    PHOTO_LIBRARY = 'photo-library',
    PHOTO_SIZE_SELECT_ACTUAL = 'photo-size-select-actual',
    PHOTO_SIZE_SELECT_LARGE = 'photo-size-select-large',
    PHOTO_SIZE_SELECT_SMALL = 'photo-size-select-small',
    PICTURE_AS_PDF = 'picture-as-pdf',
    PICTURE_IN_PICTURE = 'picture-in-picture',
    PICTURE_IN_PICTURE_ALT = 'picture-in-picture-alt',
    PIE_CHART = 'pie-chart',
    PIE_CHART_OUTLINED = 'pie-chart-outlined',
    PIN_DROP = 'pin-drop',
    PIVOT_TABLE_CHART = 'pivot-table-chart',
    PLACE = 'place',
    PLAGIARISM = 'plagiarism',
    PLAY_ARROW = 'play-arrow',
    PLAY_CIRCLE_FILL = 'play-circle-fill',
    PLAY_CIRCLE_FILLED = 'play-circle-filled',
    PLAY_CIRCLE_OUTLINE = 'play-circle-outline',
    PLAY_DISABLED = 'play-disabled',
    PLAY_FOR_WORK = 'play-for-work',
    PLAYLIST_ADD = 'playlist-add',
    PLAYLIST_ADD_CHECK = 'playlist-add-check',
    PLAYLIST_PLAY = 'playlist-play',
    PLUMBING = 'plumbing',
    PLUS_ONE = 'plus-one',
    POINT_OF_SALE = 'point-of-sale',
    POLICY = 'policy',
    POLL = 'poll',
    POLYMER = 'polymer',
    POOL = 'pool',
    PORTABLE_WIFI_OFF = 'portable-wifi-off',
    PORTRAIT = 'portrait',
    POST_ADD = 'post-add',
    POWER = 'power',
    POWER_INPUT = 'power-input',
    POWER_OFF = 'power-off',
    POWER_SETTINGS_NEW = 'power-settings-new',
    PREGNANT_WOMAN = 'pregnant-woman',
    PRESENT_TO_ALL = 'present-to-all',
    PREVIEW = 'preview',
    PRINT = 'print',
    PRINT_DISABLED = 'print-disabled',
    PRIORITY_HIGH = 'priority-high',
    PRIVACY_TIP = 'privacy-tip',
    PSYCHOLOGY = 'psychology',
    PUBLIC = 'public',
    PUBLIC_OFF = 'public-off',
    PUBLISH = 'publish',
    PUBLISHED_WITH_CHANGES = 'published-with-changes',
    PUSH_PIN = 'push-pin',
    QR_CODE = 'qr-code',
    QR_CODE_2 = 'qr-code-2',
    QR_CODE_SCANNER = 'qr-code-scanner',
    QUERY_BUILDER = 'query-builder',
    QUESTION_ANSWER = 'question-answer',
    QUEUE = 'queue',
    QUEUE_MUSIC = 'queue-music',
    QUEUE_PLAY_NEXT = 'queue-play-next',
    QUICK_CONTACTS_DIALER = 'quick-contacts-dialer',
    QUICK_CONTACTS_MAIL = 'quick-contacts-mail',
    QUICKREPLY = 'quickreply',
    RADIO = 'radio',
    RADIO_BUTTON_CHECKED = 'radio-button-checked',
    RADIO_BUTTON_OFF = 'radio-button-off',
    RADIO_BUTTON_ON = 'radio-button-on',
    RADIO_BUTTON_UNCHECKED = 'radio-button-unchecked',
    RAILWAY_ALERT = 'railway-alert',
    RAMEN_DINING = 'ramen-dining',
    RATE_REVIEW = 'rate-review',
    READ_MORE = 'read-more',
    RECEIPT = 'receipt',
    RECEIPT_LONG = 'receipt-long',
    RECENT_ACTORS = 'recent-actors',
    RECOMMEND = 'recommend',
    RECORD_VOICE_OVER = 'record-voice-over',
    REDEEM = 'redeem',
    REDO = 'redo',
    REDUCE_CAPACITY = 'reduce-capacity',
    REFRESH = 'refresh',
    REMOVE = 'remove',
    REMOVE_CIRCLE = 'remove-circle',
    REMOVE_CIRCLE_OUTLINE = 'remove-circle-outline',
    REMOVE_DONE = 'remove-done',
    REMOVE_FROM_QUEUE = 'remove-from-queue',
    REMOVE_MODERATOR = 'remove-moderator',
    REMOVE_RED_EYE = 'remove-red-eye',
    REMOVE_SHOPPING_CART = 'remove-shopping-cart',
    REORDER = 'reorder',
    REPEAT = 'repeat',
    REPEAT_ON = 'repeat-on',
    REPEAT_ONE = 'repeat-one',
    REPEAT_ONE_ON = 'repeat-one-on',
    REPLAY = 'replay',
    REPLAY_10 = 'replay-10',
    REPLAY_30 = 'replay-30',
    REPLAY_5 = 'replay-5',
    REPLAY_CIRCLE_FILLED = 'replay-circle-filled',
    REPLY = 'reply',
    REPLY_ALL = 'reply-all',
    REPORT = 'report',
    REPORT_OFF = 'report-off',
    REPORT_PROBLEM = 'report-problem',
    REQUEST_PAGE = 'request-page',
    REQUEST_QUOTE = 'request-quote',
    RESET_TV = 'reset-tv',
    RESTAURANT = 'restaurant',
    RESTAURANT_MENU = 'restaurant-menu',
    RESTORE = 'restore',
    RESTORE_FROM_TRASH = 'restore-from-trash',
    RESTORE_PAGE = 'restore-page',
    RICE_BOWL = 'rice-bowl',
    RING_VOLUME = 'ring-volume',
    ROOFING = 'roofing',
    ROOM = 'room',
    ROOM_PREFERENCES = 'room-preferences',
    ROOM_SERVICE = 'room-service',
    ROTATE_90_DEGREES_CCW = 'rotate-90-degrees-ccw',
    ROTATE_LEFT = 'rotate-left',
    ROTATE_RIGHT = 'rotate-right',
    ROUNDED_CORNER = 'rounded-corner',
    ROUTER = 'router',
    ROWING = 'rowing',
    RSS_FEED = 'rss-feed',
    RTT = 'rtt',
    RULE = 'rule',
    RULE_FOLDER = 'rule-folder',
    RUN_CIRCLE = 'run-circle',
    RV_HOOKUP = 'rv-hookup',
    SANITIZER = 'sanitizer',
    SATELLITE = 'satellite',
    SAVE = 'save',
    SAVE_ALT = 'save-alt',
    SAVED_SEARCH = 'saved-search',
    SCANNER = 'scanner',
    SCATTER_PLOT = 'scatter-plot',
    SCHEDULE = 'schedule',
    SCHEDULE_SEND = 'schedule-send',
    SCHOOL = 'school',
    SCIENCE = 'science',
    SCORE = 'score',
    SCREEN_LOCK_LANDSCAPE = 'screen-lock-landscape',
    SCREEN_LOCK_PORTRAIT = 'screen-lock-portrait',
    SCREEN_LOCK_ROTATION = 'screen-lock-rotation',
    SCREEN_ROTATION = 'screen-rotation',
    SCREEN_SEARCH_DESKTOP = 'screen-search-desktop',
    SCREEN_SHARE = 'screen-share',
    SD = 'sd',
    SD_CARD = 'sd-card',
    SD_STORAGE = 'sd-storage',
    SEARCH = 'search',
    SEARCH_OFF = 'search-off',
    SECURITY = 'security',
    SEGMENT = 'segment',
    SELECT_ALL = 'select-all',
    SELF_IMPROVEMENT = 'self-improvement',
    SEND = 'send',
    SEND_AND_ARCHIVE = 'send-and-archive',
    SEND_TO_MOBILE = 'send-to-mobile',
    SENSOR_DOOR = 'sensor-door',
    SENSOR_WINDOW = 'sensor-window',
    SENTIMENT_DISSATISFIED = 'sentiment-dissatisfied',
    SENTIMENT_NEUTRAL = 'sentiment-neutral',
    SENTIMENT_SATISFIED = 'sentiment-satisfied',
    SENTIMENT_SATISFIED_ALT = 'sentiment-satisfied-alt',
    SENTIMENT_VERY_DISSATISFIED = 'sentiment-very-dissatisfied',
    SENTIMENT_VERY_SATISFIED = 'sentiment-very-satisfied',
    SET_MEAL = 'set-meal',
    SETTINGS = 'settings',
    SETTINGS_APPLICATIONS = 'settings-applications',
    SETTINGS_BACKUP_RESTORE = 'settings-backup-restore',
    SETTINGS_BLUETOOTH = 'settings-bluetooth',
    SETTINGS_BRIGHTNESS = 'settings-brightness',
    SETTINGS_CELL = 'settings-cell',
    SETTINGS_DISPLAY = 'settings-display',
    SETTINGS_ETHERNET = 'settings-ethernet',
    SETTINGS_INPUT_ANTENNA = 'settings-input-antenna',
    SETTINGS_INPUT_COMPONENT = 'settings-input-component',
    SETTINGS_INPUT_COMPOSITE = 'settings-input-composite',
    SETTINGS_INPUT_HDMI = 'settings-input-hdmi',
    SETTINGS_INPUT_SVIDEO = 'settings-input-svideo',
    SETTINGS_OVERSCAN = 'settings-overscan',
    SETTINGS_PHONE = 'settings-phone',
    SETTINGS_POWER = 'settings-power',
    SETTINGS_REMOTE = 'settings-remote',
    SETTINGS_SYSTEM_DAYDREAM = 'settings-system-daydream',
    SETTINGS_VOICE = 'settings-voice',
    SHARE = 'share',
    SHIELD = 'shield',
    SHOP = 'shop',
    SHOP_TWO = 'shop-two',
    SHOPPING_BAG = 'shopping-bag',
    SHOPPING_BASKET = 'shopping-basket',
    SHOPPING_CART = 'shopping-cart',
    SHORT_TEXT = 'short-text',
    SHOW_CHART = 'show-chart',
    SHUFFLE = 'shuffle',
    SHUFFLE_ON = 'shuffle-on',
    SHUTTER_SPEED = 'shutter-speed',
    SICK = 'sick',
    SIGNAL_CELLULAR_0_BAR = 'signal-cellular-0-bar',
    SIGNAL_CELLULAR_4_BAR = 'signal-cellular-4-bar',
    SIGNAL_CELLULAR_ALT = 'signal-cellular-alt',
    SIGNAL_CELLULAR_CONNECTED_NO_INTERNET_4_BAR = 'signal-cellular-connected-no-internet-4-bar',
    SIGNAL_CELLULAR_NO_SIM = 'signal-cellular-no-sim',
    SIGNAL_CELLULAR_NULL = 'signal-cellular-null',
    SIGNAL_CELLULAR_OFF = 'signal-cellular-off',
    SIGNAL_WIFI_0_BAR = 'signal-wifi-0-bar',
    SIGNAL_WIFI_4_BAR = 'signal-wifi-4-bar',
    SIGNAL_WIFI_4_BAR_LOCK = 'signal-wifi-4-bar-lock',
    SIGNAL_WIFI_OFF = 'signal-wifi-off',
    SIM_CARD = 'sim-card',
    SIM_CARD_ALERT = 'sim-card-alert',
    SINGLE_BED = 'single-bed',
    SKIP_NEXT = 'skip-next',
    SKIP_PREVIOUS = 'skip-previous',
    SLIDESHOW = 'slideshow',
    SLOW_MOTION_VIDEO = 'slow-motion-video',
    SMART_BUTTON = 'smart-button',
    SMARTPHONE = 'smartphone',
    SMOKE_FREE = 'smoke-free',
    SMOKING_ROOMS = 'smoking-rooms',
    SMS = 'sms',
    SMS_FAILED = 'sms-failed',
    SNIPPET_FOLDER = 'snippet-folder',
    SNOOZE = 'snooze',
    SOAP = 'soap',
    SORT = 'sort',
    SORT_BY_ALPHA = 'sort-by-alpha',
    SOURCE = 'source',
    SOUTH = 'south',
    SOUTH_EAST = 'south-east',
    SOUTH_WEST = 'south-west',
    SPA = 'spa',
    SPACE_BAR = 'space-bar',
    SPEAKER = 'speaker',
    SPEAKER_GROUP = 'speaker-group',
    SPEAKER_NOTES = 'speaker-notes',
    SPEAKER_NOTES_OFF = 'speaker-notes-off',
    SPEAKER_PHONE = 'speaker-phone',
    SPEED = 'speed',
    SPELLCHECK = 'spellcheck',
    SPORTS = 'sports',
    SPORTS_BAR = 'sports-bar',
    SPORTS_BASEBALL = 'sports-baseball',
    SPORTS_BASKETBALL = 'sports-basketball',
    SPORTS_CRICKET = 'sports-cricket',
    SPORTS_ESPORTS = 'sports-esports',
    SPORTS_FOOTBALL = 'sports-football',
    SPORTS_GOLF = 'sports-golf',
    SPORTS_HANDBALL = 'sports-handball',
    SPORTS_HOCKEY = 'sports-hockey',
    SPORTS_KABADDI = 'sports-kabaddi',
    SPORTS_MMA = 'sports-mma',
    SPORTS_MOTORSPORTS = 'sports-motorsports',
    SPORTS_RUGBY = 'sports-rugby',
    SPORTS_SOCCER = 'sports-soccer',
    SPORTS_TENNIS = 'sports-tennis',
    SPORTS_VOLLEYBALL = 'sports-volleyball',
    SQUARE_FOOT = 'square-foot',
    STACKED_BAR_CHART = 'stacked-bar-chart',
    STACKED_LINE_CHART = 'stacked-line-chart',
    STAIRS = 'stairs',
    STAR = 'star',
    STAR_BORDER = 'star-border',
    STAR_HALF = 'star-half',
    STAR_OUTLINE = 'star-outline',
    STAR_RATE = 'star-rate',
    STARS = 'stars',
    STAY_CURRENT_LANDSCAPE = 'stay-current-landscape',
    STAY_CURRENT_PORTRAIT = 'stay-current-portrait',
    STAY_PRIMARY_LANDSCAPE = 'stay-primary-landscape',
    STAY_PRIMARY_PORTRAIT = 'stay-primary-portrait',
    STICKY_NOTE_2 = 'sticky-note-2',
    STOP = 'stop',
    STOP_CIRCLE = 'stop-circle',
    STOP_SCREEN_SHARE = 'stop-screen-share',
    STORAGE = 'storage',
    STORE = 'store',
    STORE_MALL_DIRECTORY = 'store-mall-directory',
    STOREFRONT = 'storefront',
    STRAIGHTEN = 'straighten',
    STREAM = 'stream',
    STREETVIEW = 'streetview',
    STRIKETHROUGH_S = 'strikethrough-s',
    STROLLER = 'stroller',
    STYLE = 'style',
    SUBDIRECTORY_ARROW_LEFT = 'subdirectory-arrow-left',
    SUBDIRECTORY_ARROW_RIGHT = 'subdirectory-arrow-right',
    SUBJECT = 'subject',
    SUBSCRIPT = 'subscript',
    SUBSCRIPTIONS = 'subscriptions',
    SUBTITLES = 'subtitles',
    SUBTITLES_OFF = 'subtitles-off',
    SUBWAY = 'subway',
    SUPERSCRIPT = 'superscript',
    SUPERVISED_USER_CIRCLE = 'supervised-user-circle',
    SUPERVISOR_ACCOUNT = 'supervisor-account',
    SUPPORT = 'support',
    SUPPORT_AGENT = 'support-agent',
    SURROUND_SOUND = 'surround-sound',
    SWAP_CALLS = 'swap-calls',
    SWAP_HORIZ = 'swap-horiz',
    SWAP_HORIZONTAL_CIRCLE = 'swap-horizontal-circle',
    SWAP_VERT = 'swap-vert',
    SWAP_VERT_CIRCLE = 'swap-vert-circle',
    SWAP_VERTICAL_CIRCLE = 'swap-vertical-circle',
    SWIPE = 'swipe',
    SWITCH_ACCOUNT = 'switch-account',
    SWITCH_CAMERA = 'switch-camera',
    SWITCH_LEFT = 'switch-left',
    SWITCH_RIGHT = 'switch-right',
    SWITCH_VIDEO = 'switch-video',
    SYNC = 'sync',
    SYNC_ALT = 'sync-alt',
    SYNC_DISABLED = 'sync-disabled',
    SYNC_PROBLEM = 'sync-problem',
    SYSTEM_UPDATE = 'system-update',
    SYSTEM_UPDATE_ALT = 'system-update-alt',
    SYSTEM_UPDATE_TV = 'system-update-tv',
    TAB = 'tab',
    TAB_UNSELECTED = 'tab-unselected',
    TABLE_CHART = 'table-chart',
    TABLE_ROWS = 'table-rows',
    TABLE_VIEW = 'table-view',
    TABLET = 'tablet',
    TABLET_ANDROID = 'tablet-android',
    TABLET_MAC = 'tablet-mac',
    TAG = 'tag',
    TAG_FACES = 'tag-faces',
    TAKEOUT_DINING = 'takeout-dining',
    TAP_AND_PLAY = 'tap-and-play',
    TAPAS = 'tapas',
    TAXI_ALERT = 'taxi-alert',
    TERRAIN = 'terrain',
    TEXT_FIELDS = 'text-fields',
    TEXT_FORMAT = 'text-format',
    TEXT_ROTATE_UP = 'text-rotate-up',
    TEXT_ROTATE_VERTICAL = 'text-rotate-vertical',
    TEXT_ROTATION_ANGLEDOWN = 'text-rotation-angledown',
    TEXT_ROTATION_ANGLEUP = 'text-rotation-angleup',
    TEXT_ROTATION_DOWN = 'text-rotation-down',
    TEXT_ROTATION_NONE = 'text-rotation-none',
    TEXT_SNIPPET = 'text-snippet',
    TEXTSMS = 'textsms',
    TEXTURE = 'texture',
    THEATER_COMEDY = 'theater-comedy',
    THEATERS = 'theaters',
    THUMB_DOWN = 'thumb-down',
    THUMB_DOWN_ALT = 'thumb-down-alt',
    THUMB_DOWN_OFF_ALT = 'thumb-down-off-alt',
    THUMB_UP = 'thumb-up',
    THUMB_UP_ALT = 'thumb-up-alt',
    THUMB_UP_OFF_ALT = 'thumb-up-off-alt',
    THUMBS_UP_DOWN = 'thumbs-up-down',
    TIME_TO_LEAVE = 'time-to-leave',
    TIMELAPSE = 'timelapse',
    TIMELINE = 'timeline',
    TIMER = 'timer',
    TIMER_10 = 'timer-10',
    TIMER_3 = 'timer-3',
    TIMER_OFF = 'timer-off',
    TITLE = 'title',
    TOC = 'toc',
    TODAY = 'today',
    TOGGLE_OFF = 'toggle-off',
    TOGGLE_ON = 'toggle-on',
    TOLL = 'toll',
    TONALITY = 'tonality',
    TOPIC = 'topic',
    TOUCH_APP = 'touch-app',
    TOUR = 'tour',
    TOYS = 'toys',
    TRACK_CHANGES = 'track-changes',
    TRAFFIC = 'traffic',
    TRAIN = 'train',
    TRAM = 'tram',
    TRANSFER_WITHIN_A_STATION = 'transfer-within-a-station',
    TRANSFORM = 'transform',
    TRANSIT_ENTEREXIT = 'transit-enterexit',
    TRANSLATE = 'translate',
    TRENDING_DOWN = 'trending-down',
    TRENDING_FLAT = 'trending-flat',
    TRENDING_NEUTRAL = 'trending-neutral',
    TRENDING_UP = 'trending-up',
    TRIP_ORIGIN = 'trip-origin',
    TTY = 'tty',
    TUNE = 'tune',
    TURNED_IN = 'turned-in',
    TURNED_IN_NOT = 'turned-in-not',
    TV = 'tv',
    TV_OFF = 'tv-off',
    TWO_WHEELER = 'two-wheeler',
    UMBRELLA = 'umbrella',
    UNARCHIVE = 'unarchive',
    UNDO = 'undo',
    UNFOLD_LESS = 'unfold-less',
    UNFOLD_MORE = 'unfold-more',
    UNPUBLISHED = 'unpublished',
    UNSUBSCRIBE = 'unsubscribe',
    UPDATE = 'update',
    UPDATE_DISABLED = 'update-disabled',
    UPGRADE = 'upgrade',
    UPLOAD_FILE = 'upload-file',
    USB = 'usb',
    VERIFIED = 'verified',
    VERIFIED_USER = 'verified-user',
    VERTICAL_ALIGN_BOTTOM = 'vertical-align-bottom',
    VERTICAL_ALIGN_CENTER = 'vertical-align-center',
    VERTICAL_ALIGN_TOP = 'vertical-align-top',
    VERTICAL_DISTRIBUTE = 'vertical-distribute',
    VERTICAL_SPLIT = 'vertical-split',
    VIBRATION = 'vibration',
    VIDEO_CALL = 'video-call',
    VIDEO_COLLECTION = 'video-collection',
    VIDEO_LABEL = 'video-label',
    VIDEO_LIBRARY = 'video-library',
    VIDEO_SETTINGS = 'video-settings',
    VIDEOCAM = 'videocam',
    VIDEOCAM_OFF = 'videocam-off',
    VIDEOGAME_ASSET = 'videogame-asset',
    VIEW_AGENDA = 'view-agenda',
    VIEW_ARRAY = 'view-array',
    VIEW_CAROUSEL = 'view-carousel',
    VIEW_COLUMN = 'view-column',
    VIEW_COMFORTABLE = 'view-comfortable',
    VIEW_COMFY = 'view-comfy',
    VIEW_COMPACT = 'view-compact',
    VIEW_DAY = 'view-day',
    VIEW_HEADLINE = 'view-headline',
    VIEW_IN_AR = 'view-in-ar',
    VIEW_LIST = 'view-list',
    VIEW_MODULE = 'view-module',
    VIEW_QUILT = 'view-quilt',
    VIEW_SIDEBAR = 'view-sidebar',
    VIEW_STREAM = 'view-stream',
    VIEW_WEEK = 'view-week',
    VIGNETTE = 'vignette',
    VISIBILITY = 'visibility',
    VISIBILITY_OFF = 'visibility-off',
    VOICE_CHAT = 'voice-chat',
    VOICE_OVER_OFF = 'voice-over-off',
    VOICEMAIL = 'voicemail',
    VOLUME_DOWN = 'volume-down',
    VOLUME_MUTE = 'volume-mute',
    VOLUME_OFF = 'volume-off',
    VOLUME_UP = 'volume-up',
    VOLUNTEER_ACTIVISM = 'volunteer-activism',
    VPN_KEY = 'vpn-key',
    VPN_LOCK = 'vpn-lock',
    WALLET_GIFTCARD = 'wallet-giftcard',
    WALLET_MEMBERSHIP = 'wallet-membership',
    WALLET_TRAVEL = 'wallet-travel',
    WALLPAPER = 'wallpaper',
    WARNING = 'warning',
    WASH = 'wash',
    WATCH = 'watch',
    WATCH_LATER = 'watch-later',
    WATER_DAMAGE = 'water-damage',
    WATERFALL_CHART = 'waterfall-chart',
    WAVES = 'waves',
    WB_AUTO = 'wb-auto',
    WB_CLOUDY = 'wb-cloudy',
    WB_INCANDESCENT = 'wb-incandescent',
    WB_IRIDESCENT = 'wb-iridescent',
    WB_SHADE = 'wb-shade',
    WB_SUNNY = 'wb-sunny',
    WB_TWIGHLIGHT = 'wb-twighlight',
    WC = 'wc',
    WEB = 'web',
    WEB_ASSET = 'web-asset',
    WEEKEND = 'weekend',
    WEST = 'west',
    WHATSHOT = 'whatshot',
    WHEELCHAIR_PICKUP = 'wheelchair-pickup',
    WHERE_TO_VOTE = 'where-to-vote',
    WIDGETS = 'widgets',
    WIFI = 'wifi',
    WIFI_CALLING = 'wifi-calling',
    WIFI_LOCK = 'wifi-lock',
    WIFI_OFF = 'wifi-off',
    WIFI_PROTECTED_SETUP = 'wifi-protected-setup',
    WIFI_TETHERING = 'wifi-tethering',
    WINE_BAR = 'wine-bar',
    WORK = 'work',
    WORK_OFF = 'work-off',
    WORK_OUTLINE = 'work-outline',
    WORKSPACES_FILLED = 'workspaces-filled',
    WORKSPACES_OUTLINE = 'workspaces-outline',
    WRAP_TEXT = 'wrap-text',
    WRONG_LOCATION = 'wrong-location',
    WYSIWYG = 'wysiwyg',
    YOUTUBE_SEARCHED_FOR = 'youtube-searched-for',
    ZOOM_IN = 'zoom-in',
    ZOOM_OUT = 'zoom-out',
    ZOOM_OUT_MAP = 'zoom-out-map'
}

export enum type2 {
    NEWS = 'NEWS',
    CONTENT = 'CONTENT',
    LINK = 'LINK',
    CUSTOMIZED_PAGE = 'CUSTOMIZED_PAGE',
    SCHEDULE = 'SCHEDULE',
    MY_SCHEDULE = 'MY_SCHEDULE',
    FLOORPLAN = 'FLOORPLAN',
    SEARCH = 'SEARCH',
    NOTES = 'NOTES',
    POLL = 'POLL',
    NOW = 'NOW',
    SPONSORS = 'SPONSORS',
    SETTINGS = 'SETTINGS',
    PEOPLE = 'PEOPLE'
}

export type UpdateMenuItemDto = {
    title?: string;
    icon?: '360' | '10k' | '10mp' | '11mp' | '12mp' | '13mp' | '14mp' | '15mp' | '16mp' | '17mp' | '18mp' | '19mp' | '1k' | '1k-plus' | '20mp' | '21mp' | '22mp' | '23mp' | '24mp' | '2k' | '2k-plus' | '2mp' | '3d-rotation' | '3k' | '3k-plus' | '3mp' | '4k' | '4k-plus' | '4mp' | '5g' | '5k' | '5k-plus' | '5mp' | '6-ft-apart' | '6k' | '6k-plus' | '6mp' | '7k' | '7k-plus' | '7mp' | '8k' | '8k-plus' | '8mp' | '9k' | '9k-plus' | '9mp' | 'ac-unit' | 'access-alarm' | 'access-alarms' | 'access-time' | 'accessibility' | 'accessibility-new' | 'accessible' | 'accessible-forward' | 'account-balance' | 'account-balance-wallet' | 'account-box' | 'account-circle' | 'account-tree' | 'ad-units' | 'adb' | 'add' | 'add-a-photo' | 'add-alarm' | 'add-alert' | 'add-box' | 'add-business' | 'add-call' | 'add-chart' | 'add-circle' | 'add-circle-outline' | 'add-comment' | 'add-ic-call' | 'add-link' | 'add-location' | 'add-location-alt' | 'add-moderator' | 'add-photo-alternate' | 'add-road' | 'add-shopping-cart' | 'add-task' | 'add-to-drive' | 'add-to-home-screen' | 'add-to-photos' | 'add-to-queue' | 'addchart' | 'adjust' | 'admin-panel-settings' | 'agriculture' | 'airline-seat-flat' | 'airline-seat-flat-angled' | 'airline-seat-individual-suite' | 'airline-seat-legroom-extra' | 'airline-seat-legroom-normal' | 'airline-seat-legroom-reduced' | 'airline-seat-recline-extra' | 'airline-seat-recline-normal' | 'airplanemode-active' | 'airplanemode-inactive' | 'airplanemode-off' | 'airplanemode-on' | 'airplay' | 'airport-shuttle' | 'alarm' | 'alarm-add' | 'alarm-off' | 'alarm-on' | 'album' | 'align-horizontal-center' | 'align-horizontal-left' | 'align-horizontal-right' | 'align-vertical-bottom' | 'align-vertical-center' | 'align-vertical-top' | 'all-inbox' | 'all-inclusive' | 'all-out' | 'alt-route' | 'alternate-email' | 'amp-stories' | 'analytics' | 'anchor' | 'android' | 'animation' | 'announcement' | 'apartment' | 'api' | 'app-blocking' | 'app-registration' | 'app-settings-alt' | 'approval' | 'apps' | 'architecture' | 'archive' | 'arrow-back' | 'arrow-back-ios' | 'arrow-circle-down' | 'arrow-circle-up' | 'arrow-downward' | 'arrow-drop-down' | 'arrow-drop-down-circle' | 'arrow-drop-up' | 'arrow-forward' | 'arrow-forward-ios' | 'arrow-left' | 'arrow-right' | 'arrow-right-alt' | 'arrow-upward' | 'art-track' | 'article' | 'aspect-ratio' | 'assessment' | 'assignment' | 'assignment-ind' | 'assignment-late' | 'assignment-return' | 'assignment-returned' | 'assignment-turned-in' | 'assistant' | 'assistant-direction' | 'assistant-navigation' | 'assistant-photo' | 'atm' | 'attach-email' | 'attach-file' | 'attach-money' | 'attachment' | 'attractions' | 'audiotrack' | 'auto-awesome' | 'auto-awesome-mosaic' | 'auto-awesome-motion' | 'auto-delete' | 'auto-fix-high' | 'auto-fix-normal' | 'auto-fix-off' | 'auto-stories' | 'autorenew' | 'av-timer' | 'baby-changing-station' | 'backpack' | 'backspace' | 'backup' | 'backup-table' | 'badge' | 'bakery-dining' | 'ballot' | 'bar-chart' | 'batch-prediction' | 'bathtub' | 'battery-alert' | 'battery-charging-full' | 'battery-full' | 'battery-std' | 'battery-unknown' | 'beach-access' | 'bedtime' | 'beenhere' | 'bento' | 'bike-scooter' | 'biotech' | 'block' | 'block-flipped' | 'bluetooth' | 'bluetooth-audio' | 'bluetooth-connected' | 'bluetooth-disabled' | 'bluetooth-searching' | 'blur-circular' | 'blur-linear' | 'blur-off' | 'blur-on' | 'bolt' | 'book' | 'book-online' | 'bookmark' | 'bookmark-border' | 'bookmark-outline' | 'bookmarks' | 'border-all' | 'border-bottom' | 'border-clear' | 'border-color' | 'border-horizontal' | 'border-inner' | 'border-left' | 'border-outer' | 'border-right' | 'border-style' | 'border-top' | 'border-vertical' | 'branding-watermark' | 'breakfast-dining' | 'brightness-1' | 'brightness-2' | 'brightness-3' | 'brightness-4' | 'brightness-5' | 'brightness-6' | 'brightness-7' | 'brightness-auto' | 'brightness-high' | 'brightness-low' | 'brightness-medium' | 'broken-image' | 'browser-not-supported' | 'brunch-dining' | 'brush' | 'bubble-chart' | 'bug-report' | 'build' | 'build-circle' | 'burst-mode' | 'bus-alert' | 'business' | 'business-center' | 'cached' | 'cake' | 'calculate' | 'calendar-today' | 'calendar-view-day' | 'call' | 'call-end' | 'call-made' | 'call-merge' | 'call-missed' | 'call-missed-outgoing' | 'call-received' | 'call-split' | 'call-to-action' | 'camera' | 'camera-alt' | 'camera-enhance' | 'camera-front' | 'camera-rear' | 'camera-roll' | 'campaign' | 'cancel' | 'cancel-presentation' | 'cancel-schedule-send' | 'car-rental' | 'car-repair' | 'card-giftcard' | 'card-membership' | 'card-travel' | 'carpenter' | 'cases' | 'casino' | 'cast' | 'cast-connected' | 'cast-for-education' | 'category' | 'celebration' | 'cell-wifi' | 'center-focus-strong' | 'center-focus-weak' | 'change-history' | 'charging-station' | 'chat' | 'chat-bubble' | 'chat-bubble-outline' | 'check' | 'check-box' | 'check-box-outline-blank' | 'check-circle' | 'check-circle-outline' | 'checkroom' | 'chevron-left' | 'chevron-right' | 'child-care' | 'child-friendly' | 'chrome-reader-mode' | 'circle' | 'circle-notifications' | 'class' | 'clean-hands' | 'cleaning-services' | 'clear' | 'clear-all' | 'close' | 'close-fullscreen' | 'closed-caption' | 'closed-caption-disabled' | 'closed-caption-off' | 'cloud' | 'cloud-circle' | 'cloud-done' | 'cloud-download' | 'cloud-off' | 'cloud-queue' | 'cloud-upload' | 'code' | 'collections' | 'collections-bookmark' | 'color-lens' | 'colorize' | 'comment' | 'comment-bank' | 'commute' | 'compare' | 'compare-arrows' | 'compass-calibration' | 'compress' | 'computer' | 'confirmation-num' | 'confirmation-number' | 'connect-without-contact' | 'connected-tv' | 'construction' | 'contact-mail' | 'contact-page' | 'contact-phone' | 'contact-support' | 'contactless' | 'contacts' | 'content-copy' | 'content-cut' | 'content-paste' | 'control-camera' | 'control-point' | 'control-point-duplicate' | 'copyright' | 'coronavirus' | 'corporate-fare' | 'countertops' | 'create' | 'create-new-folder' | 'credit-card' | 'crop' | 'crop-16-9' | 'crop-3-2' | 'crop-5-4' | 'crop-7-5' | 'crop-din' | 'crop-free' | 'crop-landscape' | 'crop-original' | 'crop-portrait' | 'crop-rotate' | 'crop-square' | 'dangerous' | 'dashboard' | 'dashboard-customize' | 'data-usage' | 'date-range' | 'deck' | 'dehaze' | 'delete' | 'delete-forever' | 'delete-outline' | 'delete-sweep' | 'delivery-dining' | 'departure-board' | 'description' | 'design-services' | 'desktop-access-disabled' | 'desktop-mac' | 'desktop-windows' | 'details' | 'developer-board' | 'developer-mode' | 'device-hub' | 'device-thermostat' | 'device-unknown' | 'devices' | 'devices-other' | 'dialer-sip' | 'dialpad' | 'dinner-dining' | 'directions' | 'directions-bike' | 'directions-boat' | 'directions-bus' | 'directions-car' | 'directions-ferry' | 'directions-off' | 'directions-railway' | 'directions-run' | 'directions-subway' | 'directions-train' | 'directions-transit' | 'directions-walk' | 'dirty-lens' | 'disabled-by-default' | 'disc-full' | 'dnd-forwardslash' | 'dns' | 'do-not-disturb' | 'do-not-disturb-alt' | 'do-not-disturb-off' | 'do-not-disturb-on' | 'do-not-step' | 'do-not-touch' | 'dock' | 'domain' | 'domain-disabled' | 'domain-verification' | 'done' | 'done-all' | 'done-outline' | 'donut-large' | 'donut-small' | 'double-arrow' | 'drafts' | 'drag-handle' | 'drag-indicator' | 'drive-eta' | 'drive-file-move' | 'drive-file-move-outline' | 'drive-file-rename-outline' | 'drive-folder-upload' | 'dry' | 'dry-cleaning' | 'duo' | 'dvr' | 'dynamic-feed' | 'dynamic-form' | 'east' | 'eco' | 'edit' | 'edit-attributes' | 'edit-location' | 'edit-off' | 'edit-road' | 'eject' | 'elderly' | 'electric-bike' | 'electric-car' | 'electric-moped' | 'electric-rickshaw' | 'electric-scooter' | 'electrical-services' | 'elevator' | 'email' | 'emoji-emotions' | 'emoji-events' | 'emoji-flags' | 'emoji-food-beverage' | 'emoji-nature' | 'emoji-objects' | 'emoji-people' | 'emoji-symbols' | 'emoji-transportation' | 'engineering' | 'enhance-photo-translate' | 'enhanced-encryption' | 'equalizer' | 'error' | 'error-outline' | 'escalator' | 'escalator-warning' | 'euro' | 'euro-symbol' | 'ev-station' | 'event' | 'event-available' | 'event-busy' | 'event-note' | 'event-seat' | 'exit-to-app' | 'expand' | 'expand-less' | 'expand-more' | 'explicit' | 'explore' | 'explore-off' | 'exposure' | 'exposure-minus-1' | 'exposure-minus-2' | 'exposure-neg-1' | 'exposure-neg-2' | 'exposure-plus-1' | 'exposure-plus-2' | 'exposure-zero' | 'extension' | 'face' | 'face-retouching-natural' | 'facebook' | 'fact-check' | 'family-restroom' | 'fast-forward' | 'fast-rewind' | 'fastfood' | 'favorite' | 'favorite-border' | 'favorite-outline' | 'featured-play-list' | 'featured-video' | 'feedback' | 'fence' | 'festival' | 'fiber-dvr' | 'fiber-manual-record' | 'fiber-new' | 'fiber-pin' | 'fiber-smart-record' | 'file-copy' | 'file-download' | 'file-download-done' | 'file-present' | 'file-upload' | 'filter' | 'filter-1' | 'filter-2' | 'filter-3' | 'filter-4' | 'filter-5' | 'filter-6' | 'filter-7' | 'filter-8' | 'filter-9' | 'filter-9-plus' | 'filter-alt' | 'filter-b-and-w' | 'filter-center-focus' | 'filter-drama' | 'filter-frames' | 'filter-hdr' | 'filter-list' | 'filter-list-alt' | 'filter-none' | 'filter-tilt-shift' | 'filter-vintage' | 'find-in-page' | 'find-replace' | 'fingerprint' | 'fire-extinguisher' | 'fire-hydrant' | 'fireplace' | 'first-page' | 'fit-screen' | 'fitness-center' | 'flag' | 'flaky' | 'flare' | 'flash-auto' | 'flash-off' | 'flash-on' | 'flight' | 'flight-land' | 'flight-takeoff' | 'flip' | 'flip-camera-android' | 'flip-camera-ios' | 'flip-to-back' | 'flip-to-front' | 'folder' | 'folder-open' | 'folder-shared' | 'folder-special' | 'follow-the-signs' | 'font-download' | 'food-bank' | 'format-align-center' | 'format-align-justify' | 'format-align-left' | 'format-align-right' | 'format-bold' | 'format-clear' | 'format-color-fill' | 'format-color-reset' | 'format-color-text' | 'format-indent-decrease' | 'format-indent-increase' | 'format-italic' | 'format-line-spacing' | 'format-list-bulleted' | 'format-list-numbered' | 'format-list-numbered-rtl' | 'format-paint' | 'format-quote' | 'format-shapes' | 'format-size' | 'format-strikethrough' | 'format-textdirection-l-to-r' | 'format-textdirection-r-to-l' | 'format-underline' | 'format-underlined' | 'forum' | 'forward' | 'forward-10' | 'forward-30' | 'forward-5' | 'forward-to-inbox' | 'foundation' | 'free-breakfast' | 'fullscreen' | 'fullscreen-exit' | 'functions' | 'g-translate' | 'gamepad' | 'games' | 'gavel' | 'gesture' | 'get-app' | 'gif' | 'goat' | 'golf-course' | 'gps-fixed' | 'gps-not-fixed' | 'gps-off' | 'grade' | 'gradient' | 'grading' | 'grain' | 'graphic-eq' | 'grass' | 'grid-off' | 'grid-on' | 'grid-view' | 'group' | 'group-add' | 'group-work' | 'groups' | 'hail' | 'handyman' | 'hardware' | 'hd' | 'hdr-enhanced-select' | 'hdr-off' | 'hdr-on' | 'hdr-strong' | 'hdr-weak' | 'headset' | 'headset-mic' | 'headset-off' | 'healing' | 'hearing' | 'hearing-disabled' | 'height' | 'help' | 'help-center' | 'help-outline' | 'high-quality' | 'highlight' | 'highlight-alt' | 'highlight-off' | 'highlight-remove' | 'history' | 'history-edu' | 'history-toggle-off' | 'home' | 'home-filled' | 'home-repair-service' | 'home-work' | 'horizontal-distribute' | 'horizontal-rule' | 'horizontal-split' | 'hot-tub' | 'hotel' | 'hourglass-bottom' | 'hourglass-disabled' | 'hourglass-empty' | 'hourglass-full' | 'hourglass-top' | 'house' | 'house-siding' | 'how-to-reg' | 'how-to-vote' | 'http' | 'https' | 'hvac' | 'icecream' | 'image' | 'image-aspect-ratio' | 'image-not-supported' | 'image-search' | 'imagesearch-roller' | 'import-contacts' | 'import-export' | 'important-devices' | 'inbox' | 'indeterminate-check-box' | 'info' | 'info-outline' | 'input' | 'insert-chart' | 'insert-chart-outlined' | 'insert-comment' | 'insert-drive-file' | 'insert-emoticon' | 'insert-invitation' | 'insert-link' | 'insert-photo' | 'insights' | 'integration-instructions' | 'inventory' | 'invert-colors' | 'invert-colors-off' | 'invert-colors-on' | 'ios-share' | 'iso' | 'keyboard' | 'keyboard-arrow-down' | 'keyboard-arrow-left' | 'keyboard-arrow-right' | 'keyboard-arrow-up' | 'keyboard-backspace' | 'keyboard-capslock' | 'keyboard-control' | 'keyboard-hide' | 'keyboard-return' | 'keyboard-tab' | 'keyboard-voice' | 'king-bed' | 'kitchen' | 'label' | 'label-important' | 'label-important-outline' | 'label-off' | 'label-outline' | 'landscape' | 'language' | 'laptop' | 'laptop-chromebook' | 'laptop-mac' | 'laptop-windows' | 'last-page' | 'launch' | 'layers' | 'layers-clear' | 'leaderboard' | 'leak-add' | 'leak-remove' | 'leave-bags-at-home' | 'legend-toggle' | 'lens' | 'library-add' | 'library-add-check' | 'library-books' | 'library-music' | 'lightbulb' | 'lightbulb-outline' | 'line-style' | 'line-weight' | 'linear-scale' | 'link' | 'link-off' | 'linked-camera' | 'liquor' | 'list' | 'list-alt' | 'live-help' | 'live-tv' | 'local-activity' | 'local-airport' | 'local-atm' | 'local-attraction' | 'local-bar' | 'local-cafe' | 'local-car-wash' | 'local-convenience-store' | 'local-dining' | 'local-drink' | 'local-fire-department' | 'local-florist' | 'local-gas-station' | 'local-grocery-store' | 'local-hospital' | 'local-hotel' | 'local-laundry-service' | 'local-library' | 'local-mall' | 'local-movies' | 'local-offer' | 'local-parking' | 'local-pharmacy' | 'local-phone' | 'local-pizza' | 'local-play' | 'local-police' | 'local-post-office' | 'local-print-shop' | 'local-printshop' | 'local-restaurant' | 'local-see' | 'local-shipping' | 'local-taxi' | 'location-city' | 'location-disabled' | 'location-history' | 'location-off' | 'location-on' | 'location-pin' | 'location-searching' | 'lock' | 'lock-clock' | 'lock-open' | 'lock-outline' | 'login' | 'logout' | 'looks' | 'looks-3' | 'looks-4' | 'looks-5' | 'looks-6' | 'looks-one' | 'looks-two' | 'loop' | 'loupe' | 'low-priority' | 'loyalty' | 'luggage' | 'lunch-dining' | 'mail' | 'mail-outline' | 'map' | 'maps-ugc' | 'margin' | 'mark-as-unread' | 'mark-chat-read' | 'mark-chat-unread' | 'mark-email-read' | 'mark-email-unread' | 'markunread' | 'markunread-mailbox' | 'masks' | 'maximize' | 'mediation' | 'medical-services' | 'meeting-room' | 'memory' | 'menu' | 'menu-book' | 'menu-open' | 'merge-type' | 'message' | 'messenger' | 'messenger-outline' | 'mic' | 'mic-external-off' | 'mic-external-on' | 'mic-none' | 'mic-off' | 'microwave' | 'military-tech' | 'minimize' | 'miscellaneous-services' | 'missed-video-call' | 'mms' | 'mobile-friendly' | 'mobile-off' | 'mobile-screen-share' | 'mode-comment' | 'mode-edit' | 'model-training' | 'monetization-on' | 'money' | 'money-off' | 'monitor' | 'monochrome-photos' | 'mood' | 'mood-bad' | 'moped' | 'more' | 'more-horiz' | 'more-time' | 'more-vert' | 'motion-photos-off' | 'motion-photos-on' | 'motion-photos-pause' | 'motion-photos-paused' | 'motorcycle' | 'mouse' | 'move-to-inbox' | 'movie' | 'movie-creation' | 'movie-filter' | 'mp' | 'multiline-chart' | 'multiple-stop' | 'multitrack-audio' | 'museum' | 'music-note' | 'music-off' | 'music-video' | 'my-library-add' | 'my-library-books' | 'my-library-music' | 'my-location' | 'nat' | 'nature' | 'nature-people' | 'navigate-before' | 'navigate-next' | 'navigation' | 'near-me' | 'near-me-disabled' | 'network-cell' | 'network-check' | 'network-locked' | 'network-wifi' | 'new-releases' | 'next-plan' | 'next-week' | 'nfc' | 'night-shelter' | 'nightlife' | 'nightlight-round' | 'nights-stay' | 'no-backpack' | 'no-cell' | 'no-drinks' | 'no-encryption' | 'no-flash' | 'no-food' | 'no-luggage' | 'no-meals' | 'no-meals-ouline' | 'no-meeting-room' | 'no-photography' | 'no-sim' | 'no-stroller' | 'no-transfer' | 'north' | 'north-east' | 'north-west' | 'not-accessible' | 'not-interested' | 'not-listed-location' | 'not-started' | 'note' | 'note-add' | 'notes' | 'notification-important' | 'notifications' | 'notifications-active' | 'notifications-none' | 'notifications-off' | 'notifications-on' | 'notifications-paused' | 'now-wallpaper' | 'now-widgets' | 'offline-bolt' | 'offline-pin' | 'offline-share' | 'ondemand-video' | 'online-prediction' | 'opacity' | 'open-in-browser' | 'open-in-full' | 'open-in-new' | 'open-with' | 'outbond' | 'outbox' | 'outdoor-grill' | 'outgoing-mail' | 'outlet' | 'outlined-flag' | 'padding' | 'pages' | 'pageview' | 'palette' | 'pan-tool' | 'panorama' | 'panorama-fish-eye' | 'panorama-fisheye' | 'panorama-horizontal' | 'panorama-horizontal-select' | 'panorama-photosphere' | 'panorama-photosphere-select' | 'panorama-vertical' | 'panorama-vertical-select' | 'panorama-wide-angle' | 'panorama-wide-angle-select' | 'park' | 'party-mode' | 'pause' | 'pause-circle-filled' | 'pause-circle-outline' | 'pause-presentation' | 'payment' | 'payments' | 'pedal-bike' | 'pending' | 'pending-actions' | 'people' | 'people-alt' | 'people-outline' | 'perm-camera-mic' | 'perm-contact-cal' | 'perm-contact-calendar' | 'perm-data-setting' | 'perm-device-info' | 'perm-device-information' | 'perm-identity' | 'perm-media' | 'perm-phone-msg' | 'perm-scan-wifi' | 'person' | 'person-add' | 'person-add-alt' | 'person-add-alt-1' | 'person-add-disabled' | 'person-outline' | 'person-pin' | 'person-pin-circle' | 'person-remove' | 'person-remove-alt-1' | 'person-search' | 'personal-video' | 'pest-control' | 'pest-control-rodent' | 'pets' | 'phone' | 'phone-android' | 'phone-bluetooth-speaker' | 'phone-callback' | 'phone-disabled' | 'phone-enabled' | 'phone-forwarded' | 'phone-in-talk' | 'phone-iphone' | 'phone-locked' | 'phone-missed' | 'phone-paused' | 'phonelink' | 'phonelink-erase' | 'phonelink-lock' | 'phonelink-off' | 'phonelink-ring' | 'phonelink-setup' | 'photo' | 'photo-album' | 'photo-camera' | 'photo-camera-back' | 'photo-camera-front' | 'photo-filter' | 'photo-library' | 'photo-size-select-actual' | 'photo-size-select-large' | 'photo-size-select-small' | 'picture-as-pdf' | 'picture-in-picture' | 'picture-in-picture-alt' | 'pie-chart' | 'pie-chart-outlined' | 'pin-drop' | 'pivot-table-chart' | 'place' | 'plagiarism' | 'play-arrow' | 'play-circle-fill' | 'play-circle-filled' | 'play-circle-outline' | 'play-disabled' | 'play-for-work' | 'playlist-add' | 'playlist-add-check' | 'playlist-play' | 'plumbing' | 'plus-one' | 'point-of-sale' | 'policy' | 'poll' | 'polymer' | 'pool' | 'portable-wifi-off' | 'portrait' | 'post-add' | 'power' | 'power-input' | 'power-off' | 'power-settings-new' | 'pregnant-woman' | 'present-to-all' | 'preview' | 'print' | 'print-disabled' | 'priority-high' | 'privacy-tip' | 'psychology' | 'public' | 'public-off' | 'publish' | 'published-with-changes' | 'push-pin' | 'qr-code' | 'qr-code-2' | 'qr-code-scanner' | 'query-builder' | 'question-answer' | 'queue' | 'queue-music' | 'queue-play-next' | 'quick-contacts-dialer' | 'quick-contacts-mail' | 'quickreply' | 'radio' | 'radio-button-checked' | 'radio-button-off' | 'radio-button-on' | 'radio-button-unchecked' | 'railway-alert' | 'ramen-dining' | 'rate-review' | 'read-more' | 'receipt' | 'receipt-long' | 'recent-actors' | 'recommend' | 'record-voice-over' | 'redeem' | 'redo' | 'reduce-capacity' | 'refresh' | 'remove' | 'remove-circle' | 'remove-circle-outline' | 'remove-done' | 'remove-from-queue' | 'remove-moderator' | 'remove-red-eye' | 'remove-shopping-cart' | 'reorder' | 'repeat' | 'repeat-on' | 'repeat-one' | 'repeat-one-on' | 'replay' | 'replay-10' | 'replay-30' | 'replay-5' | 'replay-circle-filled' | 'reply' | 'reply-all' | 'report' | 'report-off' | 'report-problem' | 'request-page' | 'request-quote' | 'reset-tv' | 'restaurant' | 'restaurant-menu' | 'restore' | 'restore-from-trash' | 'restore-page' | 'rice-bowl' | 'ring-volume' | 'roofing' | 'room' | 'room-preferences' | 'room-service' | 'rotate-90-degrees-ccw' | 'rotate-left' | 'rotate-right' | 'rounded-corner' | 'router' | 'rowing' | 'rss-feed' | 'rtt' | 'rule' | 'rule-folder' | 'run-circle' | 'rv-hookup' | 'sanitizer' | 'satellite' | 'save' | 'save-alt' | 'saved-search' | 'scanner' | 'scatter-plot' | 'schedule' | 'schedule-send' | 'school' | 'science' | 'score' | 'screen-lock-landscape' | 'screen-lock-portrait' | 'screen-lock-rotation' | 'screen-rotation' | 'screen-search-desktop' | 'screen-share' | 'sd' | 'sd-card' | 'sd-storage' | 'search' | 'search-off' | 'security' | 'segment' | 'select-all' | 'self-improvement' | 'send' | 'send-and-archive' | 'send-to-mobile' | 'sensor-door' | 'sensor-window' | 'sentiment-dissatisfied' | 'sentiment-neutral' | 'sentiment-satisfied' | 'sentiment-satisfied-alt' | 'sentiment-very-dissatisfied' | 'sentiment-very-satisfied' | 'set-meal' | 'settings' | 'settings-applications' | 'settings-backup-restore' | 'settings-bluetooth' | 'settings-brightness' | 'settings-cell' | 'settings-display' | 'settings-ethernet' | 'settings-input-antenna' | 'settings-input-component' | 'settings-input-composite' | 'settings-input-hdmi' | 'settings-input-svideo' | 'settings-overscan' | 'settings-phone' | 'settings-power' | 'settings-remote' | 'settings-system-daydream' | 'settings-voice' | 'share' | 'shield' | 'shop' | 'shop-two' | 'shopping-bag' | 'shopping-basket' | 'shopping-cart' | 'short-text' | 'show-chart' | 'shuffle' | 'shuffle-on' | 'shutter-speed' | 'sick' | 'signal-cellular-0-bar' | 'signal-cellular-4-bar' | 'signal-cellular-alt' | 'signal-cellular-connected-no-internet-4-bar' | 'signal-cellular-no-sim' | 'signal-cellular-null' | 'signal-cellular-off' | 'signal-wifi-0-bar' | 'signal-wifi-4-bar' | 'signal-wifi-4-bar-lock' | 'signal-wifi-off' | 'sim-card' | 'sim-card-alert' | 'single-bed' | 'skip-next' | 'skip-previous' | 'slideshow' | 'slow-motion-video' | 'smart-button' | 'smartphone' | 'smoke-free' | 'smoking-rooms' | 'sms' | 'sms-failed' | 'snippet-folder' | 'snooze' | 'soap' | 'sort' | 'sort-by-alpha' | 'source' | 'south' | 'south-east' | 'south-west' | 'spa' | 'space-bar' | 'speaker' | 'speaker-group' | 'speaker-notes' | 'speaker-notes-off' | 'speaker-phone' | 'speed' | 'spellcheck' | 'sports' | 'sports-bar' | 'sports-baseball' | 'sports-basketball' | 'sports-cricket' | 'sports-esports' | 'sports-football' | 'sports-golf' | 'sports-handball' | 'sports-hockey' | 'sports-kabaddi' | 'sports-mma' | 'sports-motorsports' | 'sports-rugby' | 'sports-soccer' | 'sports-tennis' | 'sports-volleyball' | 'square-foot' | 'stacked-bar-chart' | 'stacked-line-chart' | 'stairs' | 'star' | 'star-border' | 'star-half' | 'star-outline' | 'star-rate' | 'stars' | 'stay-current-landscape' | 'stay-current-portrait' | 'stay-primary-landscape' | 'stay-primary-portrait' | 'sticky-note-2' | 'stop' | 'stop-circle' | 'stop-screen-share' | 'storage' | 'store' | 'store-mall-directory' | 'storefront' | 'straighten' | 'stream' | 'streetview' | 'strikethrough-s' | 'stroller' | 'style' | 'subdirectory-arrow-left' | 'subdirectory-arrow-right' | 'subject' | 'subscript' | 'subscriptions' | 'subtitles' | 'subtitles-off' | 'subway' | 'superscript' | 'supervised-user-circle' | 'supervisor-account' | 'support' | 'support-agent' | 'surround-sound' | 'swap-calls' | 'swap-horiz' | 'swap-horizontal-circle' | 'swap-vert' | 'swap-vert-circle' | 'swap-vertical-circle' | 'swipe' | 'switch-account' | 'switch-camera' | 'switch-left' | 'switch-right' | 'switch-video' | 'sync' | 'sync-alt' | 'sync-disabled' | 'sync-problem' | 'system-update' | 'system-update-alt' | 'system-update-tv' | 'tab' | 'tab-unselected' | 'table-chart' | 'table-rows' | 'table-view' | 'tablet' | 'tablet-android' | 'tablet-mac' | 'tag' | 'tag-faces' | 'takeout-dining' | 'tap-and-play' | 'tapas' | 'taxi-alert' | 'terrain' | 'text-fields' | 'text-format' | 'text-rotate-up' | 'text-rotate-vertical' | 'text-rotation-angledown' | 'text-rotation-angleup' | 'text-rotation-down' | 'text-rotation-none' | 'text-snippet' | 'textsms' | 'texture' | 'theater-comedy' | 'theaters' | 'thumb-down' | 'thumb-down-alt' | 'thumb-down-off-alt' | 'thumb-up' | 'thumb-up-alt' | 'thumb-up-off-alt' | 'thumbs-up-down' | 'time-to-leave' | 'timelapse' | 'timeline' | 'timer' | 'timer-10' | 'timer-3' | 'timer-off' | 'title' | 'toc' | 'today' | 'toggle-off' | 'toggle-on' | 'toll' | 'tonality' | 'topic' | 'touch-app' | 'tour' | 'toys' | 'track-changes' | 'traffic' | 'train' | 'tram' | 'transfer-within-a-station' | 'transform' | 'transit-enterexit' | 'translate' | 'trending-down' | 'trending-flat' | 'trending-neutral' | 'trending-up' | 'trip-origin' | 'tty' | 'tune' | 'turned-in' | 'turned-in-not' | 'tv' | 'tv-off' | 'two-wheeler' | 'umbrella' | 'unarchive' | 'undo' | 'unfold-less' | 'unfold-more' | 'unpublished' | 'unsubscribe' | 'update' | 'update-disabled' | 'upgrade' | 'upload-file' | 'usb' | 'verified' | 'verified-user' | 'vertical-align-bottom' | 'vertical-align-center' | 'vertical-align-top' | 'vertical-distribute' | 'vertical-split' | 'vibration' | 'video-call' | 'video-collection' | 'video-label' | 'video-library' | 'video-settings' | 'videocam' | 'videocam-off' | 'videogame-asset' | 'view-agenda' | 'view-array' | 'view-carousel' | 'view-column' | 'view-comfortable' | 'view-comfy' | 'view-compact' | 'view-day' | 'view-headline' | 'view-in-ar' | 'view-list' | 'view-module' | 'view-quilt' | 'view-sidebar' | 'view-stream' | 'view-week' | 'vignette' | 'visibility' | 'visibility-off' | 'voice-chat' | 'voice-over-off' | 'voicemail' | 'volume-down' | 'volume-mute' | 'volume-off' | 'volume-up' | 'volunteer-activism' | 'vpn-key' | 'vpn-lock' | 'wallet-giftcard' | 'wallet-membership' | 'wallet-travel' | 'wallpaper' | 'warning' | 'wash' | 'watch' | 'watch-later' | 'water-damage' | 'waterfall-chart' | 'waves' | 'wb-auto' | 'wb-cloudy' | 'wb-incandescent' | 'wb-iridescent' | 'wb-shade' | 'wb-sunny' | 'wb-twighlight' | 'wc' | 'web' | 'web-asset' | 'weekend' | 'west' | 'whatshot' | 'wheelchair-pickup' | 'where-to-vote' | 'widgets' | 'wifi' | 'wifi-calling' | 'wifi-lock' | 'wifi-off' | 'wifi-protected-setup' | 'wifi-tethering' | 'wine-bar' | 'work' | 'work-off' | 'work-outline' | 'workspaces-filled' | 'workspaces-outline' | 'wrap-text' | 'wrong-location' | 'wysiwyg' | 'youtube-searched-for' | 'zoom-in' | 'zoom-out' | 'zoom-out-map' | null;
    type?: 'NEWS' | 'CONTENT' | 'LINK' | 'CUSTOMIZED_PAGE' | 'SCHEDULE' | 'MY_SCHEDULE' | 'FLOORPLAN' | 'SEARCH' | 'NOTES' | 'POLL' | 'NOW' | 'SPONSORS' | 'SETTINGS' | 'PEOPLE';
    data?: string | null;
    visibility?: string;
};

export type Topic = {
    id: string;
    name: string | null;
};

export type Section = {
    id: string;
    name: string | null;
    name2: string | null;
    name3: string | null;
    shortName: string | null;
    description: string | null;
    from: number | null;
    to: number | null;
    date: string | null;
    dateEnd: string | null;
    startTime: string | null;
    endTime: string | null;
    chairLabel: string | null;
    chairFree: string | null;
    discussant: string | null;
    room: string;
    roomRank: number;
    showBreakAfter: boolean;
    breakName: string | null;
    breakTime: number | null;
    showDiscussionAfter: boolean;
    discussionName: string | null;
    discussionTime: number | null;
    poster: boolean;
    sectionGroup: string | null;
    track: string | null;
};

export type Abstract = {
    id: string;
    sectionId: string;
    abstractNum: number;
    title: string | null;
    presenter: string | null;
    nameHead: string | null;
    instHead: string | null;
    description: string | null;
    content: string | null;
    keyword: string | null;
    rank: number;
    from: number | null;
    to: number | null;
    date: string | null;
    dateEnd: string | null;
    lectName: string | null;
    lectNumber: string | null;
    lectTime: number | null;
    discussionTime: number | null;
    uploadedFileName: string | null;
    track: string | null;
    forum: boolean;
    infoBefore: string | null;
    infoAfter: string | null;
    videoId: string | null;
    room: string | null;
    topic: (Topic) | null;
    section: Section;
};

export type Break = {
    id: string;
    name: string | null;
    fromDate: string;
    toDate: string;
    fromTime: string;
    toTime: string;
    from: number;
    to: number;
};

export enum AdvertisementType {
    SPLASH_SCREEN = 'SPLASH_SCREEN'
}

export type Advertisement = {
    id: string;
    congressId: string;
    name: string;
    type: AdvertisementType;
    imageId: string;
    createdAt: string;
    updatedAt: string;
    image: File;
};

export type CongressData = {
    menu: Array<Menu>;
    abstract: Array<Abstract>;
    section: Array<Section>;
    break: Array<Break>;
    advertisement: Array<Advertisement>;
};

export type CreateCongressDto = {
    congId: number;
    name: string;
    from: string;
    to: string;
    timezone: string;
    status: boolean;
    hidden: boolean;
    color: string;
    textColor: string;
    source: string;
    coverId?: string;
};

export type MigrationResult = {
    sessions: number;
    abstracts: number;
    breaks: number;
    topics: number;
    duration: number;
};

export type UpdateCongressDto = {
    congId?: number;
    isAbstractQaEnabled?: boolean;
    isAbstractRatingEnabled?: boolean;
    isSectionRatingEnabled?: boolean;
    isSectionQaEnabled?: boolean;
    sectionLeftTemplate?: string;
    sectionRightTemplate?: string;
    abstractLeftTemplate?: string;
    abstractRightTemplate?: string;
    displayPosterDay?: boolean;
    displaySectionGroup?: boolean;
    name?: string;
    from?: string;
    to?: string;
    timezone?: string;
    status?: boolean;
    hidden?: boolean;
    color?: string;
    textColor?: string;
    source?: string;
    coverId?: string;
};

export type DeleteCongressDto = {
    /**
     * Congress name to confirm deletion
     */
    name: string;
};

export type MigrationLog = {
    id: string;
    congId: string;
    isSuccess: boolean;
    error: string;
    createdAt: string;
    updatedAt: string;
};

export type AbstractListItem = {
    id: string;
    sectionId: string;
    abstractNum: number;
    title: string | null;
    presenter: string | null;
    nameHead: string | null;
    instHead: string | null;
    description: string | null;
    content: string | null;
    keyword: string | null;
    rank: number;
    from: number | null;
    to: number | null;
    date: string | null;
    dateEnd: string | null;
    lectName: string | null;
    lectNumber: string | null;
    lectTime: number | null;
    discussionTime: number | null;
    uploadedFileName: string | null;
    track: string | null;
    forum: boolean;
    infoBefore: string | null;
    infoAfter: string | null;
    videoId: string | null;
    room: string | null;
    topic: (Topic) | null;
    section: Section;
    /**
     * Average rating (1–5)
     */
    rating?: number;
    /**
     * Number of ratings
     */
    ratingCount?: number;
};

export type AbstractListPagination = {
    items: Array<AbstractListItem>;
    count: number;
};

export type SectionListItem = {
    id: string;
    name: string | null;
    name2: string | null;
    name3: string | null;
    shortName: string | null;
    description: string | null;
    from: number | null;
    to: number | null;
    date: string | null;
    dateEnd: string | null;
    startTime: string | null;
    endTime: string | null;
    chairLabel: string | null;
    chairFree: string | null;
    discussant: string | null;
    room: string;
    roomRank: number;
    showBreakAfter: boolean;
    breakName: string | null;
    breakTime: number | null;
    showDiscussionAfter: boolean;
    discussionName: string | null;
    discussionTime: number | null;
    poster: boolean;
    sectionGroup: string | null;
    track: string | null;
    /**
     * Average rating (1–5)
     */
    rating?: number;
    /**
     * Number of ratings
     */
    ratingCount?: number;
};

export type SectionListPagination = {
    items: Array<SectionListItem>;
    count: number;
};

export type BreakPagination = {
    items: Array<Break>;
    count: number;
};

export type CreateAdvertisementDto = {
    congressId: string;
    name: string;
    type: AdvertisementType;
    imageId: string;
};

export type UpdateAdvertisementDto = {
    congressId?: string;
    name?: string;
    type?: AdvertisementType;
    imageId?: string;
};

export type News = {
    id: string;
    title: string;
    excerpt: string;
    data: string;
    sendNotificationAfter: string | null;
    createdAt: string;
};

export type CreateNewsDto = {
    title: string;
    excerpt: string;
    data: string;
    sendNotificationAfter?: string;
};

export type UpsertDeviceDto = {
    deviceId: string;
    congressId: string;
    name?: string;
};

export type Device = {
    deviceId: string;
    congressId: string;
    name: string;
};

export type NotificationStatusResponse = {
    status: 'ENABLED' | 'DISABLED';
};

export enum status {
    ENABLED = 'ENABLED',
    DISABLED = 'DISABLED'
}

export type NotificationAnalytics = {
    totalDevices: number;
    totalNotificationsSent: number;
    totalNotificationsFailed: number;
    totalNotificationsDelivered: number;
};

export type CreateQuestionDto = {
    question: string;
    congressId: string;
    author: string;
    eventType: 'SECTION' | 'ABSTRACT';
    contentId: string;
};

export enum eventType {
    SECTION = 'SECTION',
    ABSTRACT = 'ABSTRACT'
}

export type QA = {
    id: string;
    congressId: string;
    sectionId: string;
    abstractId: string;
    isFlagged: boolean;
    isAnswered: boolean;
    author: string;
    question: string;
    createdAt: string;
    updatedAt: string;
};

export type UpdateQuestionDto = {
    isAnswered?: boolean;
    isFlagged?: boolean;
};

export type CreateRatingDto = {
    contentId: string;
    rating: number;
};

export type Rating = {
    id: string;
    contentId: string;
    rating: number;
};

export type CongressRef = {
    id: string;
    congId: number;
    name: string;
};

export type UserWithCongress = {
    casm_id: number;
    part_id: number;
    regstatus: string;
    regcode: string;
    lastname: string;
    firstname: string;
    title: string;
    rank: string;
    company: string;
    department: string;
    city: string;
    country: string;
    phone: string;
    email: string;
    lang: string;
    badge_category: string;
    allowscan: string;
    'checked-in': string | null;
    votes: number;
    congress: CongressRef;
};

export type PushNotificationMessageBody = {
    congressId: string | null;
    menuId: string;
    menuItemId?: string;
};

export type GetAllSocietyDataResponse = SocietyData;

export type ProxySentryResponse = unknown;

export type GetAllData = {
    type?: 'ICON' | 'IMG' | 'DOC' | 'QUILL_IMAGE';
};

export type GetAllResponse = Array<File>;

export type UploadFileData = {
    formData: {
        type: 'ICON' | 'IMG' | 'DOC' | 'QUILL_IMAGE';
        file: (Blob | File);
    };
};

export type UploadFileResponse = File;

export type GetAllMenuForCongressIdData = {
    congressId?: string;
};

export type GetAllMenuForCongressIdResponse = Array<Menu>;

export type CreateMenuData = {
    requestBody: CreateMenuDto;
};

export type CreateMenuResponse = Menu;

export type UpdateMenuItemsOrderData = {
    menuId: string;
    requestBody: UpdateMenuItemsOrderDto;
};

export type UpdateMenuItemsOrderResponse = unknown;

export type UpdateData = {
    menuId: string;
    requestBody: UpdateMenuDto;
};

export type UpdateResponse = Menu;

export type DeleteMenuData = {
    menuId: string;
};

export type DeleteMenuResponse = void;

export type CreateMenuItemData = {
    menuId: string;
    requestBody: CreateMenuItemDto;
};

export type CreateMenuItemResponse = MenuItem;

export type UpdateMenuItemData = {
    menuItemId: string;
    requestBody: UpdateMenuItemDto;
};

export type UpdateMenuItemResponse = MenuItem;

export type DeleteMenuItemData = {
    menuItemId: string;
};

export type DeleteMenuItemResponse = void;

export type GetCongressesResponse = Array<Congress>;

export type CreateCongressData = {
    requestBody: CreateCongressDto;
};

export type CreateCongressResponse = Congress;

export type GetCongressByIdData = {
    congressId: string;
};

export type GetCongressByIdResponse = CongressData;

export type UpdateCongressMetadataData = {
    congressId: string;
    requestBody: UpdateCongressDto;
};

export type UpdateCongressMetadataResponse = Congress;

export type DeleteCongressData = {
    congressId: string;
    requestBody: DeleteCongressDto;
};

export type DeleteCongressResponse = void;

export type GetCongressMetadataData = {
    congressId: string;
};

export type GetCongressMetadataResponse = Congress;

export type DuplicateCongressData = {
    congressId: string;
};

export type DuplicateCongressResponse = Congress;

export type MigrationCongressData = {
    congressId: string;
};

export type MigrationCongressResponse = MigrationResult;

export type GetMigrationLogsData = {
    congressId: string;
};

export type GetMigrationLogsResponse = Array<MigrationLog>;

export type GetAbstractsData = {
    congressId: string;
    limit?: number;
    offset?: number;
    search?: string;
    sortBy?: 'rating' | 'ratingCount' | 'createdAt';
    sortOrder?: 'asc' | 'desc';
};

export type GetAbstractsResponse = AbstractListPagination;

export type GetAbstractByIdData = {
    id: string;
};

export type GetAbstractByIdResponse = Abstract;

export type GetSectionsData = {
    congressId: string;
    limit?: number;
    offset?: number;
    search?: string;
    sortBy?: 'rating' | 'ratingCount' | 'from';
    sortOrder?: 'asc' | 'desc';
};

export type GetSectionsResponse = SectionListPagination;

export type GetSectionByIdData = {
    id: string;
};

export type GetSectionByIdResponse = Section;

export type GetBreaksData = {
    congressId: string;
    limit?: number;
    offset?: number;
    search?: string;
};

export type GetBreaksResponse = BreakPagination;

export type CreateAdvertisementData = {
    requestBody: CreateAdvertisementDto;
};

export type CreateAdvertisementResponse = Advertisement;

export type GetAdvertisementByIdData = {
    id: string;
};

export type GetAdvertisementByIdResponse = Advertisement;

export type UpdateAdvertisementData = {
    id: string;
    requestBody: UpdateAdvertisementDto;
};

export type UpdateAdvertisementResponse = Advertisement;

export type DeleteAdvertisementData = {
    id: string;
};

export type DeleteAdvertisementResponse = unknown;

export type GetAdvertisementsByCongressIdData = {
    congressId: string;
};

export type GetAdvertisementsByCongressIdResponse = Array<Advertisement>;

export type GetAllNewsData = {
    congressId?: string;
    includeFuture?: boolean;
};

export type GetAllNewsResponse = Array<News>;

export type CreateNewsData = {
    congressId?: string;
    includeFuture?: boolean;
    requestBody: CreateNewsDto;
};

export type CreateNewsResponse = News;

export type GetNewsMenuItemData = {
    congressId?: string;
};

export type GetNewsMenuItemResponse = unknown;

export type DeleteNewsData = {
    id: string;
};

export type DeleteNewsResponse = void;

export type UpsertDeviceData = {
    requestBody: UpsertDeviceDto;
};

export type UpsertDeviceResponse = Device;

export type GetDeviceData = {
    congressId: string;
    deviceId: string;
};

export type GetDeviceResponse = NotificationStatusResponse;

export type GetAvailableDevicesData = {
    congressId: string;
};

export type GetAvailableDevicesResponse = NotificationAnalytics;

export type CreateQuestionData = {
    requestBody: CreateQuestionDto;
};

export type CreateQuestionResponse = QA;

export type FetchQuestionsData = {
    congressId: string;
    contentId: string;
    eventType: 'SECTION' | 'ABSTRACT';
};

export type FetchQuestionsResponse = Array<QA>;

export type UpdateQuestionData = {
    id: string;
    requestBody: UpdateQuestionDto;
};

export type UpdateQuestionResponse = unknown;

export type CreateRatingData = {
    requestBody: CreateRatingDto;
};

export type CreateRatingResponse = Rating;

export type FetchUserData = {
    userId: string;
};

export type FetchUserResponse = UserWithCongress;

export type $OpenApiTs = {
    '/society': {
        get: {
            res: {
                200: SocietyData;
            };
        };
    };
    '/monitoring': {
        post: {
            res: {
                201: unknown;
            };
        };
    };
    '/file-upload/files': {
        get: {
            req: GetAllData;
            res: {
                200: Array<File>;
            };
        };
    };
    '/file-upload/upload': {
        post: {
            req: UploadFileData;
            res: {
                /**
                 * The image has been successfully uploaded.
                 */
                201: File;
            };
        };
    };
    '/menu': {
        get: {
            req: GetAllMenuForCongressIdData;
            res: {
                200: Array<Menu>;
            };
        };
        post: {
            req: CreateMenuData;
            res: {
                201: Menu;
            };
        };
    };
    '/menu/{menuId}/order': {
        patch: {
            req: UpdateMenuItemsOrderData;
            res: {
                200: unknown;
            };
        };
    };
    '/menu/{menuId}': {
        patch: {
            req: UpdateData;
            res: {
                200: Menu;
            };
        };
        delete: {
            req: DeleteMenuData;
            res: {
                204: void;
            };
        };
    };
    '/menu/{menuId}/menu-item': {
        post: {
            req: CreateMenuItemData;
            res: {
                201: MenuItem;
            };
        };
    };
    '/menu/menu-item/{menuItemId}': {
        patch: {
            req: UpdateMenuItemData;
            res: {
                200: MenuItem;
            };
        };
        delete: {
            req: DeleteMenuItemData;
            res: {
                204: void;
            };
        };
    };
    '/congresses': {
        get: {
            res: {
                200: Array<Congress>;
            };
        };
        post: {
            req: CreateCongressData;
            res: {
                201: Congress;
            };
        };
    };
    '/congresses/{congressId}': {
        get: {
            req: GetCongressByIdData;
            res: {
                200: CongressData;
            };
        };
        patch: {
            req: UpdateCongressMetadataData;
            res: {
                200: Congress;
            };
        };
        delete: {
            req: DeleteCongressData;
            res: {
                204: void;
            };
        };
    };
    '/congresses/{congressId}/metadata': {
        get: {
            req: GetCongressMetadataData;
            res: {
                200: Congress;
            };
        };
    };
    '/congresses/{congressId}/duplicate': {
        post: {
            req: DuplicateCongressData;
            res: {
                201: Congress;
            };
        };
    };
    '/congresses/{congressId}/migration': {
        post: {
            req: MigrationCongressData;
            res: {
                201: MigrationResult;
            };
        };
    };
    '/congresses/{congressId}/migration-logs': {
        get: {
            req: GetMigrationLogsData;
            res: {
                200: Array<MigrationLog>;
            };
        };
    };
    '/abstracts/{congressId}/all': {
        get: {
            req: GetAbstractsData;
            res: {
                200: AbstractListPagination;
            };
        };
    };
    '/abstracts/{id}': {
        get: {
            req: GetAbstractByIdData;
            res: {
                200: Abstract;
            };
        };
    };
    '/sections/{congressId}/all': {
        get: {
            req: GetSectionsData;
            res: {
                200: SectionListPagination;
            };
        };
    };
    '/sections/{id}': {
        get: {
            req: GetSectionByIdData;
            res: {
                200: Section;
            };
        };
    };
    '/breaks/{congressId}': {
        get: {
            req: GetBreaksData;
            res: {
                200: BreakPagination;
            };
        };
    };
    '/advertisements': {
        post: {
            req: CreateAdvertisementData;
            res: {
                201: Advertisement;
            };
        };
    };
    '/advertisements/{id}': {
        get: {
            req: GetAdvertisementByIdData;
            res: {
                /**
                 * Advertisement found
                 */
                200: Advertisement;
            };
        };
        patch: {
            req: UpdateAdvertisementData;
            res: {
                /**
                 * Advertisement updated successfully
                 */
                200: Advertisement;
            };
        };
        delete: {
            req: DeleteAdvertisementData;
            res: {
                /**
                 * Advertisement deleted successfully
                 */
                200: unknown;
            };
        };
    };
    '/advertisements/congress/{congressId}': {
        get: {
            req: GetAdvertisementsByCongressIdData;
            res: {
                /**
                 * List of advertisements for congress
                 */
                200: Array<Advertisement>;
            };
        };
    };
    '/news': {
        get: {
            req: GetAllNewsData;
            res: {
                200: Array<News>;
            };
        };
        post: {
            req: CreateNewsData;
            res: {
                201: News;
            };
        };
    };
    '/news/menu-item': {
        get: {
            req: GetNewsMenuItemData;
            res: {
                200: unknown;
            };
        };
    };
    '/news/{id}': {
        delete: {
            req: DeleteNewsData;
            res: {
                204: void;
            };
        };
    };
    '/notifications': {
        post: {
            req: UpsertDeviceData;
            res: {
                201: Device;
            };
        };
    };
    '/notifications/{deviceId}': {
        get: {
            req: GetDeviceData;
            res: {
                200: NotificationStatusResponse;
            };
        };
    };
    '/notifications/analytics/{congressId}': {
        get: {
            req: GetAvailableDevicesData;
            res: {
                200: NotificationAnalytics;
            };
        };
    };
    '/qa': {
        post: {
            req: CreateQuestionData;
            res: {
                201: QA;
            };
        };
        get: {
            req: FetchQuestionsData;
            res: {
                200: Array<QA>;
            };
        };
    };
    '/qa/{id}': {
        post: {
            req: UpdateQuestionData;
            res: {
                201: unknown;
            };
        };
    };
    '/rating': {
        post: {
            req: CreateRatingData;
            res: {
                201: Rating;
            };
        };
    };
    '/user/{userId}': {
        get: {
            req: FetchUserData;
            res: {
                200: UserWithCongress;
            };
        };
    };
};